
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("jt4qp", function(module, exports) {
$parcel$export(module.exports, "getObjectIconUrl", () => $d30a0c7f02527705$export$bcf275804417edda);
const $d30a0c7f02527705$export$bcf275804417edda = (details)=>{
    if (details !== null && details !== void 0 && details.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};

});

parcelRegister("ihJP7", function(module, exports) {
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $463bcbb6ca231a2f$export$6c837641a9ab03cb);
const $463bcbb6ca231a2f$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';

});

parcelRegister("lwoVF", function(module, exports) {
$parcel$export(module.exports, "default", () => $92e94385c84954f6$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $ihJP7 = parcelRequire("ihJP7");
// This property enables the intersection observer to be run once the
// HTML element being observed is within `X` px of the target container it is
// being compared to. Since the default container is the `document`, we set this
// up to check once a Smart Link is within `X` px from the bottom of the viewport.
const $92e94385c84954f6$var$ROOT_MARGIN_VERTICAL = '360px';
const $92e94385c84954f6$var$useIntersectionObserver = ({ onIntersecting: onIntersectingCallback, onIntersection: onIntersectionCallback })=>{
    const ref = (0, $fc4bM.useRef)(null);
    const onIntersectingCallbackRef = (0, $fc4bM.useRef)(onIntersectingCallback);
    const onIntersectionCallbackRef = (0, $fc4bM.useRef)(onIntersectionCallback);
    (0, $fc4bM.useEffect)(()=>{
        onIntersectingCallbackRef.current = onIntersectingCallback;
        onIntersectionCallbackRef.current = onIntersectionCallback;
    }, [
        onIntersectingCallback,
        onIntersectionCallback
    ]);
    const onIntersection = (0, $fc4bM.useCallback)((entries, observer)=>{
        var _onIntersectionCallba;
        const isIntersecting = entries.some((entry)=>entry.isIntersecting);
        (_onIntersectionCallba = onIntersectionCallbackRef.current) === null || _onIntersectionCallba === void 0 || _onIntersectionCallba.call(onIntersectionCallbackRef, isIntersecting);
        if (isIntersecting) {
            var _onIntersectingCallba;
            (_onIntersectingCallba = onIntersectingCallbackRef.current) === null || _onIntersectingCallba === void 0 || _onIntersectingCallba.call(onIntersectingCallbackRef);
            observer.disconnect();
        }
    }, []);
    (0, $fc4bM.useEffect)(()=>{
        if (!(0, $ihJP7.isIntersectionObserverSupported)() || !ref.current) return;
        const intersectionObserver = new IntersectionObserver(onIntersection, {
            rootMargin: `${$92e94385c84954f6$var$ROOT_MARGIN_VERTICAL} 0px ${$92e94385c84954f6$var$ROOT_MARGIN_VERTICAL} 0px`
        });
        intersectionObserver.observe(ref.current);
        return ()=>intersectionObserver.disconnect();
    }, [
        ref,
        onIntersection
    ]);
    return ref;
};
var $92e94385c84954f6$export$2e2bcd8739ae039 = $92e94385c84954f6$var$useIntersectionObserver;

});

parcelRegister("1gjag", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkSeenEvent", () => $afac4059399fa209$export$c721b83ca330cb86);

var $fc4bM = parcelRequire("fc4bM");

var $fVrlX = parcelRequire("fVrlX");

var $dqLu4 = parcelRequire("dqLu4");

var $c2F9z = parcelRequire("c2F9z");
function $afac4059399fa209$export$c721b83ca330cb86({ appearance: appearance, children: children, id: id, ui: ui, url: url = '' }) {
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const { getByUrl: getByUrl } = (0, $dqLu4.useSmartLinkAnalyticsUtils)();
    const getAnalyticsProps = (0, $fc4bM.useCallback)(()=>{
        const isFlexibleUi = (0, $c2F9z.isFlexibleUiCard)(children, ui);
        const display = isFlexibleUi ? 'flexible' : appearance;
        return {
            display: display,
            id: id
        };
    }, [
        appearance,
        children,
        id,
        ui
    ]);
    const statusRef = (0, $fc4bM.useRef)();
    const analyticsPropsRef = (0, $fc4bM.useRef)(null);
    const hasIntersectedRef = (0, $fc4bM.useRef)(false);
    const hasFiredSeenRef = (0, $fc4bM.useRef)(false);
    (0, $fc4bM.useEffect)(()=>{
        analyticsPropsRef.current = getAnalyticsProps();
    }, [
        getAnalyticsProps
    ]);
    const maybeFireSeenEvent = (0, $fc4bM.useCallback)(()=>{
        if (!hasFiredSeenRef.current && hasIntersectedRef.current && statusRef.current === 'unauthorized') {
            const payload = getByUrl(url, analyticsPropsRef.current);
            fireEvent('ui.smartLink.seen', payload === null || payload === void 0 ? void 0 : payload.attributes);
            hasFiredSeenRef.current = true;
        }
    }, [
        fireEvent,
        getByUrl,
        url
    ]);
    const onIntersecting = (0, $fc4bM.useCallback)(()=>{
        if (hasIntersectedRef.current) return;
        hasIntersectedRef.current = true;
        maybeFireSeenEvent();
    }, [
        maybeFireSeenEvent
    ]);
    const onStatusSettled = (0, $fc4bM.useCallback)((status)=>{
        statusRef.current = status;
        maybeFireSeenEvent();
    }, [
        maybeFireSeenEvent
    ]);
    return (0, $fc4bM.useMemo)(()=>({
            onIntersecting: onIntersecting,
            onStatusSettled: onStatusSettled
        }), [
        onIntersecting,
        onStatusSettled
    ]);
}

});
parcelRegister("dqLu4", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkAnalyticsUtils", () => $ce820e9f7364da06$export$853798cf89e90693);

var $fc4bM = parcelRequire("fc4bM");

var $fnEFU = parcelRequire("fnEFU");

var $6Ki2B = parcelRequire("6Ki2B");

var $16FEv = parcelRequire("16FEv");
const $ce820e9f7364da06$export$853798cf89e90693 = ()=>{
    const { store: store } = (0, $fnEFU.useSmartLinkContext)();
    const getByUrl = (0, $fc4bM.useCallback)((url, props)=>{
        const state = store ? (0, $6Ki2B.getUrl)(store, url) : undefined;
        return (0, $16FEv.getSmartLinkAnalyticsContext)({
            display: props === null || props === void 0 ? void 0 : props.display,
            id: props === null || props === void 0 ? void 0 : props.id,
            response: state === null || state === void 0 ? void 0 : state.details,
            source: props === null || props === void 0 ? void 0 : props.source,
            status: state === null || state === void 0 ? void 0 : state.status,
            url: url,
            error: state === null || state === void 0 ? void 0 : state.error
        });
    }, [
        store
    ]);
    return (0, $fc4bM.useMemo)(()=>({
            getByUrl: getByUrl
        }), [
        getByUrl
    ]);
};

});


parcelRegister("8yWCk", function(module, exports) {
$parcel$export(module.exports, "default", () => $38c136c31d65b8f0$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
const $38c136c31d65b8f0$var$CardLoaderWrapper = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ appearance: appearance, children: children }, ref)=>{
    const Component = appearance === 'inline' ? 'span' : 'div';
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, {
        className: "loader-wrapper",
        ref: ref
    }, children));
});
var $38c136c31d65b8f0$export$2e2bcd8739ae039 = $38c136c31d65b8f0$var$CardLoaderWrapper;

});

parcelRegister("cHDa7", function(module, exports) {
$parcel$export(module.exports, "CardWithUrlContent", () => $ea70321911296f9d$export$7598f5d7c597dd32);
$parcel$export(module.exports, "CardWithUrl", () => $ea70321911296f9d$export$d4ee8167ac732647);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $kSVgB = parcelRequire("kSVgB");

var $fnEFU = parcelRequire("fnEFU");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $eCeLl = parcelRequire("eCeLl");

var $jQwFa = parcelRequire("jQwFa");

var $6ZxOX = parcelRequire("6ZxOX");

var $96gGh = parcelRequire("96gGh");

var $4TeS8 = parcelRequire("4TeS8");

var $h49UZ = parcelRequire("h49UZ");

var $jt4qp = parcelRequire("jt4qp");

var $1nf2I = parcelRequire("1nf2I");

var $jKScA = parcelRequire("jKScA");

var $9pwnX = parcelRequire("9pwnX");

var $iIrBK = parcelRequire("iIrBK");

var $jpYbX = parcelRequire("jpYbX");

var $jxH84 = parcelRequire("jxH84");

var $lwb5x = parcelRequire("lwb5x");

var $8K8sp = parcelRequire("8K8sp");

var $1JV8M = parcelRequire("1JV8M");

var $9VWuO = parcelRequire("9VWuO");

var $baiO5 = parcelRequire("baiO5");

var $7Wdq8 = parcelRequire("7Wdq8");

var $aNEya = parcelRequire("aNEya");

var $8yp28 = parcelRequire("8yp28");

var $6sD3Q = parcelRequire("6sD3Q");

var $c2F9z = parcelRequire("c2F9z");

var $bNNZ4 = parcelRequire("bNNZ4");

var $kTSf6 = parcelRequire("kTSf6");

var $9pmKt = parcelRequire("9pmKt");

var $6PbEY = parcelRequire("6PbEY");

var $8jRNm = parcelRequire("8jRNm");

var $8R7wn = parcelRequire("8R7wn");

var $8I0WZ = parcelRequire("8I0WZ");

var $6Sqna = parcelRequire("6Sqna");

var $jQkCW = parcelRequire("jQkCW");

var $eaXI0 = parcelRequire("eaXI0");

var $Xfogc = parcelRequire("Xfogc");

var $c6cgh = parcelRequire("c6cgh");
const $ea70321911296f9d$var$thirdPartyARIPrefix = 'ari:third-party';
function $ea70321911296f9d$var$Component({ id: id, url: url, title: title, isSelected: isSelected, isHovered: isHovered, frameStyle: frameStyle, platform: platform, onClick: onClick, appearance: appearance, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptionsProp, inheritDimensions: inheritDimensions, embedIframeRef: embedIframeRef, embedIframeUrlType: embedIframeUrlType, inlinePreloaderStyle: inlinePreloaderStyle, ui: ui, children: children, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, disablePreviewPanel: disablePreviewPanel, placeholderData: placeholderData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    let isFlexibleUi = (0, $fc4bM.useMemo)(()=>(0, $c2F9z.isFlexibleUiCard)(children, ui), [
        children,
        ui
    ]);
    const isEmbedOpenInNewTabEnabled = appearance === (0, $j9rqA.CardDisplay).Embed && (0, $bcN2K.isExperimentEnabled)('platform_editor_embed_open_in_new_tab');
    // Get state, actions for this card.
    // appearance is pre-resolved by the caller (loader.tsx for Card, ssr.tsx for CardSSR):
    // FlexibleCards are always passed appearance='block' when FG is on, so component.tsx
    // simply consumes whatever appearance it receives.
    const { state: state, actions: actions, config: config, renderers: renderers, error: error, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $jxH84.useSmartLink)(id, url, appearance);
    const { linkNavigation: linkNavigation } = (0, $fnEFU.useSmartLinkContext)();
    const resolveNavigation = (0, $dRkX9.fg)('confluence_ep_shim_macro_links_v2') && isFlexibleUi ? linkNavigation : undefined;
    const ari = (0, $h49UZ.getObjectAri)(state.details);
    const name = (0, $1nf2I.getObjectName)(state.details);
    const definitionId = (0, $6ZxOX.getDefinitionId)(state.details);
    const extensionKey = (0, $96gGh.getExtensionKey)(state.details);
    const resourceType = (0, $jKScA.getResourceType)(state.details);
    const services = (0, $9pwnX.getServices)(state.details);
    const thirdPartyARI = (0, $iIrBK.getThirdPartyARI)(state.details);
    const firstPartyIdentifier = (0, $4TeS8.getFirstPartyIdentifier)();
    const appendCrossProductAnalyticsParams = (0, $jpYbX.useSmartLinkCrossProductUrlWrapper)({
        details: state.details
    });
    const actionOptions = (0, $1JV8M.combineActionOptions)({
        actionOptions: actionOptionsProp,
        platform: platform
    });
    // TODO: [ZS] Add new experiment flag to determine if the Rovo Actions CTA should be shown
    const rovoActionsCtaShown = false;
    const fire3PClickEvent = (0, $eaXI0.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI);
    // Shared scope guard for all 3P-click handlers.
    const shouldFire3PClickEvent = thirdPartyARI && thirdPartyARI.startsWith($ea70321911296f9d$var$thirdPartyARIPrefix) && (0, $jQwFa.getClickUrl)(url, state.details) === url && fire3PClickEvent;
    const getDestinationUrl = (0, $fc4bM.useCallback)(()=>{
        // FIXME: destinationUrl should be rendered in the DOM anchor href instead of derived at click time
        const preferredUrl = (0, $jQwFa.getClickUrl)(url, state.details) ?? url;
        return appendCrossProductAnalyticsParams(preferredUrl) ?? preferredUrl;
    }, [
        appendCrossProductAnalyticsParams,
        state.details,
        url
    ]);
    const navigation = (0, $fc4bM.useMemo)(()=>resolveNavigation === null || resolveNavigation === void 0 ? void 0 : resolveNavigation(getDestinationUrl()), [
        getDestinationUrl,
        resolveNavigation
    ]);
    // Setup UI handlers.
    const handleClickWrapper = (0, $fc4bM.useCallback)((event)=>{
        const isEmbedDoubleClick = isEmbedOpenInNewTabEnabled && event.type === 'dblclick' && event.button === 0 && event.detail === 2 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
        // The title link's preceding clicks already navigate without a consumer callback.
        if (isEmbedDoubleClick && !onClick) {
            const clickedAnchor = event.target instanceof Element ? event.target.closest('a') : null;
            if (clickedAnchor && event.currentTarget.contains(clickedAnchor)) return;
        }
        const isModifierKeyPressed = (0, $9pmKt.isSpecialKey)(event) || (0, $bNNZ4.isSpecialClick)(event);
        fireEvent('ui.smartLink.clicked', {
            id: id,
            display: isFlexibleUi ? (0, $j9rqA.CardDisplay).Flexible : appearance,
            definitionId: definitionId ?? null,
            isModifierKeyPressed: isModifierKeyPressed
        });
        if (shouldFire3PClickEvent) // For questions or concerns about this event,
        // please reach out to the 3P Workflows Team via Slack in #help-3p-connector-workflow
        fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent();
        // FIXME: InlineCard, BlockCard and EmbedCard call event.preventDefault() internally
        // before the event bubbles up to this handler. This forces us to snapshot
        // event.defaultPrevented before calling onClick to detect whether the consumer
        // specifically prevented navigation. Ideally those components should not call
        // preventDefault so this workaround can be removed.
        const isEventDefaultPrevented = event.defaultPrevented;
        const canOpenPreviewPanel = !isModifierKeyPressed && ari && name && openPreviewPanel && (isPreviewPanelAvailable === null || isPreviewPanelAvailable === void 0 ? void 0 : isPreviewPanelAvailable({
            ari: ari
        })) && !disablePreviewPanel;
        // Preview panel takes priority over link navigation when available.
        if (canOpenPreviewPanel) {
            var _extractSmartLinkEmbe;
            event.preventDefault();
            event.stopPropagation();
            openPreviewPanel({
                url: url,
                ari: ari,
                name: name,
                iconUrl: (0, $jt4qp.getObjectIconUrl)(state.details),
                panelData: {
                    embedUrl: (0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (_extractSmartLinkEmbe = (0, $kSVgB.extractSmartLinkEmbed)(state.details)) === null || _extractSmartLinkEmbe === void 0 ? void 0 : _extractSmartLinkEmbe.src : undefined
                }
            });
            (0, $9VWuO.fireLinkClickedEvent)(createAnalyticsEvent)(event, {
                attributes: {
                    clickOutcome: 'previewPanel'
                }
            });
            return;
        }
        const destinationUrl = (resolveNavigation === null || resolveNavigation === void 0 ? void 0 : resolveNavigation(getDestinationUrl()).url) ?? getDestinationUrl();
        (0, $8jRNm.updateAnchorHref)(event, destinationUrl);
        // For FlexibleCard, read target from the clicked anchor element (e.g. _blank for links
        // rendered with explicit target). For classic cards, default to _self
        const { target: anchorTarget } = (0, $aNEya.getAnchorAttributesFromEvent)(event);
        let openInNewTab;
        let shouldOpenLink;
        if (isEmbedOpenInNewTabEnabled) {
            const isNewTabGesture = isEmbedDoubleClick || event.button === 0 && (event.metaKey || event.ctrlKey) || event.button === 1;
            openInNewTab = isNewTabGesture || (resolveNavigation ? event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1 : (0, $kTSf6.isSpecialEvent)(event));
            // Embed gestures navigate here even when the consumer handles ordinary clicks.
            shouldOpenLink = isFlexibleUi || !onClick || isNewTabGesture;
        } else {
            openInNewTab = resolveNavigation ? event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1 : (0, $kTSf6.isSpecialEvent)(event);
            shouldOpenLink = isFlexibleUi || !onClick;
        }
        const isInIframe = window.top !== window;
        const target = openInNewTab || isInIframe ? '_blank' : isFlexibleUi ? anchorTarget : '_self';
        onClick === null || onClick === void 0 || onClick(event, {
            url: url,
            destinationUrl: destinationUrl
        });
        // Check if the event is prevented via onClick callback
        const consumerPreventedNavigation = event.defaultPrevented && !isEventDefaultPrevented;
        // FlexibleCard's anchor is prevented from native navigation, so this handler always
        // opens the link for FlexibleCard unless the consumer's onClick called preventDefault.
        const doOpenLink = shouldOpenLink && !consumerPreventedNavigation;
        if (doOpenLink) {
            event.preventDefault();
            window.open(destinationUrl, target);
        }
        // Only set clickOutcome when this handler actually opened the link.
        // If a parent onClick handled navigation, fire a generic click event instead.
        (0, $9VWuO.fireLinkClickedEvent)(createAnalyticsEvent)(event, doOpenLink ? {
            attributes: {
                clickOutcome: target === '_blank' ? 'clickThroughNewTabOrWindow' : 'clickThrough'
            }
        } : undefined);
    }, [
        fireEvent,
        id,
        isFlexibleUi,
        isEmbedOpenInNewTabEnabled,
        appearance,
        definitionId,
        getDestinationUrl,
        resolveNavigation,
        onClick,
        url,
        state.details,
        ari,
        name,
        fire3PClickEvent,
        shouldFire3PClickEvent,
        isPreviewPanelAvailable,
        openPreviewPanel,
        createAnalyticsEvent,
        disablePreviewPanel
    ]);
    // Middle-click handler to trigger fire3PClickEvent on middle-clicks.
    // Scope is limited to 3P click analytics.
    const handleFrameAuxClick = (0, $fc4bM.useCallback)((event)=>{
        const destinationUrl = (resolveNavigation === null || resolveNavigation === void 0 ? void 0 : resolveNavigation(getDestinationUrl()).url) ?? getDestinationUrl();
        (0, $8jRNm.updateAnchorHref)(event, destinationUrl);
        // isAuxClick filters Windows right-clicks (button === 2) that also fire onAuxClick.
        if ((0, $6sD3Q.isAuxClick)(event) && shouldFire3PClickEvent) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isAuxClick: true
        });
    }, [
        fire3PClickEvent,
        getDestinationUrl,
        shouldFire3PClickEvent,
        resolveNavigation
    ]);
    // Right-click handler to trigger fire3PClickEvent on right-clicks.
    // Scope is limited to 3P click analytics.
    const handleFrameContextMenu = (0, $fc4bM.useCallback)((event)=>{
        const destinationUrl = (resolveNavigation === null || resolveNavigation === void 0 ? void 0 : resolveNavigation(getDestinationUrl()).url) ?? getDestinationUrl();
        (0, $8jRNm.updateAnchorHref)(event, destinationUrl);
        if (shouldFire3PClickEvent) fire3PClickEvent === null || fire3PClickEvent === void 0 || fire3PClickEvent({
            isContextMenu: true
        });
    }, [
        fire3PClickEvent,
        getDestinationUrl,
        shouldFire3PClickEvent,
        resolveNavigation
    ]);
    const { reload: reload } = actions;
    const handleAuthorize = (0, $fc4bM.useCallback)(()=>actions.authorize(appearance), [
        actions,
        appearance
    ]);
    const handleRetry = (0, $fc4bM.useCallback)(()=>{
        reload();
    }, [
        reload
    ]);
    const hasMounted = (0, $fc4bM.useRef)(false);
    const prevAppearance = (0, $fc4bM.useRef)(appearance);
    // When appearance changes from inline to non-inline on a mounted card
    // (e.g. direct consumer changes inline → block/embed), reload with the new appearance
    // so ORS can return the appropriate full data. We intentionally do NOT reload on
    // block → embed or embed → block transitions since both already have full ORS data.
    (0, $fc4bM.useEffect)(()=>{
        if (!hasMounted.current) {
            hasMounted.current = true;
            prevAppearance.current = appearance;
            return;
        }
        if (prevAppearance.current === 'inline' && appearance !== 'inline' && (0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization')) reload(appearance);
        prevAppearance.current = appearance;
    }, [
        appearance,
        reload
    ]);
    const handleInvoke = (0, $fc4bM.useCallback)((opts)=>actions.invoke(opts, appearance), [
        actions,
        appearance
    ]);
    const experimentMetaEventAttributes = (0, $c6cgh.default)({
        appearance: appearance,
        state: state
    });
    // NB: for each status change in a Smart Link, a performance mark is created.
    // Measures are sent relative to the first mark, matching what a user sees.
    (0, $fc4bM.useEffect)(()=>{
        (0, $6PbEY.mark)(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            var _state$error, _state$error2, _state$error3;
            (0, $7Wdq8.create)(id, state.status);
            if (state.status === 'resolved') {
                var _getMeasure;
                fireEvent('operational.smartLink.resolved', {
                    definitionId: definitionId ?? null,
                    duration: ((_getMeasure = (0, $8yp28.getMeasure)(id, state.status)) === null || _getMeasure === void 0 ? void 0 : _getMeasure.duration) ?? null
                });
            } else if (((_state$error = state.error) === null || _state$error === void 0 ? void 0 : _state$error.type) !== 'ResolveUnsupportedError' && ((_state$error2 = state.error) === null || _state$error2 === void 0 ? void 0 : _state$error2.type) !== 'UnsupportedError' && ((_state$error3 = state.error) === null || _state$error3 === void 0 ? void 0 : _state$error3.name) !== 'InvalidUrlError') fireEvent('operational.smartLink.unresolved', {
                definitionId: definitionId ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        appearance,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    // NB: once the smart-card has rendered into an end state, we capture
    // this as a successful render. These can be one of:
    // - the resolved state: when metadata is shown;
    // - the unresolved states: viz. forbidden, not_found, unauthorized, errored.
    (0, $fc4bM.useEffect)(()=>{
        if ((0, $lwb5x.isFinalState)(state.status)) {
            (0, $eCeLl.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
                extensionKey: extensionKey,
                display: isFlexibleUi ? 'flexible' : appearance
            });
            // UFO will disregard this if authentication experience has not yet been started
            (0, $eCeLl.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
                display: isFlexibleUi ? 'flexible' : appearance
            });
            fireEvent('ui.smartLink.renderSuccess', {
                display: isFlexibleUi ? 'flexible' : appearance,
                ...appearance === 'inline' && {
                    rovoActionsCtaShown: rovoActionsCtaShown
                },
                ...experimentMetaEventAttributes && {
                    experimentMeta: experimentMetaEventAttributes
                }
            });
        }
    }, [
        appearance,
        extensionKey,
        fireEvent,
        id,
        isFlexibleUi,
        rovoActionsCtaShown,
        state.status,
        experimentMetaEventAttributes
    ]);
    const onIframeDwell = (0, $fc4bM.useCallback)((dwellTime, dwellPercentVisible)=>{
        fireEvent('ui.smartLinkIframe.dwelled', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            dwellPercentVisible: dwellPercentVisible,
            dwellTime: dwellTime
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeFocus = (0, $fc4bM.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'focus'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseEnter = (0, $fc4bM.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseenter'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    const onIframeMouseLeave = (0, $fc4bM.useCallback)(()=>{
        fireEvent('ui.smartLinkIframe.focused', {
            id: id,
            definitionId: definitionId ?? null,
            display: isFlexibleUi ? 'flexible' : appearance,
            interactionType: 'mouseleave'
        });
    }, [
        id,
        appearance,
        definitionId,
        isFlexibleUi,
        fireEvent
    ]);
    if (isFlexibleUi) {
        let cardState = state;
        if (error) {
            if ((error === null || error === void 0 ? void 0 : error.name) === 'APIError') cardState = {
                status: 'errored'
            };
            else throw error;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6Sqna.default), {
            id: id,
            cardState: cardState,
            navigation: navigation,
            placeholderData: placeholderData,
            onAuthorize: services.length && handleAuthorize || undefined,
            onClick: handleClickWrapper,
            onAuxClick: handleFrameAuxClick,
            onContextMenu: handleFrameContextMenu,
            origin: "smartLinkCard",
            renderers: renderers,
            ui: ui,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            actionOptions: actionOptions,
            url: url,
            title: title,
            testId: testId,
            onResolve: onResolve,
            onError: onError
        }, children);
    }
    // We have to keep this last to prevent hook order from being violated
    if (error) throw error;
    switch(appearance){
        case 'inline':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jQkCW.InlineCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                isSelected: isSelected,
                isHovered: isHovered,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inlinePreloaderStyle: inlinePreloaderStyle,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                removeTextHighlightingFromTitle: removeTextHighlightingFromTitle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'block':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8R7wn.BlockCard), {
                id: id,
                url: url,
                renderers: renderers,
                authFlow: config && config.authFlow,
                cardState: state,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                isSelected: isSelected,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                actionOptions: actionOptions,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'embed':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8I0WZ.EmbedCard), {
                id: id,
                url: url,
                renderers: renderers,
                cardState: state,
                iframeUrlType: embedIframeUrlType,
                handleAuthorize: services.length && handleAuthorize || undefined,
                handleErrorRetry: handleRetry,
                handleFrameClick: handleClickWrapper,
                handleFrameAuxClick: handleFrameAuxClick,
                handleFrameContextMenu: handleFrameContextMenu,
                handleInvoke: handleInvoke,
                isSelected: isSelected,
                frameStyle: frameStyle,
                platform: platform,
                onResolve: onResolve,
                onError: onError,
                testId: testId,
                inheritDimensions: inheritDimensions,
                actionOptions: actionOptions,
                ref: embedIframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
    }
}
const $ea70321911296f9d$export$7598f5d7c597dd32 = (props)=>{
    const display = (0, $c2F9z.isFlexibleUiCard)(props.children, props === null || props === void 0 ? void 0 : props.ui) ? (0, $j9rqA.CardDisplay).Flexible : props.appearance;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8K8sp.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $baiO5.SmartLinkAnalyticsContext), {
        url: props.url,
        id: props.id,
        display: display
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($ea70321911296f9d$var$Component, props)));
};
const $ea70321911296f9d$export$d4ee8167ac732647 = (0, $Xfogc.default)($ea70321911296f9d$export$7598f5d7c597dd32);

});
parcelRegister("h49UZ", function(module, exports) {
$parcel$export(module.exports, "getObjectAri", () => $4ccc042e119e7e22$export$81164c1570bcd038);
const $4ccc042e119e7e22$export$81164c1570bcd038 = (details)=>(details === null || details === void 0 ? void 0 : details.data) && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;

});

parcelRegister("1nf2I", function(module, exports) {
$parcel$export(module.exports, "getObjectName", () => $ee234d9d4ab46bbe$export$5615361d76a8be5);
const $ee234d9d4ab46bbe$export$5615361d76a8be5 = (details)=>(details === null || details === void 0 ? void 0 : details.data) && 'name' in details.data && details.data.name || undefined;

});

parcelRegister("jxH84", function(module, exports) {
$parcel$export(module.exports, "useSmartLink", () => $c40db9d7cb104937$export$9f4e486b1dc3e700);

var $fc4bM = parcelRequire("fc4bM");

var $fnEFU = parcelRequire("fnEFU");

var $dRkX9 = parcelRequire("dRkX9");

var $lBTn5 = parcelRequire("lBTn5");

var $i0TIn = parcelRequire("i0TIn");

var $eANHk = parcelRequire("eANHk");

var $fzYCU = parcelRequire("fzYCU");
function $c40db9d7cb104937$export$9f4e486b1dc3e700(id, url, appearance) {
    const state = (0, $fzYCU.useSmartCardState)(url);
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = (0, $fnEFU.useSmartLinkContext)();
    const actions = (0, $lBTn5.useSmartCardActions)(id, url);
    const config = (0, $i0TIn.useSmartLinkConfig)();
    const renderers = (0, $eANHk.useSmartLinkRenderers)();
    // NB: used to propagate errors from hooks to error boundaries.
    const [error, setError] = (0, $fc4bM.useState)(null);
    // Register the current card with appearance hint for optimized ORS response.
    const register = ()=>{
        actions.register((0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization') ? appearance : undefined).catch((err)=>setError(err));
    };
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $fc4bM.useEffect)(register, [
        url,
        store
    ]);
    // Provide the state and card actions to consumers.
    return {
        state: state,
        actions: actions,
        config: config,
        renderers: renderers,
        error: error,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        isPreviewRestricted: (0, $dRkX9.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined,
        openPreviewPanel: openPreviewPanel
    };
}

});
parcelRegister("i0TIn", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkConfig", () => $f9983048b67e9f81$export$5d10838c1e539409);

var $fnEFU = parcelRequire("fnEFU");
const $f9983048b67e9f81$export$5d10838c1e539409 = ()=>{
    const context = (0, $fnEFU.useSmartLinkContext)();
    if (context) return context.config;
    return undefined;
};

});


parcelRegister("lwb5x", function(module, exports) {
$parcel$export(module.exports, "isFinalState", () => $36bbb2dbbf8c0ea2$export$d590d08942abc17a);
const $36bbb2dbbf8c0ea2$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};

});

parcelRegister("1JV8M", function(module, exports) {
$parcel$export(module.exports, "combineActionOptions", () => $10ec52aedd8c49f9$export$2ae4cf79c720146a);
const $10ec52aedd8c49f9$export$2ae4cf79c720146a = ({ actionOptions: actionOptions, platform: platform })=>{
    if (typeof actionOptions !== 'undefined') return actionOptions;
    if (platform === 'mobile') return {
        hide: true
    };
    let exclude = [];
    return {
        hide: false,
        exclude: exclude
    };
};

});

parcelRegister("8R7wn", function(module, exports) {
$parcel$export(module.exports, "BlockCard", () => $e16ffc9326aa8717$export$d18ccd25c0d2c6b0);

var $fc4bM = parcelRequire("fc4bM");

var $d7r8x = parcelRequire("d7r8x");

var $9oqjm = parcelRequire("9oqjm");

var $lddQC = parcelRequire("lddQC");

var $l0pqb = parcelRequire("l0pqb");

var $azBNw = parcelRequire("azBNw");

var $kCuXG = parcelRequire("kCuXG");

var $8YFbm = parcelRequire("8YFbm");

var $lvGat = parcelRequire("lvGat");

var $jC1og = parcelRequire("jC1og");

var $9tzlS = parcelRequire("9tzlS");
const $e16ffc9326aa8717$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: "smart-card-block-card"
    }), children);
const $e16ffc9326aa8717$export$d18ccd25c0d2c6b0 = ({ id: id, url: url, cardState: cardState, authFlow: authFlow, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, renderers: renderers, isSelected: isSelected, onResolve: onResolve, onError: onError, testId: testId, actionOptions: actionOptions, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const { status: status } = cardState;
    const blockCardProps = {
        id: id,
        cardState: cardState,
        url: url,
        testId: testId,
        onClick: (event)=>(0, $l0pqb.handleClickCommon)(event, handleFrameClick),
        onAuxClick: handleFrameAuxClick,
        onContextMenu: handleFrameContextMenu,
        onError: onError,
        onResolve: onResolve,
        renderers: renderers,
        actionOptions: actionOptions,
        CompetitorPrompt: CompetitorPrompt,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    };
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9oqjm.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e16ffc9326aa8717$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jC1og.default), {
                ...blockCardProps,
                testId: "smart-block-resolving-view"
            }));
        case 'resolved':
            if ((0, $lddQC.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9tzlS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jC1og.default), blockCardProps);
        case 'unauthorized':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9tzlS.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'forbidden':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8YFbm.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'not_found':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lvGat.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            if (authFlow && authFlow === 'disabled') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $azBNw.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: `${testId}-${status}`
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kCuXG.default), {
                ...blockCardProps,
                onAuthorize: handleAuthorize
            });
    }
};

});
parcelRegister("9oqjm", function(module, exports) {
$parcel$export(module.exports, "useControlDataExportConfig", () => $128ba0b7acdbf18c$export$f93c47f1b2b3f55b);

var $fc4bM = parcelRequire("fc4bM");

var $fnEFU = parcelRequire("fnEFU");
const $128ba0b7acdbf18c$export$f93c47f1b2b3f55b = ()=>{
    const { connections: connections, product: product, shouldControlDataExport: shouldControlDataExport } = (0, $fnEFU.useSmartLinkContext)();
    return (0, $fc4bM.useMemo)(()=>({
            baseUrl: connections.client.baseUrlOverride,
            envKey: connections.client.envKey,
            product: product,
            shouldControlDataExport: shouldControlDataExport
        }), [
        connections.client.baseUrlOverride,
        connections.client.envKey,
        product,
        shouldControlDataExport
    ]);
};

});

parcelRegister("lddQC", function(module, exports) {
$parcel$export(module.exports, "getIsDataExportEnabled", () => $36cd7adc648dde88$export$a019611f39785186);
const $36cd7adc648dde88$export$a019611f39785186 = (shouldControlDataExport = false, response)=>{
    var _response$meta;
    return Boolean(shouldControlDataExport && (response === null || response === void 0 || (_response$meta = response.meta) === null || _response$meta === void 0 || (_response$meta = _response$meta.supportedFeature) === null || _response$meta === void 0 ? void 0 : _response$meta.includes('ExportBlocked')));
};

});

parcelRegister("l0pqb", function(module, exports) {
$parcel$export(module.exports, "handleClickCommon", () => $3c7a3389b7189bd3$export$9759a67e215c4598);
const $3c7a3389b7189bd3$export$9759a67e215c4598 = (event, onClick)=>{
    if (onClick) {
        event.preventDefault();
        event.stopPropagation();
        onClick(event);
    }
};

});

parcelRegister("kCuXG", function(module, exports) {
$parcel$export(module.exports, "default", () => $23c6061df7e34037$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $7ZdBj = parcelRequire("7ZdBj");

var $ewFKq = parcelRequire("ewFKq");

var $jBxpI = parcelRequire("jBxpI");

var $l2jO1 = parcelRequire("l2jO1");

var $6W3ME = parcelRequire("6W3ME");

var $hvEwH = parcelRequire("hvEwH");
/**
 * This view represents a Block Card with an 'Errored' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $23c6061df7e34037$var$ErroredView = ({ testId: testId = 'smart-block-errored-view', ...props })=>{
    const actions = (0, $fc4bM.useMemo)(()=>props.onAuthorize ? [
            (0, $l2jO1.RetryAction)(props.onAuthorize)
        ] : [], [
        props.onAuthorize
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6W3ME.default), {
        ...props,
        actions: actions,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7ZdBj))), {
        label: "errored-warning-icon",
        color: "var(--ds-icon-warning, #E06C00)",
        testId: `${testId}-warning-icon`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jBxpI.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $ewFKq.messages).could_not_load_link
        }
    }));
};
const $23c6061df7e34037$var$_default_1 = (0, $hvEwH.withFlexibleUIBlockCardStyle)($23c6061df7e34037$var$ErroredView);
var $23c6061df7e34037$export$2e2bcd8739ae039 = $23c6061df7e34037$var$_default_1;

});
parcelRegister("l2jO1", function(module, exports) {
$parcel$export(module.exports, "RetryAction", () => $126ce7e9e4c9d598$export$c527d977b53f7537);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");
const $126ce7e9e4c9d598$export$c527d977b53f7537 = (onRetry)=>({
        name: (0, $j9rqA.ActionName).CustomAction,
        onClick: onRetry,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).try_again),
        testId: 'smart-action-try-again'
    });

});

parcelRegister("6W3ME", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1249080ec18ae3d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fJ9SP = parcelRequire("fJ9SP");

var $6Sqna = parcelRequire("6Sqna");

var $gndj3 = parcelRequire("gndj3");

var $cRZsT = parcelRequire("cRZsT");

var $8DLmm = parcelRequire("8DLmm");

var $htqFW = parcelRequire("htqFW");

var $8nzdZ = parcelRequire("8nzdZ");
const $c1249080ec18ae3d$var$customBlockStyles = null;
const $c1249080ec18ae3d$var$titleBlockCss = null;
const $c1249080ec18ae3d$var$footerBlockCss = null;
const $c1249080ec18ae3d$var$footerBlockSafariStyles = null;
const $c1249080ec18ae3d$var$UnresolvedView = ({ actions: actions, cardState: cardState, children: children, onAuthorize: onAuthorize, onClick: onClick, onError: onError, showPreview: showPreview = false, testId: testId, title: title, url: url, CompetitorPrompt: CompetitorPrompt })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $fc4bM.useMemo)(()=>(0, $fJ9SP.browser)(), []);
    return /*#__PURE__*/ $fc4bM.createElement((0, $6Sqna.default), {
        appearance: "block",
        cardState: cardState,
        onAuthorize: onAuthorize,
        onClick: onClick,
        onError: onError,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $8nzdZ.FlexibleCardUiOptions),
        url: url
    }, /*#__PURE__*/ $fc4bM.createElement((0, $htqFW.default), {
        ...(0, $8nzdZ.titleBlockOptions),
        hideIcon: !!title,
        text: title,
        CompetitorPrompt: CompetitorPrompt,
        className: (0, $2R2iS.default)([
            "_zulpu2gc _13mh1pd9 _2yhz13af"
        ])
    }), /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        className: (0, $2R2iS.default)([
            "_zulp1b66 _1e0c1txw _4cvr1y6m _1wpz1fhb _7yjtidpf _ngc0i7uo"
        ])
    }, children), showPreview && /*#__PURE__*/ $fc4bM.createElement((0, $8DLmm.default), (0, $8nzdZ.PreviewBlockOptions)), /*#__PURE__*/ $fc4bM.createElement((0, $cRZsT.default), {
        actions: actions,
        testId: "smart-block-card-footer",
        className: (0, $2R2iS.default)([
            "_4t3i1k8s _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
            safari && "_4t3i1osq"
        ])
    }));
};
var $c1249080ec18ae3d$export$2e2bcd8739ae039 = $c1249080ec18ae3d$var$UnresolvedView;

});
parcelRegister("8nzdZ", function(module, exports) {
$parcel$export(module.exports, "getSimulatedBetterMetadata", () => $6925c4f9de2a9bd8$export$f87d357259b3b7c8);
$parcel$export(module.exports, "FlexibleCardUiOptions", () => $6925c4f9de2a9bd8$export$22ebf74c8bee4708);
$parcel$export(module.exports, "titleBlockOptions", () => $6925c4f9de2a9bd8$export$45bdb4108909a713);
$parcel$export(module.exports, "PreviewBlockOptions", () => $6925c4f9de2a9bd8$export$9671929f11bd4ad8);

var $j9rqA = parcelRequire("j9rqA");

var $8FBNQ = parcelRequire("8FBNQ");

var $96gGh = parcelRequire("96gGh");
const $6925c4f9de2a9bd8$var$baseTopMetadata = [
    {
        name: (0, $j9rqA.ElementName).ModifiedOn
    },
    {
        name: (0, $j9rqA.ElementName).AttachmentCount
    },
    {
        name: (0, $j9rqA.ElementName).SubscriberCount
    },
    {
        name: (0, $j9rqA.ElementName).VoteCount
    },
    {
        name: (0, $j9rqA.ElementName).DueOn
    },
    {
        name: (0, $j9rqA.ElementName).ReadTime
    }
];
const $6925c4f9de2a9bd8$var$baseBottomMetaData = [
    {
        name: (0, $j9rqA.ElementName).ReactCount
    },
    {
        name: (0, $j9rqA.ElementName).CommentCount
    },
    {
        name: (0, $j9rqA.ElementName).ViewCount
    },
    {
        name: (0, $j9rqA.ElementName).Priority
    },
    {
        name: (0, $j9rqA.ElementName).SubTasksProgress
    },
    {
        name: (0, $j9rqA.ElementName).ChecklistProgress
    }
];
const $6925c4f9de2a9bd8$export$f87d357259b3b7c8 = (cardDetails)=>{
    var _data$Type;
    const extensionKey = (0, $96gGh.getExtensionKey)(cardDetails) ?? '';
    const data = cardDetails === null || cardDetails === void 0 ? void 0 : cardDetails.data;
    const defaultTitleMetadata = [
        {
            name: (0, $j9rqA.ElementName).State
        }
    ];
    const defaultTopMetadata = [
        {
            name: (0, $j9rqA.ElementName).AuthorGroup
        },
        {
            name: (0, $j9rqA.ElementName).CreatedBy
        },
        ...$6925c4f9de2a9bd8$var$baseTopMetadata
    ];
    const defaultBottomMetadata = $6925c4f9de2a9bd8$var$baseBottomMetaData;
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            const isFile = data['@type'].includes('schema:DigitalDocument');
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: isFile ? [
                    {
                        name: (0, $j9rqA.ElementName).LatestCommit
                    },
                    {
                        name: (0, $j9rqA.ElementName).CollaboratorGroup
                    },
                    {
                        name: (0, $j9rqA.ElementName).ModifiedOn
                    }
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'dragonfruit-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $8FBNQ.extractOwnedBy)(data) ? [
                    {
                        name: (0, $j9rqA.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $j9rqA.ElementName).OwnedBy
                    },
                    ...$6925c4f9de2a9bd8$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $j9rqA.ElementName).AppliedToComponentsCount
                    },
                    ...$6925c4f9de2a9bd8$var$baseBottomMetaData
                ]
            };
        case 'integration-passionfruit-object-provider':
        case 'mercury-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $8FBNQ.extractOwnedBy)(data) ? [
                    {
                        name: (0, $j9rqA.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $j9rqA.ElementName).OwnedBy
                    },
                    ...$6925c4f9de2a9bd8$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: [
                    {
                        name: (0, $j9rqA.ElementName).AppliedToComponentsCount
                    },
                    ...$6925c4f9de2a9bd8$var$baseBottomMetaData
                ]
            };
        case 'confluence-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: (0, $8FBNQ.extractOwnedBy)(data) ? [
                    {
                        name: (0, $j9rqA.ElementName).OwnedByGroup
                    },
                    {
                        name: (0, $j9rqA.ElementName).OwnedBy
                    },
                    ...$6925c4f9de2a9bd8$var$baseTopMetadata
                ] : defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
        case 'jira-object-provider':
            const isJiraTask = ((_data$Type = data['@type']) === null || _data$Type === void 0 ? void 0 : _data$Type.includes('atlassian:Task')) ?? false;
            const isJiraPlan = data['atlassian:ownedBy'] ? true : false;
            let topMetadata = [
                {
                    name: (0, $j9rqA.ElementName).AuthorGroup
                },
                {
                    name: (0, $j9rqA.ElementName).CreatedBy
                },
                {
                    name: (0, $j9rqA.ElementName).ModifiedOn
                }
            ];
            if (isJiraTask) topMetadata = [
                {
                    name: (0, $j9rqA.ElementName).AssignedToGroup
                },
                {
                    name: (0, $j9rqA.ElementName).AssignedTo
                },
                {
                    name: (0, $j9rqA.ElementName).ModifiedOn
                }
            ];
            else if (isJiraPlan) topMetadata = [
                {
                    name: (0, $j9rqA.ElementName).OwnedByGroup
                },
                {
                    name: (0, $j9rqA.ElementName).OwnedBy
                }
            ];
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: topMetadata,
                bottomMetadata: [
                    {
                        name: (0, $j9rqA.ElementName).StoryPoints
                    },
                    {
                        name: (0, $j9rqA.ElementName).Priority
                    },
                    {
                        name: (0, $j9rqA.ElementName).SubTasksProgress
                    }
                ]
            };
        case 'slack-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $j9rqA.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $j9rqA.ElementName).SentOn
                    }
                ],
                bottomMetadata: [
                    {
                        name: (0, $j9rqA.ElementName).ReactCount
                    },
                    {
                        name: (0, $j9rqA.ElementName).CommentCount
                    }
                ]
            };
        case 'trello-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $j9rqA.ElementName).CollaboratorGroup
                    },
                    ...$6925c4f9de2a9bd8$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        case 'legion-object-provider':
        case 'people-object-provider':
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: [
                    {
                        name: (0, $j9rqA.ElementName).AuthorGroup
                    },
                    {
                        name: (0, $j9rqA.ElementName).TeamMemberCount
                    },
                    {
                        name: (0, $j9rqA.ElementName).UserAttributes
                    },
                    ...$6925c4f9de2a9bd8$var$baseTopMetadata
                ],
                bottomMetadata: defaultBottomMetadata
            };
        default:
            return {
                titleMetadata: defaultTitleMetadata,
                topMetadata: defaultTopMetadata,
                bottomMetadata: defaultBottomMetadata
            };
    }
};
const $6925c4f9de2a9bd8$export$22ebf74c8bee4708 = {
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true
};
const $6925c4f9de2a9bd8$export$45bdb4108909a713 = {
    anchorTarget: '_self',
    position: (0, $j9rqA.SmartLinkPosition).Center,
    hideRetry: true,
    size: (0, $j9rqA.SmartLinkSize).Large
};
const $6925c4f9de2a9bd8$export$9671929f11bd4ad8 = {
    placement: (0, $j9rqA.MediaPlacement).Right,
    ignoreContainerPadding: true
};

});


parcelRegister("hvEwH", function(module, exports) {
$parcel$export(module.exports, "withFlexibleUIBlockCardStyle", () => $a9cd54c0ea17cf8f$export$36ce1a3a446661ab);
/* withFlexibleUIBlockCardStyle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $a9cd54c0ea17cf8f$var$flexibleBlockCardStyle = null;
const $a9cd54c0ea17cf8f$export$36ce1a3a446661ab = (FlexibleBlockCardView)=>(props)=>{
        return /*#__PURE__*/ $fc4bM.createElement("div", {
            className: (0, $2R2iS.default)([
                "_1g961mok _1qo3ia51"
            ])
        }, /*#__PURE__*/ $fc4bM.createElement(FlexibleBlockCardView, props));
    };

});


parcelRegister("8YFbm", function(module, exports) {
$parcel$export(module.exports, "default", () => $8d437965b2979215$export$2e2bcd8739ae039);
/* ForbiddenView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $jEubQ = parcelRequire("jEubQ");

var $jTWWA = parcelRequire("jTWWA");

var $kzNPc = parcelRequire("kzNPc");

var $hiN0m = parcelRequire("hiN0m");

var $kyL3S = parcelRequire("kyL3S");

var $ewFKq = parcelRequire("ewFKq");

var $dnVHi = parcelRequire("dnVHi");

var $h7cVs = parcelRequire("h7cVs");

var $jBxpI = parcelRequire("jBxpI");

var $kxbst = parcelRequire("kxbst");

var $6W3ME = parcelRequire("6W3ME");

var $hvEwH = parcelRequire("hvEwH");
const $8d437965b2979215$var$textStyles = null;
/**
 * This view represent a Block Card with the 'Forbidden' status.
 * It should have a "Try another account" button that will allow a user to connect another account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $8d437965b2979215$var$ForbiddenView = ({ testId: testId = 'smart-block-forbidden-view', ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const intl = (0, $gpjDl.default)();
    const { cardState: cardState, onAuthorize: onAuthorize, url: url } = props;
    const details = cardState === null || cardState === void 0 ? void 0 : cardState.details;
    const cardMetadata = (details === null || details === void 0 ? void 0 : details.meta) ?? (0, $dnVHi.getForbiddenJsonLd)().meta;
    const provider = (0, $kzNPc.extractSmartLinkProvider)(details);
    const providerName = (provider === null || provider === void 0 ? void 0 : provider.text) || '';
    const messageContext = (0, $fc4bM.useMemo)(()=>{
        const hostname = /*#__PURE__*/ $fc4bM.createElement("b", null, (0, $kyL3S.default)(url));
        return {
            product: providerName,
            hostname: hostname
        };
    }, [
        providerName,
        url
    ]);
    const requestAccessContext = (0, $fc4bM.useMemo)(()=>{
        return (0, $hiN0m.extractRequestAccessContextImproved)({
            jsonLd: cardMetadata,
            url: url,
            product: providerName,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        cardMetadata,
        providerName,
        url,
        createAnalyticsEvent
    ]);
    const title = (0, $fc4bM.useMemo)(()=>{
        const descriptor = (0, $h7cVs.toMessage)((0, $ewFKq.messages).invalid_permissions, requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.titleMessageKey);
        return intl.formatMessage(descriptor, {
            product: providerName
        });
    }, [
        intl,
        providerName,
        requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.titleMessageKey
    ]);
    const actions = (0, $fc4bM.useMemo)(()=>{
        let actionFromAccessContext = [];
        const tryAnotherAccountAction = onAuthorize ? [
            (0, $kxbst.ForbiddenAction)(onAuthorize, 'try_another_account')
        ] : [];
        if (requestAccessContext) {
            const { action: action, callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            actionFromAccessContext = action && callToActionMessageKey ? [
                (0, $kxbst.ForbiddenAction)(action.promise, callToActionMessageKey, messageContext, requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.buttonDisabled)
            ] : [];
        }
        return [
            ...tryAnotherAccountAction,
            ...actionFromAccessContext
        ];
    }, [
        onAuthorize,
        requestAccessContext,
        messageContext
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $6W3ME.default), {
        ...props,
        actions: actions,
        showPreview: true,
        testId: testId,
        title: title
    }, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jTWWA))), {
        label: "forbidden-lock-icon",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ $fc4bM.createElement((0, $jBxpI.default), {
        maxLines: 3,
        message: {
            descriptor: (0, $h7cVs.toMessage)((0, $ewFKq.messages).invalid_permissions_description, requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.descriptiveMessageKey),
            values: messageContext
        },
        className: (0, $2R2iS.default)([
            "_syazi7uo"
        ])
    }));
};
const $8d437965b2979215$var$_default_1 = (0, $hvEwH.withFlexibleUIBlockCardStyle)($8d437965b2979215$var$ForbiddenView);
var $8d437965b2979215$export$2e2bcd8739ae039 = $8d437965b2979215$var$_default_1;

});
parcelRegister("h7cVs", function(module, exports) {
$parcel$export(module.exports, "toMessage", () => $806dfabb2a2dfedf$export$d14c2a6dee946f52);

var $ewFKq = parcelRequire("ewFKq");
const $806dfabb2a2dfedf$export$d14c2a6dee946f52 = (defaultMessage, key)=>{
    try {
        if (key !== undefined && key in (0, $ewFKq.messages)) return (0, $ewFKq.messages)[key];
        return defaultMessage;
    } catch  {
        return defaultMessage;
    }
};

});

parcelRegister("kxbst", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $73916b956f30f50e$export$59f8830fb5467e35);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");
const $73916b956f30f50e$export$59f8830fb5467e35 = (onClick, content, context, isDisabled)=>({
        name: (0, $j9rqA.ActionName).CustomAction,
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...(0, $ewFKq.messages)[content],
            values: context
        }),
        onClick: onClick,
        testId: 'smart-action-connect-other-account',
        isDisabled: isDisabled
    });

});


parcelRegister("lvGat", function(module, exports) {
$parcel$export(module.exports, "default", () => $f533d6dc04cdbad2$export$2e2bcd8739ae039);
/* NotFoundView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $gpjDl = parcelRequire("gpjDl");

var $jTWWA = parcelRequire("jTWWA");

var $kzNPc = parcelRequire("kzNPc");

var $ewFKq = parcelRequire("ewFKq");

var $jBxpI = parcelRequire("jBxpI");

var $6W3ME = parcelRequire("6W3ME");

var $hvEwH = parcelRequire("hvEwH");
const $f533d6dc04cdbad2$var$textStyles = null;
/**
 * This view represents a Block Card with a 'Not_Found' status.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $f533d6dc04cdbad2$var$NotFoundView = ({ testId: testId = 'smart-block-not-found-view', ...props })=>{
    const intl = (0, $gpjDl.default)();
    const { cardState: { details: details } } = props;
    const product = (0, $fc4bM.useMemo)(()=>{
        const provider = (0, $kzNPc.extractSmartLinkProvider)(details);
        return (provider === null || provider === void 0 ? void 0 : provider.text) ?? '';
    }, [
        details
    ]);
    const title = (0, $fc4bM.useMemo)(()=>intl.formatMessage((0, $ewFKq.messages).not_found_title, {
            product: product
        }), [
        intl,
        product
    ]);
    const description = (0, $fc4bM.useMemo)(()=>({
            descriptor: (0, $ewFKq.messages).not_found_description
        }), []);
    return /*#__PURE__*/ $fc4bM.createElement((0, $6W3ME.default), {
        ...props,
        testId: testId,
        title: title
    }, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($jTWWA))), {
        label: "not-found-lock-icon",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: `${testId}-lock-icon`
    }), /*#__PURE__*/ $fc4bM.createElement((0, $jBxpI.default), {
        message: description,
        testId: `${testId}-message`,
        maxLines: 3,
        className: (0, $2R2iS.default)([
            "_syazi7uo"
        ])
    }));
};
const $f533d6dc04cdbad2$var$_default_1 = (0, $hvEwH.withFlexibleUIBlockCardStyle)($f533d6dc04cdbad2$var$NotFoundView);
var $f533d6dc04cdbad2$export$2e2bcd8739ae039 = $f533d6dc04cdbad2$var$_default_1;

});

parcelRegister("jC1og", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f0dbe3ea02b2be6$export$2e2bcd8739ae039);
/* ResolvedView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fJ9SP = parcelRequire("fJ9SP");

var $j9rqA = parcelRequire("j9rqA");

var $95H2w = parcelRequire("95H2w");

var $96gGh = parcelRequire("96gGh");

var $9LWGg = parcelRequire("9LWGg");

var $gysdQ = parcelRequire("gysdQ");

var $hcvQy = parcelRequire("hcvQy");

var $6Sqna = parcelRequire("6Sqna");

var $4G7KW = parcelRequire("4G7KW");

var $eZzzn = parcelRequire("eZzzn");

var $8DLmm = parcelRequire("8DLmm");

var $PBikU = parcelRequire("PBikU");

var $htqFW = parcelRequire("htqFW");

var $8nzdZ = parcelRequire("8nzdZ");

var $hvEwH = parcelRequire("hvEwH");
const $7f0dbe3ea02b2be6$var$titleBlockCss = null;
const $7f0dbe3ea02b2be6$var$footerBlockCss = null;
const $7f0dbe3ea02b2be6$var$footerSpacingCss = null;
const $7f0dbe3ea02b2be6$var$footerBlockSafariStyles = null;
/**
 * This view represents a Block card that has an 'Resolved' status.
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $7f0dbe3ea02b2be6$var$ResolvedView = ({ cardState: cardState, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, onError: onError, onResolve: onResolve, actionOptions: actionOptions, testId: testId = 'smart-block-resolved-view', url: url, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    var _cardState$details2;
    const [isPreviewBlockErrored, setIsPreviewBlockErrored] = (0, $fc4bM.useState)(false);
    const extensionKey = (0, $96gGh.getExtensionKey)(cardState.details);
    const is3PRovoBlockRovoActionEnabled = (0, $9LWGg.default)(url, actionOptions);
    const rovoConfig = (0, $gysdQ.default)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $fc4bM.useMemo)(()=>(0, $fJ9SP.browser)(), []);
    (0, $fc4bM.useEffect)(()=>{
        setIsPreviewBlockErrored(false);
    }, [
        url,
        cardState
    ]);
    const { titleMetadata: titleMetadata, topMetadata: topMetadata, bottomMetadata: bottomMetadata } = (0, $8nzdZ.getSimulatedBetterMetadata)(cardState.details);
    const prompts = (0, $fc4bM.useMemo)(()=>{
        if (is3PRovoBlockRovoActionEnabled) {
            var _cardState$details;
            const defaultPrompts = [
                (0, $hcvQy.RovoChatPromptKey).KEY_HIGHLIGHTS
            ];
            const linkType = (_cardState$details = cardState.details) === null || _cardState$details === void 0 || (_cardState$details = _cardState$details.data) === null || _cardState$details === void 0 ? void 0 : _cardState$details['@type'];
            if (extensionKey === 'slack-object-provider') return [
                (0, $hcvQy.RovoChatPromptKey).FIND_OPEN_QUESTIONS,
                ...defaultPrompts
            ];
            if (extensionKey === 'google-object-provider' && linkType !== null && linkType !== void 0 && linkType.includes('schema:PresentationDigitalDocument')) return [
                (0, $hcvQy.RovoChatPromptKey).IDENTIFY_KEY_POINTS,
                ...defaultPrompts
            ];
            if (extensionKey === 'google-object-provider' && linkType !== null && linkType !== void 0 && linkType.includes('schema:SpreadsheetDigitalDocument')) return [
                (0, $hcvQy.RovoChatPromptKey).IDENTIFY_KEY_TRENDS,
                ...defaultPrompts
            ];
            return [
                (0, $hcvQy.RovoChatPromptKey).SUMMARIZE_LINK,
                ...defaultPrompts
            ];
        }
        return [];
    }, [
        cardState === null || cardState === void 0 || (_cardState$details2 = cardState.details) === null || _cardState$details2 === void 0 ? void 0 : _cardState$details2.data,
        extensionKey,
        is3PRovoBlockRovoActionEnabled
    ]);
    const footerActions = (0, $fc4bM.useMemo)(()=>{
        const showRovoResolvedView = (cardState === null || cardState === void 0 ? void 0 : cardState.status) === 'resolved' && cardState.details && (0, $95H2w.default)({
            response: cardState.details,
            rovoConfig: rovoConfig,
            actionOptions: actionOptions
        }) !== undefined;
        return showRovoResolvedView && is3PRovoBlockRovoActionEnabled ? [
            {
                name: (0, $j9rqA.ActionName).RovoChatAction,
                prompts: prompts,
                iconSize: 'small',
                cardAppearance: (0, $j9rqA.CardDisplay).Block
            },
            {
                name: (0, $j9rqA.ActionName).FollowAction,
                iconSize: 'small'
            },
            {
                name: (0, $j9rqA.ActionName).DownloadAction,
                iconSize: 'small'
            }
        ] : [
            {
                name: (0, $j9rqA.ActionName).FollowAction,
                hideIcon: true
            },
            {
                name: (0, $j9rqA.ActionName).PreviewAction,
                hideIcon: true
            },
            {
                name: (0, $j9rqA.ActionName).DownloadAction,
                hideIcon: true
            }
        ];
    }, [
        prompts,
        is3PRovoBlockRovoActionEnabled,
        cardState,
        rovoConfig,
        actionOptions
    ]);
    const uiOptions = (0, $8nzdZ.FlexibleCardUiOptions);
    uiOptions.enableSnippetRenderer = true;
    uiOptions.hideLoadingSkeleton = hideIconLoadingSkeleton;
    return /*#__PURE__*/ $fc4bM.createElement((0, $6Sqna.default), {
        appearance: "block",
        cardState: cardState,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onError: onError,
        onResolve: onResolve,
        origin: "smartLinkCard",
        actionOptions: actionOptions,
        testId: testId,
        ui: uiOptions,
        url: url
    }, /*#__PURE__*/ $fc4bM.createElement((0, $htqFW.default), {
        ...(0, $8nzdZ.titleBlockOptions),
        metadata: titleMetadata,
        subtitle: [
            {
                name: (0, $j9rqA.ElementName).Location
            }
        ],
        metadataPosition: (0, $j9rqA.SmartLinkPosition).Top,
        CompetitorPrompt: CompetitorPrompt,
        url: url,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton,
        className: (0, $2R2iS.default)([
            "_zulpu2gc _13mh1pd9 _2yhz13af"
        ])
    }), /*#__PURE__*/ $fc4bM.createElement((0, $eZzzn.default), {
        primary: topMetadata,
        maxLines: 1
    }), /*#__PURE__*/ $fc4bM.createElement((0, $PBikU.default), null), /*#__PURE__*/ $fc4bM.createElement((0, $eZzzn.default), {
        primary: bottomMetadata,
        maxLines: 1
    }), !isPreviewBlockErrored ? /*#__PURE__*/ $fc4bM.createElement((0, $8DLmm.default), {
        ...(0, $8nzdZ.PreviewBlockOptions),
        onError: ()=>{
            setIsPreviewBlockErrored(true);
        }
    }) : null, /*#__PURE__*/ $fc4bM.createElement((0, $4G7KW.default), {
        actions: footerActions,
        isPreviewBlockErrored: isPreviewBlockErrored,
        className: (0, $2R2iS.default)([
            "_4t3i10yn _1e0c1txw _1bah1yb4 _4cvresu3 _1wpz1fhb",
            safari && "_4t3i1osq",
            "_19pku2gc"
        ])
    }));
};
const $7f0dbe3ea02b2be6$var$_default_1 = (0, $hvEwH.withFlexibleUIBlockCardStyle)($7f0dbe3ea02b2be6$var$ResolvedView);
var $7f0dbe3ea02b2be6$export$2e2bcd8739ae039 = $7f0dbe3ea02b2be6$var$_default_1;

});
parcelRegister("9LWGg", function(module, exports) {
$parcel$export(module.exports, "default", () => $55ddf343eb631436$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $f4Od9 = parcelRequire("f4Od9");

var $96gGh = parcelRequire("96gGh");

var $fzYCU = parcelRequire("fzYCU");

var $gysdQ = parcelRequire("gysdQ");
const $55ddf343eb631436$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
/**
 * Returns whether the rovo actions are enabled for the current user and link context.
 *
 * All eligibility criteria are consolidated here:
 * 1. Rovo chat must be enabled for the tenant.
 * 2. The consumer must have opted in via actionOptions.rovoChatAction.optIn.
 * 3. The link must support the RovoActions feature.
 * 4. The extension key must be one of the supported options.
 *
 * The extension key is derived from the card store via the resolved URL,
 * so callers don't need to thread it as a prop.
 */ const $55ddf343eb631436$var$useBlockCardRovoAction = (url, actionOptions)=>{
    var _actionOptions$rovoCh;
    const { rovoOptions: rovoConfig, product: product } = (0, $gysdQ.default)();
    const isRovoChatEnabled = (0, $f4Od9.getIsRovoChatEnabled)(rovoConfig);
    const cardState = (0, $fzYCU.useSmartCardState)(url ?? '');
    const extensionKey = (0, $96gGh.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = (actionOptions === null || actionOptions === void 0 || (_actionOptions$rovoCh = actionOptions.rovoChatAction) === null || _actionOptions$rovoCh === void 0 ? void 0 : _actionOptions$rovoCh.optIn) ?? false;
    return (0, $fc4bM.useMemo)(()=>{
        if (!isRovoChatEnabled || !url || !isRovoChatActionOptedIn) return false;
        if (extensionKey && !$55ddf343eb631436$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey)) return false;
        return !!product && product === 'CONFLUENCE';
    }, [
        isRovoChatEnabled,
        extensionKey,
        url,
        isRovoChatActionOptedIn,
        product
    ]);
};
var $55ddf343eb631436$export$2e2bcd8739ae039 = $55ddf343eb631436$var$useBlockCardRovoAction;

});


parcelRegister("9tzlS", function(module, exports) {
$parcel$export(module.exports, "default", () => $026865505912e8f4$export$2e2bcd8739ae039);
/* UnauthorisedView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fd880 = parcelRequire("fd880");

var $3TJLC = parcelRequire("3TJLC");

var $kzNPc = parcelRequire("kzNPc");

var $fnEFU = parcelRequire("fnEFU");

var $dGxDH = parcelRequire("dGxDH");

var $dBtOK = parcelRequire("dBtOK");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $bxLV6 = parcelRequire("bxLV6");

var $9575Q = parcelRequire("9575Q");

var $b9KAt = parcelRequire("b9KAt");

var $13Tmh = parcelRequire("13Tmh");

var $8Rlkg = parcelRequire("8Rlkg");

var $6Sqna = parcelRequire("6Sqna");

var $kJrsj = parcelRequire("kJrsj");

var $gndj3 = parcelRequire("gndj3");

var $2UGy7 = parcelRequire("2UGy7");

var $ddON5 = parcelRequire("ddON5");

var $4tJOd = parcelRequire("4tJOd");

var $1fHg5 = parcelRequire("1fHg5");

var $dlSZI = parcelRequire("dlSZI");

var $aBvY5 = parcelRequire("aBvY5");

var $cuYD1 = parcelRequire("cuYD1");

var $8nzdZ = parcelRequire("8nzdZ");

var $hvEwH = parcelRequire("hvEwH");
const $026865505912e8f4$var$contentStyles = null;
const $026865505912e8f4$var$contentAdditionalStyles = null;
const $026865505912e8f4$var$newTitleBlockStyles = null;
const $026865505912e8f4$var$intermediumGapStyles = null;
const $026865505912e8f4$var$titleBlockStyles = null;
const $026865505912e8f4$var$previewBlockStyle = null;
const $026865505912e8f4$var$previewBlockStyleWithOverlap = null;
const $026865505912e8f4$var$linkIconStyles = null;
const $026865505912e8f4$var$containerStyles = null;
const $026865505912e8f4$var$previewBlockImageStyle = null;
const $026865505912e8f4$var$styles = {
    titleBoxCard: "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bsb1osq"
};
const $026865505912e8f4$var$getBetterTitle = (url)=>{
    // List of regexps to extract human-readable titles from URLs
    // Each regex should have a capture group for the title at index 1
    const titleExtractors = [
        // Dropbox: https://www.dropbox.com/scl/fi/scebraopvx4bni0sechq9/Atlas23_D1_A_0014.jpg?rlkey=... -> Atlas23_D1_A_0014.jpg
        /^https:\/\/www\.dropbox\.com\/scl\/fi\/[^\/]+\/([^\/\?]+)/,
        // Dropbox: https://www.dropbox.com/home/Teamwork%20Ecosystem?preview=xsociety00.dat -> Teamwork Ecosystem
        /^https:\/\/www\.dropbox\.com\/home\/([^\/\?]+)/,
        // Dropbox: https://www.dropbox.com/home?preview=Insomnia-All_2019-03-14.json -> Insomnia-All_2019-03-14.json
        /^https:\/\/www\.dropbox\.com\/home\?(?:.*?&)?preview=([^&#]+)/,
        // Dropbox: https://www.dropbox.com/preview/AI%20Contest -> AI Contest
        /^https:\/\/www\.dropbox\.com\/preview\/([^&?]+)/,
        // Dropbox: https://www.dropbox.com/s/votiehk00g4opif/xsociety00.dat?dl=0 -> xsociety00.dat
        /^https:\/\/www\.dropbox\.com\/(?:s|sh|sc|t)\/[^\/]+\/([^\/\?]+)/,
        // Figma: https://www.figma.com/slides/vW47To0dYPnT7jlrJdUd7h/Universal-Create-in-TwC?node-id=... -> Universal-Create-in-TwC
        // Also supports: /file/, /design/, /board/, /proto/
        /^https:\/\/(?:[\w.-]+\.)?figma\.com\/(?:design|board|file|proto|slides)\/[0-9a-zA-Z]{22,128}\/([^\/\?]+)/,
        // OneDrive: https://1drv.ms/w/s!ABC123DEF456/Project_Plan.docx?e=abcdEF -> Project_Plan.docx
        /^https:\/\/1drv\.ms\/[a-z]+\/s![^\/]+\/([^\/\?]+)/,
        // Miro: https://miro.com/app/board/uXjVOPnT123=/my-board-name/ -> my-board-name
        /^https:\/\/miro\.com\/app\/board\/[^\/]+\/([^\/\?]+)\/?/
    ];
    // Try each extractor pattern
    for (const pattern of titleExtractors){
        const match = url.match(pattern);
        if (match) {
            const extracted = decodeURIComponent(match[1]);
            if (extracted) return extracted;
        }
    }
    try {
        const { pathname: pathname, search: search } = new URL(url);
        if (pathname.length > 1) return pathname.substring(1);
        if (search) return search;
        // Fall back to the full URL when there is no useful path/search to display,
        // so the title (and the underlying link) always has accessible text.
        return url;
    } catch  {
        return url;
    }
};
const $026865505912e8f4$var$UnauthorisedBlock = ({ actions: actions, children: children, url: url, CompetitorPrompt: CompetitorPrompt, testId: testId })=>{
    var _data$preview;
    const { ui: ui, data: data } = (0, $bxLV6.useFlexibleCardContext)() ?? {
        ui: undefined,
        data: undefined
    };
    const hasActions = actions && actions.length > 0;
    const actionGroup = hasActions ? /*#__PURE__*/ $fc4bM.createElement((0, $kJrsj.default), {
        size: (0, $j9rqA.SmartLinkSize).Large,
        items: actions
    }) : null;
    const competitorPrompt = CompetitorPrompt && data !== null && data !== void 0 && data.url ? /*#__PURE__*/ $fc4bM.createElement(CompetitorPrompt, {
        sourceUrl: data === null || data === void 0 ? void 0 : data.url,
        linkType: 'card'
    }) : null;
    const title = /*#__PURE__*/ $fc4bM.createElement((0, $1fHg5.default), {
        hideTooltip: false,
        maxLines: 1,
        theme: ui === null || ui === void 0 ? void 0 : ui.theme,
        text: $026865505912e8f4$var$getBetterTitle(url),
        className: (0, $2R2iS.default)([
            "_k48p1pd9 _syaz13af"
        ])
    });
    const { position: position } = (0, $8nzdZ.titleBlockOptions);
    let overrideUrl = (data === null || data === void 0 || (_data$preview = data.preview) === null || _data$preview === void 0 ? void 0 : _data$preview.url) ?? (0, (/*@__PURE__*/$parcel$interopDefault($aBvY5)));
    return /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        ...(0, $8nzdZ.titleBlockOptions),
        testId: `${testId}-errored-view`,
        className: (0, $2R2iS.default)([
            "_7cca15wb _1f3816vg"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $2UGy7.default), {
        direction: (0, $j9rqA.SmartLinkDirection).Vertical,
        width: (0, $j9rqA.SmartLinkWidth).Flexible,
        size: (0, $j9rqA.SmartLinkSize).Medium,
        className: (0, $2R2iS.default)([
            "_zulputpp"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), null, /*#__PURE__*/ $fc4bM.createElement((0, $4tJOd.default), {
        position: position,
        size: (0, $j9rqA.SmartLinkSize).Medium,
        isTiledIcon: true,
        className: (0, $2R2iS.default)([
            "_vsqgglyw"
        ])
    }), /*#__PURE__*/ $fc4bM.createElement((0, $2UGy7.default), {
        direction: (0, $j9rqA.SmartLinkDirection).Vertical,
        width: (0, $j9rqA.SmartLinkWidth).Flexible,
        size: (0, $j9rqA.SmartLinkSize).Large,
        className: (0, $2R2iS.default)([
            "_zulpidpf"
        ])
    }, competitorPrompt ? /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $026865505912e8f4$var$styles.titleBoxCard
    }, title, competitorPrompt) : title, /*#__PURE__*/ $fc4bM.createElement((0, $2UGy7.default), {
        size: (0, $j9rqA.SmartLinkSize).Medium,
        direction: (0, $j9rqA.SmartLinkDirection).Horizontal
    }, (0, $ddON5.renderElementItems)([
        {
            name: (0, $j9rqA.ElementName).HostName
        }
    ])))), children, actionGroup), hasActions ? /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_1reo15vq _18m915vq _1bsb1o87 _1wpz1fhb _1dptglyw",
            "_1bsbo60d"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        style: {
            backgroundImage: `url(${overrideUrl})`
        },
        className: (0, $2R2iS.default)([
            "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _4t3i1osq _1bsb1o87 _1lrw1f51 _ouxl1ssb _12vemgnk"
        ])
    })) : null);
};
/**
 * This view represents a Block card that has an 'Unauthorized' status .
 * It should have a "Connect" button that will allow a user to connect their account and view the block card.
 *
 * @see SmartLinkStatus
 * @see FlexibleCardProps
 */ const $026865505912e8f4$var$UnauthorisedViewFrame = ({ content: content, providerName: providerName, testId: testId, ...props })=>{
    const { onAuthorize: onAuthorize } = props;
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const handleAuthorize = (0, $fc4bM.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const actions = (0, $fc4bM.useMemo)(()=>onAuthorize ? [
            (0, $dlSZI.AuthorizeAction)(handleAuthorize, providerName)
        ] : [], [
        handleAuthorize,
        onAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $6Sqna.default), {
        appearance: "block",
        onAuthorize: onAuthorize,
        origin: "smartLinkCard",
        testId: testId,
        ui: (0, $8nzdZ.FlexibleCardUiOptions),
        ...props
    }, /*#__PURE__*/ $fc4bM.createElement($026865505912e8f4$var$UnauthorisedBlock, {
        actions: actions,
        cardState: props.cardState,
        CompetitorPrompt: props.CompetitorPrompt,
        testId: testId,
        url: props.url
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-testid": `${testId}-content`,
        className: (0, $2R2iS.default)([
            "_11c8fhey _syazi7uo _19pku2gc",
            actions.length > 0 && "_1reo15vq _18m915vq _otyrpxbi _p12f1osq _o5721q9c _1bto1l2s"
        ])
    }, content)));
};
const $026865505912e8f4$var$UnauthorisedViewBase = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    var _extractSmartLinkProv;
    const { cardState: cardState, onAuthorize: onAuthorize } = props;
    const providerName = (_extractSmartLinkProv = (0, $kzNPc.extractSmartLinkProvider)(cardState.details)) === null || _extractSmartLinkProv === void 0 ? void 0 : _extractSmartLinkProv.text;
    const isProductIntegrationSupported = (0, $9575Q.hasAuthScopeOverrides)(cardState.details);
    const content = (0, $fc4bM.useMemo)(()=>onAuthorize ? /*#__PURE__*/ $fc4bM.createElement((0, $8Rlkg.default), {
            providerName: providerName,
            isProductIntegrationSupported: isProductIntegrationSupported,
            testId: testId
        }) : /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
            ...(0, $ewFKq.messages)[providerName ? 'unauthorised_account_description' : 'unauthorised_account_description_no_provider'],
            values: {
                context: providerName
            }
        }), [
        isProductIntegrationSupported,
        onAuthorize,
        providerName,
        testId
    ]);
    return /*#__PURE__*/ $fc4bM.createElement($026865505912e8f4$var$UnauthorisedViewFrame, {
        ...props,
        content: content,
        providerName: providerName,
        testId: testId
    });
};
/**
 * Experiment wrapper: fires social proof exposure and renders social proof UI when FG is on.
 * TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
 */ const $026865505912e8f4$var$UnauthorisedViewWithExperiment = ({ testId: testId = 'smart-block-unauthorized-view', ...props })=>{
    var _props$cardState, _extractSmartLinkProv2;
    const extensionKey = (_props$cardState = props.cardState) === null || _props$cardState === void 0 || (_props$cardState = _props$cardState.details) === null || _props$cardState === void 0 || (_props$cardState = _props$cardState.meta) === null || _props$cardState === void 0 ? void 0 : _props$cardState.key;
    const providerName = (_extractSmartLinkProv2 = (0, $kzNPc.extractSmartLinkProvider)(props.cardState.details)) === null || _extractSmartLinkProv2 === void 0 ? void 0 : _extractSmartLinkProv2.text;
    const { connections: connections } = (0, $fnEFU.useSmartLinkContext)();
    const { isTreatment: isTreatment, tier: tier, connectedPct: connectedPct } = (0, $13Tmh.default)(providerName ? extensionKey : undefined, connections.client.baseUrlOverride);
    const socialProofExperimentMeta = (0, $b9KAt.getSocialProofExperimentMeta)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: connections.client.baseUrlOverride
    });
    const analyticsContextData = {
        attributes: {
            experiment: 'social_proof_3p_unauth_block_exp',
            cohort: isTreatment ? 'treatment' : 'control',
            tier: tier,
            experimentMeta: socialProofExperimentMeta
        }
    };
    if (!isTreatment || !providerName) {
        const fallbackView = /*#__PURE__*/ $fc4bM.createElement($026865505912e8f4$var$UnauthorisedViewBase, {
            ...props,
            testId: testId
        });
        return connectedPct !== undefined ? /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
            data: analyticsContextData
        }, fallbackView) : fallbackView;
    }
    return /*#__PURE__*/ $fc4bM.createElement((0, $3TJLC.default), {
        data: analyticsContextData
    }, /*#__PURE__*/ $fc4bM.createElement($026865505912e8f4$var$UnauthorisedViewFrame, {
        ...props,
        content: /*#__PURE__*/ $fc4bM.createElement((0, $cuYD1.default), {
            tier: tier,
            connectedPct: connectedPct,
            providerName: providerName
        }),
        providerName: providerName,
        testId: testId
    }));
};
const $026865505912e8f4$var$UnauthorisedViewWithoutExperiment = (props)=>{
    return /*#__PURE__*/ $fc4bM.createElement($026865505912e8f4$var$UnauthorisedViewBase, props);
};
const $026865505912e8f4$var$UnauthorisedView = (0, $dGxDH.componentWithFG)('social-proof-3p-unauth-block-fg', $026865505912e8f4$var$UnauthorisedViewWithExperiment, $026865505912e8f4$var$UnauthorisedViewWithoutExperiment);
const $026865505912e8f4$var$_default_1 = (0, $hvEwH.withFlexibleUIBlockCardStyle)($026865505912e8f4$var$UnauthorisedView);
var $026865505912e8f4$export$2e2bcd8739ae039 = $026865505912e8f4$var$_default_1;

});
parcelRegister("b9KAt", function(module, exports) {
$parcel$export(module.exports, "getSocialProofExperimentMeta", () => $feac25e4e636a3b5$export$49fab64ef7e3aab7);

var $6T9wD = parcelRequire("6T9wD");

var $13Tmh = parcelRequire("13Tmh");
const $feac25e4e636a3b5$export$49fab64ef7e3aab7 = (params)=>({
        [(0, $13Tmh.SOCIAL_PROOF_3P_UNAUTH_BLOCK_EXPERIMENT_KEY)]: (0, $6T9wD.getSocialProofExperimentMetadata)(params)
    });

});
parcelRegister("6T9wD", function(module, exports) {
$parcel$export(module.exports, "getSocialProofExperimentMetadata", () => $3fa92516d063405b$export$128de1ead1745dc0);

var $jpZmV = parcelRequire("jpZmV");

var $c26fn = parcelRequire("c26fn");

var $3hJbp = parcelRequire("3hJbp");

var $9XpQE = parcelRequire("9XpQE");
const $3fa92516d063405b$export$128de1ead1745dc0 = ({ extensionKey: extensionKey, baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash = '' })=>{
    if (!extensionKey) return {
        isEligible: false
    };
    const cloudId = (0, $jpZmV.getCurrentSiteCloudIdSync)(baseUriWithNoTrailingSlash);
    const providerPctMap = (0, $3hJbp.getProviderPctMapSync)(cloudId, (0, $c26fn.personalizationConstants).SOCIAL_PROOF_TRAIT_NAME);
    const tier = (0, $9XpQE.getSocialProofTier)(providerPctMap === null || providerPctMap === void 0 ? void 0 : providerPctMap[extensionKey]);
    return {
        isEligible: tier !== undefined,
        ...tier ? {
            tier: tier
        } : {}
    };
};

});
parcelRegister("jpZmV", function(module, exports) {
$parcel$export(module.exports, "getCurrentSiteCloudIdSync", () => $614be9c9e235b723$export$763646cf0dfa675c);

var $jysiD = parcelRequire("jysiD");
function $614be9c9e235b723$export$763646cf0dfa675c(baseUriWithNoTrailingSlash = '') {
    return (0, $jysiD.currentSiteCloudIdService).getStoredCloudId(baseUriWithNoTrailingSlash);
}

});

parcelRegister("c26fn", function(module, exports) {
$parcel$export(module.exports, "personalizationConstants", () => $d81dc8ed320cd5ee$export$e00ede90ba65156);
const $d81dc8ed320cd5ee$export$e00ede90ba65156 = {
    BASE_URL: '/gateway/api/tap-delivery/api/v3/personalization',
    PERSONALIZATION_STORAGE_SCOPE: 'smart-card-social-proof',
    PERSONALIZATION_STORAGE_ITEM_KEY_PREFIX: 'pct-map:v1:',
    PERSONALIZATION_PROVIDER_PCT_TTL_MS: 86400000,
    SOCIAL_PROOF_TRAIT_NAME: 'sl_3p_connected_providers_site_pct'
};

});

parcelRegister("3hJbp", function(module, exports) {
$parcel$export(module.exports, "getProviderPctMapSync", () => $05fa6f78efed3f46$export$70435023d0d90129);

var $jrpNY = parcelRequire("jrpNY");
function $05fa6f78efed3f46$export$70435023d0d90129(cloudId, traitName) {
    return (0, $jrpNY.personalizationService).getProviderPctMapSync(cloudId, traitName);
}

});
parcelRegister("jrpNY", function(module, exports) {
$parcel$export(module.exports, "personalizationService", () => $5363ecddb9ef1eed$export$356056318a4fd636);

var $8xGTn = parcelRequire("8xGTn");
const $5363ecddb9ef1eed$export$356056318a4fd636 = new (0, $8xGTn.PersonalizationService)();

});
parcelRegister("8xGTn", function(module, exports) {
$parcel$export(module.exports, "PersonalizationService", () => $8fcd6043f3720ecf$export$d653d8abac1e12ce);

var $bhV4A = parcelRequire("bhV4A");

var $c26fn = parcelRequire("c26fn");
const $8fcd6043f3720ecf$var$smartCardStorage = new (0, $bhV4A.StorageClient)((0, $c26fn.personalizationConstants).PERSONALIZATION_STORAGE_SCOPE);
/** Keys written by this service in localStorage when using {@link smartCardStorage}. */ const $8fcd6043f3720ecf$var$LOCAL_STORAGE_ROW_KEY_PREFIX = `${(0, $c26fn.personalizationConstants).PERSONALIZATION_STORAGE_SCOPE}_${(0, $c26fn.personalizationConstants).PERSONALIZATION_STORAGE_ITEM_KEY_PREFIX}`;
function $8fcd6043f3720ecf$var$scopedCacheKey(cloudId, traitName) {
    return `${cloudId}:${traitName}`;
}
function $8fcd6043f3720ecf$var$pctMapStorageItemKey(cloudId, traitName) {
    return `${(0, $c26fn.personalizationConstants).PERSONALIZATION_STORAGE_ITEM_KEY_PREFIX}${encodeURIComponent(cloudId)}:${encodeURIComponent(traitName)}`;
}
async function $8fcd6043f3720ecf$var$fetchSiteTraits(cloudId) {
    const response = await fetch(`${(0, $c26fn.personalizationConstants).BASE_URL}/site/${cloudId}`, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) return [];
    const data = await response.json();
    return (data === null || data === void 0 ? void 0 : data.attributes) ?? [];
}
class $8fcd6043f3720ecf$export$d653d8abac1e12ce {
    /** Pure synchronous read for an explicit cloud id / trait pair. */ getProviderPctMapSync(cloudId, traitName) {
        if (!cloudId) return null;
        return this.readStoredProviderPctMap(cloudId, traitName);
    }
    async getProviderPctMap(cloudId, traitName) {
        if (!cloudId) return undefined;
        const cacheKey = $8fcd6043f3720ecf$var$scopedCacheKey(cloudId, traitName);
        const cachedPromise = this.cache.get(cacheKey);
        if (cachedPromise) return cachedPromise;
        const promise = (async ()=>{
            try {
                const traits = await $8fcd6043f3720ecf$var$fetchSiteTraits(cloudId);
                const trait = traits.find((t)=>t.name === traitName);
                const mapped = this.parseTraitValue(trait === null || trait === void 0 ? void 0 : trait.value);
                if (mapped !== undefined) this.writeStoredProviderPctMap(cloudId, traitName, mapped);
                return mapped;
            } catch  {
                return undefined;
            }
        })();
        const retryablePromise = promise.finally(()=>{
            this.cache.delete(cacheKey);
        });
        this.cache.set(cacheKey, retryablePromise);
        return retryablePromise;
    }
    readStoredProviderPctMap(cloudId, traitName) {
        try {
            const stored = $8fcd6043f3720ecf$var$smartCardStorage.getItem($8fcd6043f3720ecf$var$pctMapStorageItemKey(cloudId, traitName));
            if (stored === undefined || stored === null) return null;
            return this.normalizeProviderPctMap(stored);
        } catch  {
            return null;
        }
    }
    writeStoredProviderPctMap(cloudId, traitName, map) {
        try {
            $8fcd6043f3720ecf$var$smartCardStorage.setItemWithExpiry($8fcd6043f3720ecf$var$pctMapStorageItemKey(cloudId, traitName), map, (0, $c26fn.personalizationConstants).PERSONALIZATION_PROVIDER_PCT_TTL_MS);
        } catch  {
        // Quota, private-mode, etc.
        }
    }
    normalizeProviderPctMap(value) {
        if (typeof value !== 'object' || value === null || Array.isArray(value)) return null;
        const map = {};
        const entries = Object.entries(value);
        for (const [providerKey, percentageRaw] of entries){
            if (typeof percentageRaw !== 'number' || !Number.isFinite(percentageRaw)) return null;
            map[providerKey] = percentageRaw;
        }
        return map;
    }
    parseTraitValue(raw) {
        if (typeof raw !== 'string') return undefined;
        try {
            const parsed = JSON.parse(raw);
            const normalized = this.normalizeProviderPctMap(parsed);
            return normalized === null ? undefined : normalized;
        } catch  {
            return undefined;
        }
    }
    clearCache() {
        this.cache.clear();
        this.clearStoredProviderPctMaps();
    }
    clearStoredProviderPctMaps() {
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        if (typeof globalThis.localStorage === 'undefined' || globalThis.localStorage === null) return;
        const keysToRemove = [];
        // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
        for(let index = 0; index < globalThis.localStorage.length; index += 1){
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            const key = globalThis.localStorage.key(index);
            if (key !== null && key.startsWith($8fcd6043f3720ecf$var$LOCAL_STORAGE_ROW_KEY_PREFIX)) keysToRemove.push(key);
        }
        for (const key of keysToRemove)try {
            // eslint-disable-next-line @atlaskit/platform/no-direct-web-storage-usage -- existing usage
            globalThis.localStorage.removeItem(key);
        } catch  {
        /* ignore */ }
    }
    constructor(){
        this.cache = new Map();
    }
}

});



parcelRegister("9XpQE", function(module, exports) {
$parcel$export(module.exports, "getSocialProofTier", () => $1597ce462b149836$export$adbe2edcab243434);

var $13Tmh = parcelRequire("13Tmh");
const $1597ce462b149836$export$adbe2edcab243434 = (connectedPct)=>{
    if (connectedPct === undefined) return undefined;
    return connectedPct >= (0, $13Tmh.SOCIAL_PROOF_TIER_THRESHOLD) ? 'not-low' : 'low';
};

});
parcelRegister("13Tmh", function(module, exports) {
$parcel$export(module.exports, "SOCIAL_PROOF_3P_UNAUTH_BLOCK_EXPERIMENT_KEY", () => $3ceeb5a5e7a4b98a$export$4d1c9f059e1da2cc);
$parcel$export(module.exports, "SOCIAL_PROOF_TIER_THRESHOLD", () => $3ceeb5a5e7a4b98a$export$e85fe820223563f3);
$parcel$export(module.exports, "default", () => $3ceeb5a5e7a4b98a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $aEmSo = parcelRequire("aEmSo");

var $cMZ73 = parcelRequire("cMZ73");

var $9XpQE = parcelRequire("9XpQE");
const $3ceeb5a5e7a4b98a$export$4d1c9f059e1da2cc = 'social_proof_3p_unauth_block_exp';
const $3ceeb5a5e7a4b98a$export$e85fe820223563f3 = 30;
/**
 * Returns enrollment and treatment state for the social proof unauth block card experiment.
 *
 * Delegates data-fetching to `useSocialProof` (Sasha's shared service layer),
 * which handles cloudId resolution, TAP trait fetch, localStorage caching,
 * request deduping, and sync reads.
 *
 * This hook adds the experiment/cohort layer on top:
 * - Only fires exposure (via editorExperiment) when data has loaded.
 * - Derives `tier` and `isTreatment` for rendering decisions.
 *
 * Expected to be called only inside the fg-enabled branch (via componentWithFG).
 *
 * @param extensionKey - The extensionKey of the current 3P provider (e.g. 'google-object-provider').
 */ const $3ceeb5a5e7a4b98a$var$useSocialProofExperiment = (extensionKey, baseUriWithNoTrailingSlash = '')=>{
    const { connectedPct: connectedPct, isEnabled: isEnabled, isLoading: isLoading } = (0, $cMZ73.default)(extensionKey, true, baseUriWithNoTrailingSlash);
    return (0, $fc4bM.useMemo)(()=>{
        const hasSocialProofData = connectedPct !== undefined;
        // Only fire exposure when data has loaded (prevents exposure inflation)
        const isTreatment = isEnabled && !isLoading && hasSocialProofData ? (0, $aEmSo.expValEquals)($3ceeb5a5e7a4b98a$export$4d1c9f059e1da2cc, 'isEnabled', true) : false;
        const tier = (0, $9XpQE.getSocialProofTier)(connectedPct) ?? 'low';
        return {
            isTreatment: isTreatment,
            tier: tier,
            connectedPct: connectedPct,
            isLoading: isLoading
        };
    }, [
        isEnabled,
        isLoading,
        connectedPct
    ]);
};
var $3ceeb5a5e7a4b98a$export$2e2bcd8739ae039 = $3ceeb5a5e7a4b98a$var$useSocialProofExperiment;

});
parcelRegister("cMZ73", function(module, exports) {
$parcel$export(module.exports, "default", () => $50115a17d4a26b4f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $gTn0u = parcelRequire("gTn0u");

var $jpZmV = parcelRequire("jpZmV");

var $c26fn = parcelRequire("c26fn");

var $48cNn = parcelRequire("48cNn");

var $3hJbp = parcelRequire("3hJbp");

var $2jOTt = parcelRequire("2jOTt");
const $50115a17d4a26b4f$var$NOT_ENABLED_RESULT = {
    connectedPct: undefined,
    isEnabled: false,
    isLoading: false
};
/**
 * Cache-first social proof hook.
 *
 * On mount:
 * 1. Reads localStorage synchronously via `getProviderPctMapSync`.
 *    - If data exists (warm cache): sets `providerPctMap` immediately, `isLoading = false`.
 *    - If no data (cold cache): leaves `providerPctMap` undefined, `isLoading = false`.
 * 2. Always kicks off an async fetch (fire-and-forget) via `getProviderPctMap` to populate
 *    localStorage for next page load. Does NOT update state with the async result.
 *
 * This means:
 * - First page visit (cold): no social proof rendered, no experiment exposure fired.
 *   Background fetch populates localStorage for next time.
 * - Second page visit (warm): social proof renders from localStorage, after hydration
 *   when the platform_sl_hydration_safe_content experiment is enabled (immediately on client-only mounts).
 *   Background refresh keeps localStorage fresh.
 *
 * Callers decide separately (e.g. via Statsig experiment) whether to surface the data.
 */ const $50115a17d4a26b4f$var$useSocialProof = (extensionKey, isKillswitchOn = false, baseUriWithNoTrailingSlash = '')=>{
    const isEnabled = isKillswitchOn;
    const shouldUseHydrationSafeContent = (0, $2jOTt.default)(isEnabled);
    const [snapshot] = (0, $fc4bM.useState)(()=>{
        if (!isEnabled) return {
            cloudId: undefined,
            providerPctMap: null
        };
        const cloudId = (0, $jpZmV.getCurrentSiteCloudIdSync)(baseUriWithNoTrailingSlash);
        return {
            cloudId: cloudId,
            providerPctMap: (0, $3hJbp.getProviderPctMapSync)(cloudId, (0, $c26fn.personalizationConstants).SOCIAL_PROOF_TRAIT_NAME)
        };
    });
    // Fire-and-forget: warm caches for future mounts only. Never update this mount's treatment UI.
    (0, $fc4bM.useEffect)(()=>{
        if (!isEnabled) return;
        (0, $gTn0u.getCurrentSiteCloudId)(baseUriWithNoTrailingSlash).then((cloudId)=>{
            (0, $48cNn.getProviderPctMap)(cloudId, (0, $c26fn.personalizationConstants).SOCIAL_PROOF_TRAIT_NAME);
        });
    }, [
        baseUriWithNoTrailingSlash,
        isEnabled
    ]);
    return (0, $fc4bM.useMemo)(()=>{
        if (shouldUseHydrationSafeContent) // SSR cannot access this browser's cache. Match its fallback through hydration
        // before revealing the mount-stable snapshot; async refresh still affects future mounts only.
        return $50115a17d4a26b4f$var$NOT_ENABLED_RESULT;
        if (!isEnabled) return $50115a17d4a26b4f$var$NOT_ENABLED_RESULT;
        return {
            connectedPct: extensionKey && snapshot.providerPctMap ? snapshot.providerPctMap[extensionKey] : undefined,
            isEnabled: Boolean(snapshot.cloudId && snapshot.providerPctMap),
            isLoading: false // sync read is instant; never in "loading" state
        };
    }, [
        extensionKey,
        isEnabled,
        shouldUseHydrationSafeContent,
        snapshot
    ]);
};
var $50115a17d4a26b4f$export$2e2bcd8739ae039 = $50115a17d4a26b4f$var$useSocialProof;

});
parcelRegister("48cNn", function(module, exports) {
$parcel$export(module.exports, "getProviderPctMap", () => $67b508ae7a0824dc$export$fed0d3ced5218947);

var $jrpNY = parcelRequire("jrpNY");
const $67b508ae7a0824dc$export$fed0d3ced5218947 = (cloudId, traitName)=>(0, $jrpNY.personalizationService).getProviderPctMap(cloudId, traitName);

});






parcelRegister("dlSZI", function(module, exports) {
$parcel$export(module.exports, "AuthorizeAction", () => $422e393a2769919d$export$34cef2b72294bd84);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");
const $422e393a2769919d$export$34cef2b72294bd84 = (onAuthorize, providerName)=>({
        appearance: 'primary',
        name: (0, $j9rqA.ActionName).CustomAction,
        content: providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...(0, $ewFKq.messages).connect_unauthorised_account_action,
            values: {
                context: providerName
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).connect_link_account_card),
        onClick: onAuthorize,
        testId: 'smart-action-connect-account'
    });

});

parcelRegister("aBvY5", function(module, exports) {
module.exports = new URL("../images/general@2x.8b524499.png", import.meta.url).toString();

});

parcelRegister("cuYD1", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a4008bffe2dc550$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $dBtOK = parcelRequire("dBtOK");

var $k8Adr = parcelRequire("k8Adr");

var $ewFKq = parcelRequire("ewFKq");
// TODO: remove when social-proof-3p-unauth-block-fg is cleaned up
const $1a4008bffe2dc550$var$SocialProofMessage = ({ tier: tier, connectedPct: connectedPct, providerName: providerName, testId: testId = 'smart-block-social-proof-message' })=>{
    const message = tier === 'not-low' ? (0, $ewFKq.messages).pre_auth_block_social_proof_not_low : (0, $ewFKq.messages).pre_auth_block_social_proof_low;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...message,
        values: {
            percentage: connectedPct ?? 0,
            provider: providerName,
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
                    as: "strong",
                    weight: "bold"
                }, chunks)
        }
    }));
};
var $1a4008bffe2dc550$export$2e2bcd8739ae039 = $1a4008bffe2dc550$var$SocialProofMessage;

});



parcelRegister("8I0WZ", function(module, exports) {
$parcel$export(module.exports, "EmbedCard", () => $d7c915cdc694720c$export$6789d7ecdc77631b);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $d7r8x = parcelRequire("d7r8x");

var $hiN0m = parcelRequire("hiN0m");

var $bKC9V = parcelRequire("bKC9V");

var $khTy5 = parcelRequire("khTy5");

var $96gGh = parcelRequire("96gGh");

var $9575Q = parcelRequire("9575Q");

var $9oqjm = parcelRequire("9oqjm");

var $dnVHi = parcelRequire("dnVHi");

var $lddQC = parcelRequire("lddQC");

var $jC1og = parcelRequire("jC1og");

var $8pvh1 = parcelRequire("8pvh1");

var $80nLx = parcelRequire("80nLx");

var $6KZ0w = parcelRequire("6KZ0w");

var $gU6bM = parcelRequire("gU6bM");

var $10uKt = parcelRequire("10uKt");

var $1PlSQ = parcelRequire("1PlSQ");
const $d7c915cdc694720c$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: "smart-card-embed-card"
    }), children);
const $d7c915cdc694720c$export$6789d7ecdc77631b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(({ url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleErrorRetry: handleErrorRetry, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, isSelected: isSelected, frameStyle: frameStyle, platform: platform, onResolve: onResolve, onError: onError, testId: testId, inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, iframeUrlType: iframeUrlType, actionOptions: actionOptions, renderers: renderers, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton }, iframeRef)=>{
    var _forbiddenViewProps$c, _notFoundViewProps$co;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $96gGh.getExtensionKey)(details);
    const isProductIntegrationSupported = (0, $9575Q.hasAuthScopeOverrides)(details);
    const { shouldControlDataExport: shouldControlDataExport = false } = (0, $9oqjm.useControlDataExportConfig)();
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($d7c915cdc694720c$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jC1og.default), {
                url: url,
                cardState: cardState,
                onClick: handleFrameClick,
                onError: onError,
                onResolve: onResolve,
                renderers: renderers,
                actionOptions: actionOptions,
                testId: testId ? `${testId}-resolving-view` : 'embed-card-resolving-view'
            }));
        case 'resolved':
            const resolvedViewProps = (0, $bKC9V.extractEmbedProps)(details, platform, iframeUrlType);
            if (onResolve) {
                var _resolvedViewProps$pr, _details$meta;
                onResolve({
                    title: resolvedViewProps.title,
                    url: url,
                    aspectRatio: (_resolvedViewProps$pr = resolvedViewProps.preview) === null || _resolvedViewProps$pr === void 0 ? void 0 : _resolvedViewProps$pr.aspectRatio,
                    extensionKey: details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key
                });
            }
            if ((0, $lddQC.getIsDataExportEnabled)(shouldControlDataExport, cardState.details)) {
                const unauthViewProps = (0, $bKC9V.extractEmbedProps)(details, platform);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1PlSQ.default), {
                    context: unauthViewProps.context,
                    extensionKey: extensionKey,
                    frameStyle: frameStyle,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    inheritDimensions: inheritDimensions,
                    isSelected: isSelected,
                    onAuthorize: handleAuthorize,
                    onClick: handleFrameClick,
                    testId: testId,
                    url: unauthViewProps.link
                });
            }
            if (resolvedViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $10uKt.EmbedCardResolvedView), {
                ...resolvedViewProps,
                actionOptions: actionOptions,
                details: details,
                isSelected: isSelected,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                // Other states (e.g. "resolving") could be added later for completeness.
                onAuxClick: handleFrameAuxClick,
                onContextMenu: handleFrameContextMenu,
                ref: iframeRef,
                onIframeDwell: onIframeDwell,
                onIframeFocus: onIframeFocus,
                onIframeMouseEnter: onIframeMouseEnter,
                onIframeMouseLeave: onIframeMouseLeave,
                testId: testId,
                CompetitorPrompt: CompetitorPrompt,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton,
                extensionKey: extensionKey
            });
            else {
                if (platform === 'mobile') {
                    const resolvedInlineViewProps = (0, $khTy5.extractInlineProps)(details);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8pvh1.InlineCardResolvedView), {
                        ...resolvedInlineViewProps,
                        isSelected: isSelected,
                        testId: testId,
                        onClick: handleFrameClick
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jC1og.default), {
                    url: url,
                    cardState: cardState,
                    onClick: handleFrameClick,
                    // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                    // Other states (e.g. "resolving") could be added later for completeness.
                    onAuxClick: handleFrameAuxClick,
                    onContextMenu: handleFrameContextMenu,
                    onError: onError,
                    onResolve: onResolve,
                    renderers: renderers,
                    actionOptions: actionOptions,
                    testId: testId
                });
            }
        case 'unauthorized':
            if (onError) onError({
                url: url,
                status: status
            });
            const unauthorisedViewProps = (0, $bKC9V.extractEmbedProps)(details, platform);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1PlSQ.default), {
                context: unauthorisedViewProps.context,
                extensionKey: extensionKey,
                frameStyle: frameStyle,
                isProductIntegrationSupported: isProductIntegrationSupported,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                testId: testId,
                url: unauthorisedViewProps.link
            });
        case 'forbidden':
            if (onError) onError({
                url: url,
                status: status
            });
            const forbiddenViewProps = (0, $bKC9V.extractEmbedProps)(details, platform);
            const cardMetadata = (details === null || details === void 0 ? void 0 : details.meta) ?? (0, $dnVHi.getForbiddenJsonLd)().meta;
            if (forbiddenViewProps.preview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $10uKt.EmbedCardResolvedView), {
                ...forbiddenViewProps,
                title: forbiddenViewProps.link,
                frameStyle: frameStyle,
                isSelected: isSelected,
                inheritDimensions: inheritDimensions,
                onClick: handleFrameClick,
                ref: iframeRef,
                extensionKey: extensionKey
            });
            const forbiddenAccessContext = (0, $hiN0m.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: ((_forbiddenViewProps$c = forbiddenViewProps.context) === null || _forbiddenViewProps$c === void 0 ? void 0 : _forbiddenViewProps$c.text) ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6KZ0w.default), {
                context: forbiddenViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onAuthorize: handleAuthorize,
                onClick: handleFrameClick,
                accessContext: forbiddenAccessContext,
                url: forbiddenViewProps.link
            });
        case 'not_found':
            if (onError) onError({
                url: url,
                status: status
            });
            const notFoundViewProps = (0, $bKC9V.extractEmbedProps)(details, platform);
            const notFoundAccessContext = details !== null && details !== void 0 && details.meta ? (0, $hiN0m.extractRequestAccessContextImproved)({
                jsonLd: details === null || details === void 0 ? void 0 : details.meta,
                url: url,
                product: ((_notFoundViewProps$co = notFoundViewProps.context) === null || _notFoundViewProps$co === void 0 ? void 0 : _notFoundViewProps$co.text) ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            }) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gU6bM.default), {
                context: notFoundViewProps.context,
                frameStyle: frameStyle,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected,
                onClick: handleFrameClick,
                accessContext: notFoundAccessContext,
                url: notFoundViewProps.link
            });
        case 'fallback':
        case 'errored':
        default:
            if (onError) onError({
                url: url,
                status: status
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $80nLx.EmbedCardErroredView), {
                onRetry: handleErrorRetry,
                inheritDimensions: inheritDimensions,
                isSelected: isSelected
            });
    }
});

});
parcelRegister("bKC9V", function(module, exports) {
$parcel$export(module.exports, "extractEmbedProps", () => $cd6ea06b5af64b2d$export$d6cf81ca6e68bcc3);

var $kSVgB = parcelRequire("kSVgB");

var $9b5Ea = parcelRequire("9b5Ea");

var $cbtbS = parcelRequire("cbtbS");

var $lOxou = parcelRequire("lOxou");

var $i7JiD = parcelRequire("i7JiD");

var $7KUdD = parcelRequire("7KUdD");

var $2bNyC = parcelRequire("2bNyC");

var $8CG9h = parcelRequire("8CG9h");

var $85Ivk = parcelRequire("85Ivk");
const $cd6ea06b5af64b2d$export$d6cf81ca6e68bcc3 = (response, _platform, iframeUrlType)=>{
    const meta = response === null || response === void 0 ? void 0 : response.meta;
    const jsonLd = (response === null || response === void 0 ? void 0 : response.data) || (0, $i7JiD.getEmptyJsonLd)();
    return {
        link: (0, $cbtbS.extractSmartLinkUrl)(response) || '',
        title: (0, $9b5Ea.extractSmartLinkTitle)(response),
        context: (0, $85Ivk.extractSmartLinkContext)(response),
        preview: (0, $kSVgB.extractSmartLinkEmbed)(response, iframeUrlType),
        isTrusted: (0, $8CG9h.extractIsTrusted)(meta),
        isSupportProductContext: (0, $7KUdD.extractIsSupportProductContext)(meta),
        isSupportTheming: (0, $2bNyC.extractIsSupportTheming)(meta),
        type: (0, $lOxou.extractType)(jsonLd)
    };
};

});
parcelRegister("i7JiD", function(module, exports) {
$parcel$export(module.exports, "getEmptyJsonLd", () => $2168d6d16dc1cb1f$export$2796a804c6e44f63);

var $8aoX8 = parcelRequire("8aoX8");
const $2168d6d16dc1cb1f$export$2796a804c6e44f63 = ()=>(0, $8aoX8.emptyData);

});

parcelRegister("7KUdD", function(module, exports) {
$parcel$export(module.exports, "extractIsSupportProductContext", () => $dab58a3f5a2b2507$export$f7118f5dc6fab21a);

var $5zI23 = parcelRequire("5zI23");
const $dab58a3f5a2b2507$export$f7118f5dc6fab21a = (meta)=>{
    return Boolean((meta === null || meta === void 0 ? void 0 : meta.key) && (0, $5zI23.PROVIDER_KEYS_WITH_HOSTPRODUCT_CONTEXT).includes(meta.key));
};

});

parcelRegister("85Ivk", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkContext", () => $ad4c8f761670b296$export$6ec4b6b24dec9156);

var $2okdt = parcelRequire("2okdt");

var $5NVZG = parcelRequire("5NVZG");

var $6G8gX = parcelRequire("6G8gX");

var $dRkX9 = parcelRequire("dRkX9");

var $i7JiD = parcelRequire("i7JiD");

var $l4sHT = parcelRequire("l4sHT");
function $ad4c8f761670b296$export$6ec4b6b24dec9156(response) {
    if ((0, $6G8gX.isEntityPresent)(response)) {
        if ((0, $dRkX9.fg)('platform_lp_use_generator_icon_for_provider')) {
            const entityProvider = (0, $5NVZG.extractEntityProvider)(response);
            if (!entityProvider) return undefined;
            const entityIcon = (0, $2okdt.extractEntityIcon)(response);
            return {
                ...entityProvider,
                icon: (entityIcon === null || entityIcon === void 0 ? void 0 : entityIcon.url) ?? entityProvider.icon,
                iconLabel: (entityIcon === null || entityIcon === void 0 ? void 0 : entityIcon.label) ?? entityProvider.iconLabel,
                providerIcon: entityProvider.icon,
                providerIconLabel: entityProvider.iconLabel
            };
        }
        return (0, $5NVZG.extractEntityProvider)(response);
    }
    return (0, $l4sHT.generateContext)((response === null || response === void 0 ? void 0 : response.data) || (0, $i7JiD.getEmptyJsonLd)());
}

});
parcelRegister("l4sHT", function(module, exports) {
$parcel$export(module.exports, "generateContext", () => $a63f012142ad7d16$export$8dcb07487061d3c1);

var $7fCRQ = parcelRequire("7fCRQ");

var $6Eo84 = parcelRequire("6Eo84");

var $6Hxqo = parcelRequire("6Hxqo");

var $dGpse = parcelRequire("dGpse");
function $a63f012142ad7d16$export$8dcb07487061d3c1(jsonLd) {
    const provider = (0, $7fCRQ.extractProvider)(jsonLd);
    if (!provider) return undefined;
    // If no icon is supplied, return existing context
    if (!jsonLd.icon) return provider;
    const generator = jsonLd.generator;
    const icon = (0, $dGpse.prioritiseIcon)({
        fileFormatIcon: undefined,
        documentTypeIcon: undefined,
        urlIcon: (0, $6Hxqo.extractUrlFromIconJsonLd)(jsonLd.icon),
        // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
        providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && (0, $6Eo84.extractProviderIcon)(generator.icon)
    });
    return {
        ...provider,
        icon: icon ? icon : provider.icon
    };
}

});



parcelRegister("khTy5", function(module, exports) {
$parcel$export(module.exports, "extractInlineProps", () => $b802c1a6d7f9040a$export$68e1703c529dc7e0);

var $2okdt = parcelRequire("2okdt");

var $5NVZG = parcelRequire("5NVZG");

var $7fCRQ = parcelRequire("7fCRQ");

var $haIMS = parcelRequire("haIMS");

var $9b5Ea = parcelRequire("9b5Ea");

var $cbtbS = parcelRequire("cbtbS");

var $lOxou = parcelRequire("lOxou");

var $6G8gX = parcelRequire("6G8gX");

var $bcN2K = parcelRequire("bcN2K");

var $i7JiD = parcelRequire("i7JiD");

var $4JHca = parcelRequire("4JHca");

var $i8C20 = parcelRequire("i8C20");

var $j40rd = parcelRequire("j40rd");

var $dXZgo = parcelRequire("dXZgo");

var $jaoPH = parcelRequire("jaoPH");

var $5zI23 = parcelRequire("5zI23");
const $b802c1a6d7f9040a$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $7fCRQ.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $5zI23.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $5zI23.JIRA_GENERATOR_ID)) {
            const icon = (0, $4JHca.extractIcon)(jsonLd, 'type', showIconLabel);
            if (provider.id === (0, $5zI23.JIRA_GENERATOR_ID) && typeof icon === 'string') {
                var _extractTaskType;
                const taskTypeLabel = (_extractTaskType = (0, $j40rd.extractTaskType)(jsonLd)) === null || _extractTaskType === void 0 || (_extractTaskType = _extractTaskType.name) === null || _extractTaskType === void 0 ? void 0 : _extractTaskType.trim();
                if (taskTypeLabel) return [
                    icon,
                    taskTypeLabel
                ];
            }
            return icon;
        }
    }
    return (0, $4JHca.extractIcon)(jsonLd, 'provider', showIconLabel);
};
/**
 * Should be moved to the smart link-extractor when jsonld is deprecated
 */ const $b802c1a6d7f9040a$var$extractSmartLinkInlineIcon = (response, showLabel = true)=>{
    if ((0, $6G8gX.isEntityPresent)(response)) {
        const entityIcon = (0, $2okdt.extractEntityIcon)(response);
        if (entityIcon) return [
            entityIcon.url,
            entityIcon.label
        ];
        const provider = (0, $5NVZG.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $b802c1a6d7f9040a$var$extractInlineIcon((response === null || response === void 0 ? void 0 : response.data) || (0, $i7JiD.getEmptyJsonLd)(), showLabel);
};
const $b802c1a6d7f9040a$export$68e1703c529dc7e0 = (response, renderers, removeTextHighlightingFromTitle, showLabel = true)=>{
    const jsonLd = (response === null || response === void 0 ? void 0 : response.data) || (0, $i7JiD.getEmptyJsonLd)();
    return {
        link: (0, $cbtbS.extractSmartLinkUrl)(response),
        title: (0, $9b5Ea.extractSmartLinkTitle)(response, removeTextHighlightingFromTitle),
        icon: (0, $bcN2K.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment') ? (0, $haIMS.extractSmartLinkInlineIcon)(response, showLabel) : $b802c1a6d7f9040a$var$extractSmartLinkInlineIcon(response, showLabel),
        // As we migrate to support more entities we can incorporate these fields
        lozenge: (0, $i8C20.extractLozenge)(jsonLd),
        titleTextColor: (0, $dXZgo.extractTitleTextColor)(jsonLd),
        titlePrefix: (0, $jaoPH.extractTitlePrefix)(jsonLd, renderers, 'inline'),
        type: (0, $lOxou.extractType)(jsonLd)
    };
};

});
parcelRegister("haIMS", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkInlineIcon", () => $6e91a45c400638c4$export$643db2ee2409e635);

var $fc4bM = parcelRequire("fc4bM");

var $3dgbz = parcelRequire("3dgbz");

var $lUyjF = parcelRequire("lUyjF");

var $62nNx = parcelRequire("62nNx");

var $39BPV = parcelRequire("39BPV");

var $lqopQ = parcelRequire("lqopQ");

var $7uqom = parcelRequire("7uqom");

var $4gFtZ = parcelRequire("4gFtZ");

var $d5YHt = parcelRequire("d5YHt");

var $hKYwr = parcelRequire("hKYwr");

var $1bcrw = parcelRequire("1bcrw");

var $9tj5j = parcelRequire("9tj5j");

var $8uzl9 = parcelRequire("8uzl9");

var $fvAOB = parcelRequire("fvAOB");

var $3YSuE = parcelRequire("3YSuE");

var $62KtX = parcelRequire("62KtX");

var $2IY91 = parcelRequire("2IY91");

var $2okdt = parcelRequire("2okdt");

var $5NVZG = parcelRequire("5NVZG");

var $7fCRQ = parcelRequire("7fCRQ");

var $6Hxqo = parcelRequire("6Hxqo");

var $c64OT = parcelRequire("c64OT");

var $kOAZg = parcelRequire("kOAZg");

var $6G8gX = parcelRequire("6G8gX");
const $6e91a45c400638c4$var$extractorPriorityMap = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};
const $6e91a45c400638c4$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $6e91a45c400638c4$var$getEmptyJsonLd = ()=>$6e91a45c400638c4$var$emptyData;
const $6e91a45c400638c4$var$prioritiseIcon = ({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon })=>urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
const $6e91a45c400638c4$var$extractTaskType = (jsonLd)=>{
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $6Hxqo.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};
const $6e91a45c400638c4$var$extractFileFormat = (jsonLd)=>jsonLd['schema:fileFormat'];

const $6e91a45c400638c4$var$getBlogIconWrapped = ()=>(parcelRequire("ft0OK")).default;

const $6e91a45c400638c4$var$getDocumentIcon = ()=>(parcelRequire("7lIjF")).default;

const $6e91a45c400638c4$var$getFileIcon = ()=>(parcelRequire("7FUL7")).default;

const $6e91a45c400638c4$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("dnpne")).default;

const $6e91a45c400638c4$var$getPresentationIcon = ()=>(parcelRequire("aRWSh")).default;

const $6e91a45c400638c4$var$getSpreadsheetIcon = ()=>(parcelRequire("2194u")).default;
const $6e91a45c400638c4$var$digitalDocumentToIcon = (opts)=>{
    var _opts$provider;
    if ((_opts$provider = opts.provider) !== null && _opts$provider !== void 0 && _opts$provider.id && (0, $kOAZg.isConfluenceGenerator)(opts.provider.id)) {
        const LiveDocumentIconWrapped = $6e91a45c400638c4$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(LiveDocumentIconWrapped, {
            label: opts.showIconLabel ? 'live document' : '',
            testId: "live-doc-icon"
        });
    }
    const FileIcon = $6e91a45c400638c4$var$getFileIcon();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(FileIcon, {
        label: opts.showIconLabel ? 'file' : '',
        testId: "file-icon"
    });
};
const $6e91a45c400638c4$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                const BlogIconWrapped = $6e91a45c400638c4$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(BlogIconWrapped, {
                    label: opts.showIconLabel ? 'blog' : '',
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $6e91a45c400638c4$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $6e91a45c400638c4$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(DocumentIcon, {
                    label: opts.showIconLabel ? 'document' : '',
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $6e91a45c400638c4$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(PresentationIcon, {
                    label: opts.showIconLabel ? 'presentation' : '',
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $6e91a45c400638c4$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(SpreadsheetIcon, {
                    label: opts.showIconLabel ? 'spreadsheet' : '',
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dgbz))), {
                color: "currentColor",
                label: opts.showIconLabel ? 'template' : '',
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $6e91a45c400638c4$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(DocumentIcon, {
                    label: opts.showIconLabel ? 'document' : '',
                    testId: "document-icon"
                });
            }
    }
};
const $6e91a45c400638c4$var$extractIconFromDocument = (type, opts)=>{
    const iconFromType = $6e91a45c400638c4$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $c64OT.getIconForFileType)(opts.fileFormat, opts.showIconLabel) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $6e91a45c400638c4$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $6e91a45c400638c4$var$extractIconFromTask = (opts)=>{
    const { taskType: taskType, provider: provider } = opts;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3YSuE.default), {
        label: "Task",
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $2IY91.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $2IY91.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3YSuE.default), {
                    label: "Task",
                    testId: "jira-task-icon"
                });
            case 0, $2IY91.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fvAOB.default), {
                    label: "Sub-task",
                    testId: "jira-subtask-icon"
                });
            case 0, $2IY91.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8uzl9.default), {
                    label: "Story",
                    testId: "jira-story-icon"
                });
            case 0, $2IY91.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $39BPV.default), {
                    label: "Bug",
                    testId: "jira-bug-icon"
                });
            case 0, $2IY91.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d5YHt.default), {
                    label: "Epic",
                    testId: "jira-epic-icon"
                });
            case 0, $2IY91.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hKYwr.default), {
                    label: "Incident",
                    testId: "jira-incident-icon"
                });
            case 0, $2IY91.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $62KtX.default), {
                    label: "Service request",
                    testId: "jira-service-request-icon"
                });
            case 0, $2IY91.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lqopQ.default), {
                    label: "Change",
                    testId: "jira-change-icon"
                });
            case 0, $2IY91.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1bcrw.default), {
                    label: "Problem",
                    testId: "jira-problem-icon"
                });
            case 0, $2IY91.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};
const $6e91a45c400638c4$var$typeToIcon = (type, opts)=>{
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4gFtZ.default), {
                label: "commit",
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lUyjF))), {
                label: "project",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9tj5j.default), {
                label: "pull request",
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $62nNx.default), {
                label: "reference",
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7uqom.default), {
                label: "repository",
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3YSuE.default), {
                label: "goal",
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return $6e91a45c400638c4$var$extractIconFromTask(opts);
        default:
            return undefined;
    }
};
const $6e91a45c400638c4$var$standardisedExtractIcon = (type, opts)=>{
    const iconFromType = $6e91a45c400638c4$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $c64OT.getIconForFileType)(opts.fileFormat, opts.showIconLabel) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return $6e91a45c400638c4$var$prioritiseIcon({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $6e91a45c400638c4$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return $6e91a45c400638c4$var$extractIconFromDocument(type, opts);
        default:
            return type ? $6e91a45c400638c4$var$standardisedExtractIcon(type, opts) : undefined;
    }
};
const $6e91a45c400638c4$var$extractIcon = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        provider: (0, $7fCRQ.extractProvider)(jsonLd),
        fileFormat: $6e91a45c400638c4$var$extractFileFormat(jsonLd),
        taskType: $6e91a45c400638c4$var$extractTaskType(jsonLd),
        icon: jsonLd.icon && (0, $6Hxqo.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>$6e91a45c400638c4$var$extractorPriorityMap[b] - $6e91a45c400638c4$var$extractorPriorityMap[a])[0];
        return $6e91a45c400638c4$var$extractIconByType(highestPriorityType, opts);
    } else return $6e91a45c400638c4$var$extractIconByType(type, opts);
};
const $6e91a45c400638c4$var$extractInlineIcon = (jsonLd, showIconLabel = true)=>{
    const provider = (0, $7fCRQ.extractProvider)(jsonLd);
    if (provider && provider.id) {
        if (provider.id === (0, $2IY91.CONFLUENCE_GENERATOR_ID) || provider.id === (0, $2IY91.JIRA_GENERATOR_ID)) return $6e91a45c400638c4$var$extractIcon(jsonLd, 'type', showIconLabel);
    }
    return $6e91a45c400638c4$var$extractIcon(jsonLd, 'provider', showIconLabel);
};
const $6e91a45c400638c4$export$643db2ee2409e635 = (response, showLabel = true)=>{
    if ((0, $6G8gX.isEntityPresent)(response)) {
        const entityIcon = (0, $2okdt.extractEntityIcon)(response);
        if (entityIcon) return [
            entityIcon.url,
            entityIcon.label
        ];
        const provider = (0, $5NVZG.extractEntityProvider)(response);
        if (provider) return provider.icon;
    }
    return $6e91a45c400638c4$var$extractInlineIcon((response === null || response === void 0 ? void 0 : response.data) || $6e91a45c400638c4$var$getEmptyJsonLd(), showLabel);
};

});
parcelRegister("c64OT", function(module, exports) {
$parcel$export(module.exports, "getIconForFileType", () => $6119a20b8f3e42ae$export$4d685c85ebc7a1e3);

var $fc4bM = parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $2IY91 = parcelRequire("2IY91");

var $4bvEn = parcelRequire("4bvEn");






















const $6119a20b8f3e42ae$var$getLazyIcons = ()=>({
        [(0, $2IY91.IconType).Document]: {
            default: ()=>Promise.resolve((parcelRequire("7lIjF")))
        },
        [(0, $2IY91.IconType).Audio]: {
            default: ()=>(parcelRequire("h3Zkz"))
        },
        [(0, $2IY91.IconType).Code]: {
            default: ()=>(parcelRequire("nhfLu"))
        },
        [(0, $2IY91.IconType).File]: {
            default: ()=>Promise.resolve((parcelRequire("7FUL7")))
        },
        [(0, $2IY91.IconType).Folder]: {
            default: ()=>(parcelRequire("fRZPv"))
        },
        [(0, $2IY91.IconType).Generic]: {
            default: ()=>Promise.resolve((parcelRequire("7FUL7")))
        },
        [(0, $2IY91.IconType).Image]: {
            default: ()=>(parcelRequire("gF8gF"))
        },
        [(0, $2IY91.IconType).Presentation]: {
            default: ()=>Promise.resolve((parcelRequire("aRWSh")))
        },
        [(0, $2IY91.IconType).Spreadsheet]: {
            default: ()=>Promise.resolve((parcelRequire("2194u")))
        },
        [(0, $2IY91.IconType).Video]: {
            default: ()=>(parcelRequire("guaIs"))
        },
        [(0, $2IY91.IconType).Archive]: {
            default: ()=>(parcelRequire("eZKNa"))
        },
        [(0, $2IY91.IconType).Executable]: {
            default: ()=>(parcelRequire("asxw6"))
        },
        [(0, $2IY91.IconType).GIF]: {
            default: ()=>(parcelRequire("j3rqz"))
        },
        [(0, $2IY91.IconType).GoogleDocs]: {
            default: ()=>(parcelRequire("jK91O"))
        },
        [(0, $2IY91.IconType).GoogleForms]: {
            default: ()=>(parcelRequire("8zwRB"))
        },
        [(0, $2IY91.IconType).GoogleSheets]: {
            default: ()=>(parcelRequire("2e19l"))
        },
        [(0, $2IY91.IconType).GoogleSlides]: {
            default: ()=>(parcelRequire("grrbo"))
        },
        [(0, $2IY91.IconType).MSExcel]: {
            default: ()=>(parcelRequire("9xR2y"))
        },
        [(0, $2IY91.IconType).MSPowerpoint]: {
            default: ()=>(parcelRequire("kH4hQ"))
        },
        [(0, $2IY91.IconType).MSWord]: {
            default: ()=>(parcelRequire("h12jg"))
        },
        [(0, $2IY91.IconType).PDF]: {
            default: ()=>(parcelRequire("1CQqY"))
        },
        [(0, $2IY91.IconType).Sketch]: {
            default: ()=>(parcelRequire("dx0f6"))
        }
    });
const $6119a20b8f3e42ae$var$getTypeToIconMap = (fileFormat)=>{
    var _lazyIcons$iconDescri;
    const iconDescriptor = (0, $4bvEn.default)(fileFormat);
    if (!(iconDescriptor !== null && iconDescriptor !== void 0 && iconDescriptor.icon)) return null;
    const lazyIcons = $6119a20b8f3e42ae$var$getLazyIcons();
    return [
        (_lazyIcons$iconDescri = lazyIcons[iconDescriptor.icon]) === null || _lazyIcons$iconDescri === void 0 ? void 0 : _lazyIcons$iconDescri.default,
        iconDescriptor.label ?? ''
    ];
};
const $6119a20b8f3e42ae$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    const icon = $6119a20b8f3e42ae$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    });
    const descriptorLabel = icon[1] || '';
    const label = showIconLabel ?? true ? descriptorLabel : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Icon, {
        testId: "document-file-format-icon",
        label: label
    });
};

});
parcelRegister("4bvEn", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d16e94974d72f69$export$2e2bcd8739ae039);

var $2IY91 = parcelRequire("2IY91");
const $2d16e94974d72f69$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(fileFormat){
        case 'folder':
            return getIconDescriptor((0, $2IY91.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $2IY91.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $2IY91.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $2IY91.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $2IY91.IconType).Spreadsheet, 'spreadsheet');
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $2IY91.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $2IY91.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $2IY91.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $2IY91.IconType).GoogleSlides, 'google slide');
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $2IY91.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $2IY91.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $2IY91.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $2IY91.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $2IY91.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $2IY91.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $2IY91.IconType).Video, 'video');
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $2IY91.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $2IY91.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $2IY91.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $2IY91.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
        case 'application/invision.prototype':
            return getIconDescriptor((0, $2IY91.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $2d16e94974d72f69$export$2e2bcd8739ae039 = $2d16e94974d72f69$var$extractFileFormatIcon;

});

parcelRegister("7lIjF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $075c7ba3a3a4d220$export$2e2bcd8739ae039);

var $dS86g = parcelRequire("dS86g");

var $5T3oc = parcelRequire("5T3oc");
const $075c7ba3a3a4d220$var$PageIconWithColor = (0, $5T3oc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($dS86g))), 'blueBold');
$075c7ba3a3a4d220$var$PageIconWithColor.displayName = 'PageIconWithColor';
var $075c7ba3a3a4d220$export$2e2bcd8739ae039 = $075c7ba3a3a4d220$var$PageIconWithColor;

});
parcelRegister("5T3oc", function(module, exports) {
$parcel$export(module.exports, "renderIconTile", () => $ef324cc408ca5700$export$87c3646d0e299cfe);

var $fc4bM = parcelRequire("fc4bM");

var $1AiIz = parcelRequire("1AiIz");

var $9KQyj = parcelRequire("9KQyj");
const $ef324cc408ca5700$var$appearanceToStandaloneIconColor = {
    blue: "var(--ds-icon-accent-blue, #357DE8)",
    blueBold: "var(--ds-icon-accent-blue, #357DE8)",
    gray: "var(--ds-icon-accent-gray, #7D818A)",
    grayBold: "var(--ds-icon-accent-gray, #7D818A)",
    green: "var(--ds-icon-accent-green, #22A06B)",
    greenBold: "var(--ds-icon-accent-green, #22A06B)",
    lime: "var(--ds-icon-accent-lime, #6A9A23)",
    limeBold: "var(--ds-icon-accent-lime, #6A9A23)",
    magenta: "var(--ds-icon-accent-magenta, #CD519D)",
    magentaBold: "var(--ds-icon-accent-magenta, #CD519D)",
    orange: "var(--ds-icon-accent-orange, #E06C00)",
    orangeBold: "var(--ds-icon-accent-orange, #E06C00)",
    purple: "var(--ds-icon-accent-purple, #AF59E1)",
    purpleBold: "var(--ds-icon-accent-purple, #AF59E1)",
    red: "var(--ds-icon-accent-red, #C9372C)",
    redBold: "var(--ds-icon-accent-red, #C9372C)",
    teal: "var(--ds-icon-accent-teal, #2898BD)",
    tealBold: "var(--ds-icon-accent-teal, #2898BD)",
    yellow: "var(--ds-icon-accent-yellow, #B38600)",
    yellowBold: "var(--ds-icon-accent-yellow, #B38600)"
};
const $ef324cc408ca5700$export$87c3646d0e299cfe = (Icon, appearance)=>{
    return ({ size: size, isTiledIcon: isTiledIcon, ...props })=>{
        const tileSize = (0, $9KQyj.transformSmartLinkSizeToIconTileSize)(size);
        if (tileSize === undefined) {
            const label = props.label ?? '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
                role: label ? 'img' : undefined,
                "aria-label": label || undefined,
                "data-testid": props.testId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Icon, {
                color: $ef324cc408ca5700$var$appearanceToStandaloneIconColor[appearance],
                label: ""
            }));
        }
        const { ...tileProps } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1AiIz.default), {
            appearance: appearance,
            icon: isTiledIcon ? (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Icon, {
                    ...iconProps,
                    spacing: "spacious"
                }) : Icon,
            size: tileSize,
            ...tileProps
        });
    };
};

});
parcelRegister("9KQyj", function(module, exports) {
$parcel$export(module.exports, "transformSmartLinkSizeToIconTileSize", () => $9300f19252d5be83$export$3acc3fb10995f020);

var $2IY91 = parcelRequire("2IY91");
const $9300f19252d5be83$export$3acc3fb10995f020 = (size)=>{
    switch(size){
        case (0, $2IY91.SmartLinkSize).Small:
        case (0, $2IY91.SmartLinkSize).Medium:
            return undefined;
        case (0, $2IY91.SmartLinkSize).XLarge:
        case (0, $2IY91.SmartLinkSize).Large:
            return 'small';
        default:
            return undefined;
    }
};

});



parcelRegister("h3Zkz", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4HWUv").then(()=>parcelRequire('tUjSk'));

});
parcelRegister("9dnsd", function(module, exports) {
"use strict";

function $6b57856c7829fee2$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("5WWY2")).resolve(id));
}
module.exports = $6b57856c7829fee2$var$load;

});
parcelRegister("5WWY2", function(module, exports) {
$parcel$export(module.exports, "register", () => $45501c3954b19655$export$6503ec6e8aabbaf, (v) => $45501c3954b19655$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $45501c3954b19655$export$f7ad0328861e2f03, (v) => $45501c3954b19655$export$f7ad0328861e2f03 = v);
var $45501c3954b19655$export$6503ec6e8aabbaf;
var $45501c3954b19655$export$f7ad0328861e2f03;
"use strict";
var $45501c3954b19655$var$mapping = new Map();
function $45501c3954b19655$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$45501c3954b19655$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $45501c3954b19655$var$resolve(id) {
    var resolved = $45501c3954b19655$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$45501c3954b19655$export$6503ec6e8aabbaf = $45501c3954b19655$var$register;
$45501c3954b19655$export$f7ad0328861e2f03 = $45501c3954b19655$var$resolve;

});



parcelRegister("nhfLu", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("gSayi").then(()=>parcelRequire('7yy9i'));

});

parcelRegister("7FUL7", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $3a5218f478e95af1$export$2e2bcd8739ae039);

var $3dgbz = parcelRequire("3dgbz");

var $5T3oc = parcelRequire("5T3oc");
const $3a5218f478e95af1$var$FileIconWithColor = (0, $5T3oc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($3dgbz))), 'grayBold');
$3a5218f478e95af1$var$FileIconWithColor.displayName = 'FileIconWithColor';
var $3a5218f478e95af1$export$2e2bcd8739ae039 = $3a5218f478e95af1$var$FileIconWithColor;

});

parcelRegister("fRZPv", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("aH8WB").then(()=>parcelRequire('cIA66'));

});

parcelRegister("gF8gF", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("fQOeu").then(()=>parcelRequire('cizLr'));

});

parcelRegister("aRWSh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $09144e7195f6ef13$export$2e2bcd8739ae039);

var $htOsa = parcelRequire("htOsa");

var $5T3oc = parcelRequire("5T3oc");
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $09144e7195f6ef13$var$ChartBarIconWithColor = (0, $5T3oc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($htOsa))), 'purpleBold');
$09144e7195f6ef13$var$ChartBarIconWithColor.displayName = 'ChartBarIconWithColor';
var $09144e7195f6ef13$export$2e2bcd8739ae039 = $09144e7195f6ef13$var$ChartBarIconWithColor;

});

parcelRegister("2194u", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $80cd1b50734dfdc8$export$2e2bcd8739ae039);

var $2NnGi = parcelRequire("2NnGi");

var $5T3oc = parcelRequire("5T3oc");
const $80cd1b50734dfdc8$var$ListBulletedIconWithColor = (0, $5T3oc.renderIconTile)((0, (/*@__PURE__*/$parcel$interopDefault($2NnGi))), 'greenBold');
$80cd1b50734dfdc8$var$ListBulletedIconWithColor.displayName = 'ListBulletedIconWithColor';
var $80cd1b50734dfdc8$export$2e2bcd8739ae039 = $80cd1b50734dfdc8$var$ListBulletedIconWithColor;

});

parcelRegister("guaIs", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("34scE").then(()=>parcelRequire('i9KWF'));

});

parcelRegister("eZKNa", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("fBPcn").then(()=>parcelRequire('gaVO5'));

});

parcelRegister("asxw6", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("i7YTY").then(()=>parcelRequire('aOOV6'));

});

parcelRegister("j3rqz", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("immaA").then(()=>parcelRequire('9aL41'));

});

parcelRegister("jK91O", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5Tufi").then(()=>parcelRequire('hKJmY'));

});

parcelRegister("8zwRB", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("acETV").then(()=>parcelRequire('4xPeH'));

});

parcelRegister("2e19l", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("kNKw1").then(()=>parcelRequire('9oMqL'));

});

parcelRegister("grrbo", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8CQs9").then(()=>parcelRequire('NET6K'));

});

parcelRegister("9xR2y", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("6uL7F").then(()=>parcelRequire('gDwzp'));

});

parcelRegister("kH4hQ", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("7HfdY").then(()=>parcelRequire('3lrDt'));

});

parcelRegister("h12jg", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("4MoPs").then(()=>parcelRequire('k0fs7'));

});

parcelRegister("1CQqY", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("5iocz").then(()=>parcelRequire('fzId7'));

});

parcelRegister("dx0f6", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("cxuOf").then(()=>parcelRequire('8R4C9'));

});


parcelRegister("ft0OK", function(module, exports) {
$parcel$export(module.exports, "default", () => $348a98d71edd493c$export$2e2bcd8739ae039);

var $i8H3c = parcelRequire("i8H3c");

var $dWK4M = parcelRequire("dWK4M");

var $gcwfu = parcelRequire("gcwfu");
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $348a98d71edd493c$var$BlogIconWithColor = (0, $gcwfu.renderIconPerSize)((0, $i8H3c.default), (0, $dWK4M.default));
$348a98d71edd493c$var$BlogIconWithColor.displayName = 'BlogIconWithColor';
var $348a98d71edd493c$export$2e2bcd8739ae039 = $348a98d71edd493c$var$BlogIconWithColor;

});
parcelRegister("gcwfu", function(module, exports) {
$parcel$export(module.exports, "renderIconPerSize", () => $dfd01d77f83b405f$export$28dd5ad82647c000);

var $fc4bM = parcelRequire("fc4bM");

var $2IY91 = parcelRequire("2IY91");
const $dfd01d77f83b405f$var$isIconSizeLarge = (size)=>size && [
        (0, $2IY91.SmartLinkSize).Large,
        (0, $2IY91.SmartLinkSize).XLarge
    ].includes(size);
const $dfd01d77f83b405f$export$28dd5ad82647c000 = (ObjectIcon, ObjectTileIcon)=>{
    return ({ size: size, ...props })=>{
        if ($dfd01d77f83b405f$var$isIconSizeLarge(size)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ObjectTileIcon, {
            ...props,
            size: "small"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(ObjectIcon, props);
    };
};

});


parcelRegister("dnpne", function(module, exports) {
$parcel$export(module.exports, "default", () => $8db4f70864bdde73$export$2e2bcd8739ae039);

var $cLmGU = parcelRequire("cLmGU");

var $hQly2 = parcelRequire("hQly2");

var $gcwfu = parcelRequire("gcwfu");
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $8db4f70864bdde73$var$LiveDocumentIconWithColor = (0, $gcwfu.renderIconPerSize)((0, $cLmGU.default), (0, $hQly2.default));
$8db4f70864bdde73$var$LiveDocumentIconWithColor.displayName = 'LiveDocumentIconWithColor';
var $8db4f70864bdde73$export$2e2bcd8739ae039 = $8db4f70864bdde73$var$LiveDocumentIconWithColor;

});


parcelRegister("4JHca", function(module, exports) {
$parcel$export(module.exports, "extractIcon", () => $bdbf2774abc11194$export$64bdf1f5e49e8626);

var $fc4bM = parcelRequire("fc4bM");

var $lUyjF = parcelRequire("lUyjF");

var $7fCRQ = parcelRequire("7fCRQ");

var $6Hxqo = parcelRequire("6Hxqo");

var $62nNx = parcelRequire("62nNx");

var $7uqom = parcelRequire("7uqom");

var $4gFtZ = parcelRequire("4gFtZ");

var $9tj5j = parcelRequire("9tj5j");

var $3YSuE = parcelRequire("3YSuE");

var $6xRUN = parcelRequire("6xRUN");

var $j40rd = parcelRequire("j40rd");

var $69KfR = parcelRequire("69KfR");

var $7z5UB = parcelRequire("7z5UB");

var $3ngBp = parcelRequire("3ngBp");

var $dGpse = parcelRequire("dGpse");

var $abiNE = parcelRequire("abiNE");
const $bdbf2774abc11194$export$64bdf1f5e49e8626 = (jsonLd, priority = 'type', showIconLabel = true)=>{
    const type = jsonLd['@type'];
    const opts = {
        provider: (0, $7fCRQ.extractProvider)(jsonLd),
        fileFormat: (0, $69KfR.extractFileFormat)(jsonLd),
        taskType: (0, $j40rd.extractTaskType)(jsonLd),
        icon: jsonLd.icon && (0, $6Hxqo.extractUrlFromIconJsonLd)(jsonLd.icon),
        priority: priority,
        showIconLabel: showIconLabel
    };
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $abiNE.extractorPriorityMap)[b] - (0, $abiNE.extractorPriorityMap)[a])[0];
        return $bdbf2774abc11194$var$extractIconByType(highestPriorityType, opts);
    } else return $bdbf2774abc11194$var$extractIconByType(type, opts);
};
function $bdbf2774abc11194$var$typeToIcon(type, opts) {
    switch(type){
        case 'atlassian:SourceCodeCommit':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4gFtZ.default), {
                label: "commit",
                testId: "commit-icon"
            });
        case 'atlassian:Project':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lUyjF))), {
                label: "project",
                testId: "project-icon",
                color: "currentColor"
            });
        case 'atlassian:SourceCodePullRequest':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9tj5j.default), {
                label: "pull request",
                testId: "pull-request-icon"
            });
        case 'atlassian:SourceCodeReference':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $62nNx.default), {
                label: "reference",
                testId: "branch-icon"
            });
        case 'atlassian:SourceCodeRepository':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $7uqom.default), {
                label: "repository",
                testId: "repo-icon"
            });
        case 'atlassian:Goal':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3YSuE.default), {
                label: "goal",
                testId: "task-icon"
            });
        case 'atlassian:Task':
            return (0, $3ngBp.extractIconFromTask)(opts);
        default:
            return undefined;
    }
}
function $bdbf2774abc11194$var$standardisedExtractIcon(type, opts) {
    const iconFromType = $bdbf2774abc11194$var$typeToIcon(type, opts);
    const iconFromFileFormat = opts.fileFormat ? (0, $6xRUN.getIconForFileType)(opts.fileFormat, opts.showIconLabel) : undefined;
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $dGpse.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
}
/**
 * Extracts an icon based on the given type.
 *
 * Some types return hardcoded icons, while others follow a priority list on how to pick the icon.
 * If type is not recognized, it will return the icon from the provider, or `undefined` if no icon is found.
 *
 * @param type - The type of the object.
 * @param opts - Options for the icon extraction.
 * @returns The extracted icon as a React node, or `undefined` if no icon is found.
 */ const $bdbf2774abc11194$var$extractIconByType = (type, opts)=>{
    switch(type){
        case 'Document':
        case 'schema:BlogPosting':
        case 'schema:DigitalDocument':
        case 'schema:TextDigitalDocument':
        case 'schema:PresentationDigitalDocument':
        case 'schema:SpreadsheetDigitalDocument':
        case 'atlassian:Template':
        case 'atlassian:UndefinedLink':
            return (0, $7z5UB.extractIconFromDocument)(type, opts);
        default:
            return $bdbf2774abc11194$var$standardisedExtractIcon(type, opts);
    }
};

});
parcelRegister("6xRUN", function(module, exports) {
$parcel$export(module.exports, "getIconForFileType", () => $e6766a4541dc226d$export$4d685c85ebc7a1e3);

var $fc4bM = parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $dRkX9 = parcelRequire("dRkX9");

var $h7pZU = parcelRequire("h7pZU");

var $eYOWo = parcelRequire("eYOWo");

var $fKjQL = parcelRequire("fKjQL");
const $e6766a4541dc226d$var$getTypeToIconMap = (fileFormat)=>{
    var _lazyIcons$iconDescri;
    const iconDescriptor = (0, $h7pZU.default)(fileFormat);
    if (!(iconDescriptor !== null && iconDescriptor !== void 0 && iconDescriptor.icon)) return null;
    const lazyIcons = (0, $eYOWo.getLazyIcons)();
    return [
        (_lazyIcons$iconDescri = lazyIcons[iconDescriptor.icon]) === null || _lazyIcons$iconDescri === void 0 ? void 0 : _lazyIcons$iconDescri.default,
        iconDescriptor.label ?? ''
    ];
};
const $e6766a4541dc226d$export$4d685c85ebc7a1e3 = (fileMimeType, showIconLabel)=>{
    if (!fileMimeType) return;
    let icon = $e6766a4541dc226d$var$getTypeToIconMap(fileMimeType.toLowerCase());
    if (!icon) return;
    const [importCb] = icon;
    if (!importCb) return;
    if ((0, $dRkX9.fg)('platform_sl_replace_react_loadable')) {
        var _extractFileFormatIco;
        const iconType = (_extractFileFormatIco = (0, $h7pZU.default)(fileMimeType.toLowerCase())) === null || _extractFileFormatIco === void 0 ? void 0 : _extractFileFormatIco.icon;
        if (iconType) {
            const LazyIcon = (0, $fKjQL.getLazyIconComponent)(`${iconType}:default`, importCb);
            const lazyLabel = showIconLabel ?? true ? icon[1] || '' : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(LazyIcon, {
                testId: "document-file-format-icon",
                label: lazyLabel
            });
        }
    }
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
        loader: ()=>importCb().then((module)=>module.default),
        loading: ()=>null
    }); // because we're using dynamic loading here, TS will not be able to infer the type
    const label = showIconLabel ?? true ? icon[1] || '' : '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Icon, {
        testId: "document-file-format-icon",
        label: label
    });
};

});

parcelRegister("69KfR", function(module, exports) {
$parcel$export(module.exports, "extractFileFormat", () => $0dbd0eaccabe9c58$export$f2d65f02f6888b60);
const $0dbd0eaccabe9c58$export$f2d65f02f6888b60 = (jsonLd)=>{
    return jsonLd['schema:fileFormat'];
};

});

parcelRegister("7z5UB", function(module, exports) {
$parcel$export(module.exports, "extractIconFromDocument", () => $48e1ec15a0fc2282$export$25c24c7f577936d3);

var $fc4bM = parcelRequire("fc4bM");

var $3dgbz = parcelRequire("3dgbz");

var $kOAZg = parcelRequire("kOAZg");

var $6xRUN = parcelRequire("6xRUN");

var $dGpse = parcelRequire("dGpse");

const $48e1ec15a0fc2282$var$getBlogIconWrapped = ()=>(parcelRequire("c5OI8")).default;

const $48e1ec15a0fc2282$var$getDocumentIcon = ()=>(parcelRequire("egB9d")).default;

const $48e1ec15a0fc2282$var$getFileIcon = ()=>(parcelRequire("bNyFZ")).default;

const $48e1ec15a0fc2282$var$getLiveDocumentIconWrapped = ()=>(parcelRequire("5q3t2")).default;

const $48e1ec15a0fc2282$var$getPresentationIcon = ()=>(parcelRequire("jR4gQ")).default;

const $48e1ec15a0fc2282$var$getSpreadsheetIcon = ()=>(parcelRequire("3uDvS")).default;
const $48e1ec15a0fc2282$export$25c24c7f577936d3 = (type, opts)=>{
    const iconFromType = $48e1ec15a0fc2282$var$documentTypeToIcon(type, opts);
    const iconFromFileFormat = $48e1ec15a0fc2282$var$documentFileFormatToIcon(opts);
    const iconFromProvider = opts.provider && opts.provider.icon;
    return (0, $dGpse.prioritiseIcon)({
        fileFormatIcon: iconFromFileFormat,
        documentTypeIcon: iconFromType,
        urlIcon: opts.icon,
        providerIcon: iconFromProvider
    });
};
const $48e1ec15a0fc2282$var$documentFileFormatToIcon = (opts)=>{
    if (opts.fileFormat) return (0, $6xRUN.getIconForFileType)(opts.fileFormat, opts.showIconLabel);
};
const $48e1ec15a0fc2282$var$documentLabel = (opts, label)=>{
    if (!opts.showIconLabel) return '';
    return label;
};
const $48e1ec15a0fc2282$var$documentTypeToIcon = (type, opts)=>{
    switch(type){
        case 'schema:BlogPosting':
            {
                // Intentionally keep this icon on a synchronous require()-based path.
                // This icon must be present in SSR markup so hydration does not cause a
                // visible empty-state-then-pop-in transition for Smart Links.
                const BlogIconWrapped = $48e1ec15a0fc2282$var$getBlogIconWrapped();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(BlogIconWrapped, {
                    label: $48e1ec15a0fc2282$var$documentLabel(opts, 'blog'),
                    testId: "blog-icon"
                });
            }
        case 'schema:DigitalDocument':
            return $48e1ec15a0fc2282$var$digitalDocumentToIcon(opts);
        case 'schema:TextDigitalDocument':
            {
                const DocumentIcon = $48e1ec15a0fc2282$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(DocumentIcon, {
                    label: $48e1ec15a0fc2282$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
        case 'schema:PresentationDigitalDocument':
            {
                const PresentationIcon = $48e1ec15a0fc2282$var$getPresentationIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(PresentationIcon, {
                    label: $48e1ec15a0fc2282$var$documentLabel(opts, 'presentation'),
                    testId: "presentation-icon"
                });
            }
        case 'schema:SpreadsheetDigitalDocument':
            {
                const SpreadsheetIcon = $48e1ec15a0fc2282$var$getSpreadsheetIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(SpreadsheetIcon, {
                    label: $48e1ec15a0fc2282$var$documentLabel(opts, 'spreadsheet'),
                    testId: "spreadsheet-icon"
                });
            }
        case 'atlassian:Template':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dgbz))), {
                color: "currentColor",
                label: $48e1ec15a0fc2282$var$documentLabel(opts, 'template'),
                testId: "document-filled-icon"
            });
        case 'atlassian:UndefinedLink':
            {
                const DocumentIcon = $48e1ec15a0fc2282$var$getDocumentIcon();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(DocumentIcon, {
                    label: $48e1ec15a0fc2282$var$documentLabel(opts, 'document'),
                    testId: "document-icon"
                });
            }
    }
};
/**
 * Enables providers to represent `schema:DigitalDocument` in a manner which
 * aligns with their customers when representing provider-specific types, which
 * do not apply across multiple providers.
 * @example Confluence digital documents represent 'live documents', specific to Confluence.
 * @remark This mechanism will be superseded by backend-driven icon URLs as part
 * of go/j/MODES-5864. Do not add more!
 */ const $48e1ec15a0fc2282$var$digitalDocumentToIcon = (opts)=>{
    var _opts$provider;
    if ((_opts$provider = opts.provider) !== null && _opts$provider !== void 0 && _opts$provider.id && (0, $kOAZg.isConfluenceGenerator)(opts.provider.id)) {
        // Intentionally keep this icon on a synchronous require()-based path.
        // This icon must be present in SSR markup so hydration does not cause a
        // visible empty-state-then-pop-in transition for Smart Links.
        const LiveDocumentIconWrapped = $48e1ec15a0fc2282$var$getLiveDocumentIconWrapped();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(LiveDocumentIconWrapped, {
            label: $48e1ec15a0fc2282$var$documentLabel(opts, 'live document'),
            testId: "live-doc-icon"
        });
    } else {
        const FileIcon = $48e1ec15a0fc2282$var$getFileIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(FileIcon, {
            label: $48e1ec15a0fc2282$var$documentLabel(opts, 'file'),
            testId: "file-icon"
        });
    }
};

});

parcelRegister("3ngBp", function(module, exports) {
$parcel$export(module.exports, "extractIconFromTask", () => $324d43fc3b1298c1$export$321256ed044e3100);

var $fc4bM = parcelRequire("fc4bM");

var $39BPV = parcelRequire("39BPV");

var $lqopQ = parcelRequire("lqopQ");

var $d5YHt = parcelRequire("d5YHt");

var $hKYwr = parcelRequire("hKYwr");

var $1bcrw = parcelRequire("1bcrw");

var $8uzl9 = parcelRequire("8uzl9");

var $fvAOB = parcelRequire("fvAOB");

var $3YSuE = parcelRequire("3YSuE");

var $62KtX = parcelRequire("62KtX");

var $5zI23 = parcelRequire("5zI23");
const $324d43fc3b1298c1$var$TaskIcon = (0, $3YSuE.default);
const $324d43fc3b1298c1$export$321256ed044e3100 = (opts)=>{
    // Render Atlaskit icons for all supported Jira issue types.
    const { taskType: taskType, provider: provider } = opts;
    const defaultIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($324d43fc3b1298c1$var$TaskIcon, {
        label: "Task",
        testId: "default-task-icon"
    });
    if (provider && provider.id === (0, $5zI23.JIRA_GENERATOR_ID) && taskType && taskType.id) {
        const taskTypeId = taskType.id;
        const taskTypeName = taskTypeId.split('#').pop();
        switch(taskTypeName){
            case 0, $5zI23.JIRA_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3YSuE.default), {
                    label: "Task",
                    testId: "jira-task-icon"
                });
            case 0, $5zI23.JIRA_SUB_TASK:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fvAOB.default), {
                    label: "Sub-task",
                    testId: "jira-subtask-icon"
                });
            case 0, $5zI23.JIRA_STORY:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8uzl9.default), {
                    label: "Story",
                    testId: "jira-story-icon"
                });
            case 0, $5zI23.JIRA_BUG:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $39BPV.default), {
                    label: "Bug",
                    testId: "jira-bug-icon"
                });
            case 0, $5zI23.JIRA_EPIC:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d5YHt.default), {
                    label: "Epic",
                    testId: "jira-epic-icon"
                });
            case 0, $5zI23.JIRA_INCIDENT:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hKYwr.default), {
                    label: "Incident",
                    testId: "jira-incident-icon"
                });
            case 0, $5zI23.JIRA_SERVICE_REQUEST:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $62KtX.default), {
                    label: "Service request",
                    testId: "jira-service-request-icon"
                });
            case 0, $5zI23.JIRA_CHANGE:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lqopQ.default), {
                    label: "Change",
                    testId: "jira-change-icon"
                });
            case 0, $5zI23.JIRA_PROBLEM:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1bcrw.default), {
                    label: "Problem",
                    testId: "jira-problem-icon"
                });
            case 0, $5zI23.JIRA_CUSTOM_TASK_TYPE:
                return taskType.icon || opts.icon || provider.icon || defaultIcon;
        }
    }
    return defaultIcon;
};

});


parcelRegister("dXZgo", function(module, exports) {
$parcel$export(module.exports, "extractTitleTextColor", () => $cd73ae16b0eab23e$export$a2afc198e9dada1);

var $abiNE = parcelRequire("abiNE");
const $cd73ae16b0eab23e$export$a2afc198e9dada1 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (Array.isArray(type)) {
        const highestPriorityType = type.sort((a, b)=>(0, $abiNE.extractorPriorityMap)[b] - (0, $abiNE.extractorPriorityMap)[a])[0];
        switch(highestPriorityType){
            case 'atlassian:UndefinedLink':
                return "var(--ds-text-danger, #AE2E24)";
            default:
                return undefined;
        }
    }
};

});

parcelRegister("jaoPH", function(module, exports) {
$parcel$export(module.exports, "extractTitlePrefix", () => $fd6f689740494444$export$58d9bc37318dfb32);
parcelRequire("fc4bM");
const $fd6f689740494444$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $fd6f689740494444$export$58d9bc37318dfb32 = (jsonLd, renderers, type)=>{
    const prefix = jsonLd['atlassian:titlePrefix'];
    if (prefix) // extract and return Emoji Title Prefix
    {
        if (prefix['@type'] === 'atlassian:Emoji') {
            const emojiId = $fd6f689740494444$var$sanitizeEmojiValue(prefix['text']);
            const hasEmojiPrefix = emojiId.length !== 0;
            const emojiRenderer = renderers === null || renderers === void 0 ? void 0 : renderers.emoji;
            if (hasEmojiPrefix && emojiRenderer) return emojiRenderer(emojiId, type);
        }
    }
    return undefined;
};

});


parcelRegister("8pvh1", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvedView", () => $b8833e7c8913e763$export$6d5912cb4b56390e);
parcelRequire("fc4bM");

var $gHT0S = parcelRequire("gHT0S");
const $b8833e7c8913e763$export$6d5912cb4b56390e = (0, $gHT0S.InlineCardResolvedViewFunctional);

});
parcelRegister("gHT0S", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvedViewFunctional", () => $4453c78b2eaa190d$export$4dcde1a6b9223e2e);

var $fc4bM = parcelRequire("fc4bM");

var $gUSXu = parcelRequire("gUSXu");

var $jjsJ4 = parcelRequire("jjsJ4");

var $eSfIX = parcelRequire("eSfIX");

var $5RUL3 = parcelRequire("5RUL3");

var $apOJG = parcelRequire("apOJG");

var $hseE8 = parcelRequire("hseE8");
function $4453c78b2eaa190d$export$4dcde1a6b9223e2e({ id: id, title: title = '', isSelected: isSelected, isHovered: isHovered, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, link: link, testId: testId = 'inline-card-resolved-view', titleTextColor: titleTextColor, titlePrefix: titlePrefix, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, truncateInline: truncateInline, type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton, lozenge: lozenge }) {
    const { isEnabled: isInlineTailoredRovoActionEnabled } = (0, $gUSXu.default)(link, showHoverPreview, actionOptions);
    // TODO https://hello.jira.atlassian.cloud/browse/NAVX-4436: fire analytics with cohort
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5RUL3.Frame), {
        testId: testId,
        link: link,
        isSelected: isSelected,
        isHovered: isHovered,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $apOJG.IconAndTitleLayout), {
        emoji: titlePrefix,
        icon: icon,
        title: title,
        titleTextColor: titleTextColor,
        type: type,
        hideIconLoadingSkeleton: hideIconLoadingSkeleton
    }), (0, $hseE8.renderLozenge)(lozenge), isInlineTailoredRovoActionEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eSfIX.InlineRovoActionButton), {
        testId: `${testId}-rovo-actions-cta`,
        url: link,
        actionOptions: actionOptions
    }));
    if (!showHoverPreview || !link) return frame;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jjsJ4.HoverCard), {
        id: id,
        url: link,
        actionOptions: actionOptions,
        hoverPreviewOptions: hoverPreviewOptions
    }, frame);
}

});
parcelRegister("gUSXu", function(module, exports) {
$parcel$export(module.exports, "default", () => $21aa2f9d8fa50b5f$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $f4Od9 = parcelRequire("f4Od9");

var $96gGh = parcelRequire("96gGh");

var $fzYCU = parcelRequire("fzYCU");

var $gysdQ = parcelRequire("gysdQ");
const $21aa2f9d8fa50b5f$var$ELIGIBLE_EXTENSION_KEYS = new Set([
    'slack-object-provider',
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'ms-teams-object-provider',
    'gitlab-object-provider',
    'salesforce-object-provider'
]);
const $21aa2f9d8fa50b5f$var$NOT_ENABLED_RESULT = {
    isEnabled: false
};
/**
 * Returns whether the tailored inline actions
 * are enabled for the current user and link context.
 *
 * All eligibility criteria are consolidated here:
 * 1. Rovo chat must be enabled for the tenant.
 * 2. The consumer must have opted in via actionOptions.rovoChatAction.optIn.
 * 3. The link must support the RovoActions feature.
 * 4. The extension key must be one of the supported options.
 *
 * The extension key is derived from the card store via the resolved URL,
 * so callers don't need to thread it as a prop.
 */ const $21aa2f9d8fa50b5f$var$useInlineTailoredAction = (url, showHoverPreview, actionOptions)=>{
    var _actionOptions$rovoCh;
    const { rovoOptions: rovoConfig } = (0, $gysdQ.default)();
    const isRovoChatEnabled = (0, $f4Od9.getIsRovoChatEnabled)(rovoConfig);
    const cardState = (0, $fzYCU.useSmartCardState)(url ?? '');
    const extensionKey = (0, $96gGh.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = (actionOptions === null || actionOptions === void 0 || (_actionOptions$rovoCh = actionOptions.rovoChatAction) === null || _actionOptions$rovoCh === void 0 ? void 0 : _actionOptions$rovoCh.optIn) ?? false;
    return (0, $fc4bM.useMemo)(()=>{
        if (!isRovoChatEnabled || !showHoverPreview || !url || !isRovoChatActionOptedIn) return $21aa2f9d8fa50b5f$var$NOT_ENABLED_RESULT;
        if (!extensionKey || !$21aa2f9d8fa50b5f$var$ELIGIBLE_EXTENSION_KEYS.has(extensionKey)) return $21aa2f9d8fa50b5f$var$NOT_ENABLED_RESULT;
        return {
            isEnabled: true
        };
    }, [
        isRovoChatEnabled,
        extensionKey,
        showHoverPreview,
        url,
        isRovoChatActionOptedIn
    ]);
};
var $21aa2f9d8fa50b5f$export$2e2bcd8739ae039 = $21aa2f9d8fa50b5f$var$useInlineTailoredAction;

});

parcelRegister("eSfIX", function(module, exports) {
$parcel$export(module.exports, "InlineRovoActionButton", () => $b8ed79c60c9b85d0$export$47ac6a4b603479b6);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $gpjDl = parcelRequire("gpjDl");

var $kzNPc = parcelRequire("kzNPc");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $k8Adr = parcelRequire("k8Adr");

var $95H2w = parcelRequire("95H2w");

var $96gGh = parcelRequire("96gGh");

var $cA6hx = parcelRequire("cA6hx");

var $eXUZB = parcelRequire("eXUZB");

var $gysdQ = parcelRequire("gysdQ");

var $fzYCU = parcelRequire("fzYCU");

var $hcvQy = parcelRequire("hcvQy");

var $9eSWL = parcelRequire("9eSWL");

var $jw41l = parcelRequire("jw41l");
const $b8ed79c60c9b85d0$var$styles = {
    text: "_19bv12x7 _1e0c116y _4cvr1h6o _s7n4nkob _19pk1i6y"
};
const $b8ed79c60c9b85d0$export$47ac6a4b603479b6 = (props)=>(0, $dRkX9.fg)('platform_sl_one_click_chat_spotlight_v2_fg') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b8ed79c60c9b85d0$var$InlineRovoActionButtonWithSpotlight, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($b8ed79c60c9b85d0$var$InlineRovoActionButtonLegacy, props);
const $b8ed79c60c9b85d0$var$InlineRovoActionButtonLegacy = ({ testId: testId, url: url, actionOptions: actionOptions })=>{
    const { sendPromptMessage: sendPromptMessage, isRovoChatEnabled: isRovoChatEnabled } = (0, $eXUZB.default)();
    const intl = (0, $gpjDl.default)();
    const cardState = (0, $fzYCU.useSmartCardState)(url ?? '');
    const extensionKey = (0, $96gGh.getExtensionKey)(cardState.details);
    const rovoConfig = (0, $gysdQ.default)();
    const rovoChatAction = (0, $fc4bM.useMemo)(()=>{
        return cardState.details && (0, $95H2w.default)({
            response: cardState.details,
            actionOptions: actionOptions,
            rovoConfig: rovoConfig
        });
    }, [
        cardState.details,
        rovoConfig,
        actionOptions
    ]);
    const provider = (0, $fc4bM.useMemo)(()=>{
        return cardState.details && (0, $kzNPc.extractSmartLinkProvider)(cardState.details);
    }, [
        cardState.details
    ]);
    const invoke = (0, $cA6hx.default)({});
    const promptKey = (0, $fc4bM.useMemo)(()=>{
        var _cardState$details, _cardState$details2;
        if (extensionKey === 'google-object-provider' && (_cardState$details = cardState.details) !== null && _cardState$details !== void 0 && (_cardState$details = _cardState$details.data) !== null && _cardState$details !== void 0 && (_cardState$details = _cardState$details['@type']) !== null && _cardState$details !== void 0 && _cardState$details.includes('schema:SpreadsheetDigitalDocument')) return;
        switch(extensionKey){
            case 'google-object-provider':
                if ((_cardState$details2 = cardState.details) !== null && _cardState$details2 !== void 0 && (_cardState$details2 = _cardState$details2.data) !== null && _cardState$details2 !== void 0 && (_cardState$details2 = _cardState$details2['@type']) !== null && _cardState$details2 !== void 0 && _cardState$details2.includes('schema:PresentationDigitalDocument')) return (0, $hcvQy.RovoChatPromptKey).SUMMARIZE_PRESENTATION;
                return (0, $hcvQy.RovoChatPromptKey).SUMMARIZE_DOCUMENT;
            case 'onedrive-object-provider':
                return (0, $hcvQy.RovoChatPromptKey).SUMMARIZE_DOCUMENT;
            case 'github-object-provider':
            case 'gitlab-object-provider':
                return (0, $hcvQy.RovoChatPromptKey).EXPLAIN_CODE;
            case 'slack-object-provider':
            case 'ms-teams-object-provider':
                return (0, $hcvQy.RovoChatPromptKey).CATCH_UP;
            case 'salesforce-object-provider':
                return (0, $hcvQy.RovoChatPromptKey).SALESFORCE_PREP;
        }
    }, [
        extensionKey,
        cardState
    ]);
    const { data: promptData, content: content, icon: icon } = promptKey ? (0, $hcvQy.getPromptAction)({
        promptKey: promptKey,
        intl: intl,
        url: url,
        iconSize: 'small',
        provider: provider === null || provider === void 0 ? void 0 : provider.text
    }) || {} : {};
    const handleClick = (0, $fc4bM.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (isRovoChatEnabled && promptData && rovoChatAction !== null && rovoChatAction !== void 0 && rovoChatAction.invokeAction) invoke({
            ...rovoChatAction === null || rovoChatAction === void 0 ? void 0 : rovoChatAction.invokeAction,
            actionFn: async ()=>sendPromptMessage(promptData),
            prompt: promptKey
        });
    }, [
        sendPromptMessage,
        isRovoChatEnabled,
        promptData,
        rovoChatAction,
        promptKey,
        invoke
    ]);
    return promptData && content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9eSWL.ActionButton), {
        onClick: handleClick,
        testId: testId
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $b8ed79c60c9b85d0$var$styles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        size: "small"
    }, content))) : null;
};
const $b8ed79c60c9b85d0$var$InlineRovoActionButtonWithSpotlight = ({ testId: testId, url: url, actionOptions: actionOptions })=>{
    const { sendPromptMessage: sendPromptMessage, isRovoChatEnabled: isRovoChatEnabled } = (0, $eXUZB.default)();
    const intl = (0, $gpjDl.default)();
    const cardState = (0, $fzYCU.useSmartCardState)(url ?? '');
    const extensionKey = (0, $96gGh.getExtensionKey)(cardState.details);
    const rovoConfig = (0, $gysdQ.default)();
    const rovoChatAction = (0, $fc4bM.useMemo)(()=>{
        return cardState.details && (0, $95H2w.default)({
            response: cardState.details,
            actionOptions: actionOptions,
            rovoConfig: rovoConfig
        });
    }, [
        cardState.details,
        rovoConfig,
        actionOptions
    ]);
    const provider = (0, $fc4bM.useMemo)(()=>{
        return cardState.details && (0, $kzNPc.extractSmartLinkProvider)(cardState.details);
    }, [
        cardState.details
    ]);
    const invoke = (0, $cA6hx.default)({});
    const promptKey = (0, $fc4bM.useMemo)(()=>{
        var _cardState$details3, _cardState$details4;
        if (extensionKey === 'google-object-provider' && (_cardState$details3 = cardState.details) !== null && _cardState$details3 !== void 0 && (_cardState$details3 = _cardState$details3.data) !== null && _cardState$details3 !== void 0 && (_cardState$details3 = _cardState$details3['@type']) !== null && _cardState$details3 !== void 0 && _cardState$details3.includes('schema:SpreadsheetDigitalDocument')) return;
        switch(extensionKey){
            case 'google-object-provider':
                if ((_cardState$details4 = cardState.details) !== null && _cardState$details4 !== void 0 && (_cardState$details4 = _cardState$details4.data) !== null && _cardState$details4 !== void 0 && (_cardState$details4 = _cardState$details4['@type']) !== null && _cardState$details4 !== void 0 && _cardState$details4.includes('schema:PresentationDigitalDocument')) return (0, $hcvQy.RovoChatPromptKey).SUMMARIZE_PRESENTATION;
                return (0, $hcvQy.RovoChatPromptKey).SUMMARIZE_DOCUMENT;
            case 'onedrive-object-provider':
                return (0, $hcvQy.RovoChatPromptKey).SUMMARIZE_DOCUMENT;
            case 'github-object-provider':
            case 'gitlab-object-provider':
                return (0, $hcvQy.RovoChatPromptKey).EXPLAIN_CODE;
            case 'slack-object-provider':
            case 'ms-teams-object-provider':
                return (0, $hcvQy.RovoChatPromptKey).CATCH_UP;
            case 'salesforce-object-provider':
                return (0, $hcvQy.RovoChatPromptKey).SALESFORCE_PREP;
        }
    }, [
        extensionKey,
        cardState
    ]);
    const { data: promptData, content: content, icon: icon } = promptKey ? (0, $hcvQy.getPromptAction)({
        promptKey: promptKey,
        intl: intl,
        url: url,
        iconSize: 'small',
        provider: provider === null || provider === void 0 ? void 0 : provider.text
    }) || {} : {};
    const invokePrompt = (0, $fc4bM.useCallback)((interactionSource = 'inlineAction')=>{
        if (isRovoChatEnabled && promptData && rovoChatAction !== null && rovoChatAction !== void 0 && rovoChatAction.invokeAction) invoke({
            ...rovoChatAction.invokeAction,
            interactionSource: interactionSource,
            actionFn: async ()=>sendPromptMessage(promptData),
            prompt: promptKey
        });
    }, [
        sendPromptMessage,
        isRovoChatEnabled,
        promptData,
        rovoChatAction,
        promptKey,
        invoke
    ]);
    const handleClick = (0, $fc4bM.useCallback)((event)=>{
        event.preventDefault();
        event.stopPropagation();
        invokePrompt();
    }, [
        invokePrompt
    ]);
    const button = promptData && content ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9eSWL.ActionButton), {
        onClick: handleClick,
        testId: testId
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        xcss: $b8ed79c60c9b85d0$var$styles.text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        size: "small"
    }, content))) : null;
    return button && isRovoChatEnabled && rovoChatAction !== null && rovoChatAction !== void 0 && rovoChatAction.invokeAction ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jw41l.OneClickChatSpotlightLoader), {
        key: url,
        url: url,
        actionOptions: actionOptions,
        onInvoke: ()=>invokePrompt('spotlightCta')
    }, button) : button;
};

});
parcelRegister("9eSWL", function(module, exports) {
$parcel$export(module.exports, "ActionButton", () => $b0d32329ef2671d0$export$cfc7921d29ef7b80);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $dBtOK = parcelRequire("dBtOK");

var $EawnW = parcelRequire("EawnW");
const $b0d32329ef2671d0$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    innerContainerSocialProofConnect: "_2rko12b0 _syaz15cr _80omtlke _bfhkjmqp _2hwxv77o _1e0c1nu9 _4cvr1h6o _1wybtjj4 _1y1m1u8q _16d9qvcn _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _s7n4t94y _o5721btx _1nmz9jpi _irr31q28 _1di612kk",
    innerContainerNoWrap: "_o5721q9c _1nmz4jg8",
    enabled: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    disabled: "_syaz1gmx _80om13gf _bfhk187o",
    unauthorised: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _13lilb4i _mrkblb4i _ca0qt94y _n3tdt94y _2hwxt94y _k48pi7a9 _irr31q28 _1di612kk"
};
const $b0d32329ef2671d0$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', isSlimDesign: isSlimDesign = false, ...props }, ref)=>{
    const shouldUseUnauthorisedSlimStyle = viewType === 'unauthorised' && isSlimDesign;
    if (shouldUseUnauthorisedSlimStyle && !isDisabled) {
        const { onClick: onClick, ...boxProps } = props;
        return /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
            ...boxProps,
            ref: ref,
            style: {
                font: `inherit`
            },
            xcss: $b0d32329ef2671d0$var$styles.button
        }, /*#__PURE__*/ $fc4bM.createElement("span", {
            className: (0, $2R2iS.default)([
                $b0d32329ef2671d0$var$styles.innerContainerSocialProofConnect,
                $b0d32329ef2671d0$var$styles.innerContainerNoWrap
            ])
        }, children));
    }
    return /*#__PURE__*/ $fc4bM.createElement((0, $EawnW.Pressable), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // We need to reset Pressable fixed font size to allow inline card to inherit the font size
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $b0d32329ef2671d0$var$styles.button
    }, /*#__PURE__*/ $fc4bM.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $2R2iS.default)([
            $b0d32329ef2671d0$var$styles.innerContainer,
            isDisabled ? $b0d32329ef2671d0$var$styles.disabled : viewType === 'unauthorised' ? $b0d32329ef2671d0$var$styles.unauthorised : $b0d32329ef2671d0$var$styles.enabled
        ])
    }, children));
});

});

parcelRegister("jw41l", function(module, exports) {
$parcel$export(module.exports, "OneClickChatSpotlightLoader", () => $edd8ee0d540f49e8$export$b1fc6d92f1eded49);

var $fc4bM = parcelRequire("fc4bM");

function $edd8ee0d540f49e8$export$b1fc6d92f1eded49(props) {
    const [Spotlight, setSpotlight] = (0, $fc4bM.useState)();
    (0, $fc4bM.useEffect)(()=>{
        let active = true;
        (parcelRequire("kPozj")).then(({ OneClickChatSpotlight: OneClickChatSpotlight })=>{
            if (active) setSpotlight(()=>OneClickChatSpotlight);
        }).catch(()=>{
        // An optional spotlight must not break the existing inline action.
        });
        return ()=>{
            active = false;
        };
    }, []);
    return Spotlight ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Spotlight, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, props.children);
}

});
parcelRegister("kPozj", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("8fLqo").then(()=>parcelRequire('1T1di'));

});



parcelRegister("apOJG", function(module, exports) {
$parcel$export(module.exports, "IconAndTitleLayout", () => $e0c339aca18e23bd$export$d34be4d513116847);
$parcel$export(module.exports, "IconTitleWrapper", () => $e0c339aca18e23bd$export$c73a53738ef9e3f);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports share Compiled style value(s) [LinkAppearance, iconImageStyle, iconWrapperStyle, styles] which cannot be exported across files (UI Styling Standard: no-exported-css) */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $lig3b = parcelRequire("lig3b");

var $inMs5 = parcelRequire("inMs5");

var $dBtOK = parcelRequire("dBtOK");

var $4paoX = parcelRequire("4paoX");

var $eHESC = parcelRequire("eHESC");
const $e0c339aca18e23bd$var$iconWrapperStyle = null;
const $e0c339aca18e23bd$var$iconImageStyle = null;
const $e0c339aca18e23bd$var$styles = {
    iconEmptyStyle: "_1bsb7vkz _4t3i1osq _1e0c1o8l _tzy4idpf",
    iconOuterWrapperStyle: "_1e0c1o8l _2hwx1b66 _kqswh2mm",
    iconTitleWrapperStyle: "_o5721jtm _1nmz9jpi _16d9qvcn _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
    linkStyle: "_2rkolb4i",
    noLinkAppearanceStyle: "_syaz1rpy _18u01b66",
    roundImageStyle: "_2rko1rr0"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/design-system/no-html-anchor -- Ignored via go/DSP-18766
const $e0c339aca18e23bd$var$LinkAppearance = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_syaz13af _9oik1r31 _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    });
});
const $e0c339aca18e23bd$export$d34be4d513116847 = ({ icon: icon, emoji: emoji, defaultIcon: defaultIcon, onClick: onClick, children: children, title: title, titleColor: titleColor, titleTextColor: titleTextColor, link: link, rightSide: rightSide, testId: testId = 'inline-card-icon-and-title', type: type, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $fc4bM.useState)(false);
    const renderAtlaskitIcon = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        if (emoji) return emoji;
        if (!icon || typeof icon === 'string' || Array.isArray(icon)) return null;
        return icon;
    }, [
        emoji,
        icon
    ]);
    const profileType = (0, $4paoX.isProfileType)(type);
    const renderImageIcon = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((errored, testId)=>{
        if (!icon) return null;
        let iconUrl;
        let iconLabel = '';
        if (Array.isArray(icon)) {
            const [tupleIconUrl, tupleIconLabel] = icon;
            if (typeof tupleIconUrl !== 'string') return null;
            iconUrl = tupleIconUrl;
            iconLabel = typeof tupleIconLabel === 'string' ? tupleIconLabel : '';
        } else if (typeof icon === 'string') iconUrl = icon;
        else return null;
        if (hideIconLoadingSkeleton) {
            if (hasImageErrored) return errored;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("img", {
                src: iconUrl,
                "data-testid": `${testId}-image`,
                alt: iconLabel,
                onError: ()=>setHasImageErrored(true),
                className: (0, $2R2iS.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $e0c339aca18e23bd$var$styles.roundImageStyle
                ])
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lig3b))), {
            src: iconUrl,
            loaded: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("img", {
                src: iconUrl,
                "data-testid": `${testId}-image`,
                alt: iconLabel,
                className: (0, $2R2iS.default)([
                    "_c71l7vkz _p12f7vkz _1bsb1osq",
                    profileType && $e0c339aca18e23bd$var$styles.roundImageStyle
                ])
            }),
            errored: errored,
            loading: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eHESC.Shimmer), {
                testId: `${testId}-loading`
            })
        });
    }, [
        icon,
        profileType,
        hideIconLoadingSkeleton,
        hasImageErrored
    ]);
    const renderIconPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((testId)=>{
        return defaultIcon || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($inMs5))), {
            label: "link",
            testId: `${testId}-default`,
            color: "currentColor"
        });
    }, [
        defaultIcon
    ]);
    const renderIcon = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((testId)=>{
        const icon = renderAtlaskitIcon();
        if (icon) return icon;
        const placeholder = renderIconPlaceholder(testId);
        const image = renderImageIcon(placeholder, testId);
        return image || placeholder;
    }, [
        renderAtlaskitIcon,
        renderIconPlaceholder,
        renderImageIcon
    ]);
    const handleClick = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((event)=>{
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    const handleKeyPress = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((event)=>{
        if (event.key !== ' ' && event.key !== 'Enter') return;
        if (onClick) {
            event.preventDefault();
            event.stopPropagation();
            onClick(event);
        }
    }, [
        onClick
    ]);
    // maybe consider memoising this after clean up
    const titlePart = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        // EDM-12119: This is set here to help with the positioning of the icon to be in the middle of inline display.
        // We cannot set the fix font because inline is taking the parent container font size into account.
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        style: {
            lineHeight: `1`
        },
        xcss: $e0c339aca18e23bd$var$styles.iconOuterWrapperStyle,
        testId: "icon-position-wrapper"
    }, children || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        xcss: $e0c339aca18e23bd$var$styles.iconEmptyStyle,
        testId: "icon-empty-wrapper"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        "data-testid": "icon-wrapper",
        className: (0, $2R2iS.default)([
            "_11c8wadc _2rkolb4i _1e0c116y _kqswstnw _2hwx1b66 _4t3i7vkz _1bsb7vkz _154i1ssb _1ltv1ssb _t9ec1ooe _uiztglyw"
        ])
    }, renderIcon(testId)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        style: {
            color: titleTextColor
        }
    }, title));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e0c339aca18e23bd$export$c73a53738ef9e3f, {
        style: {
            color: titleColor
        },
        testId: testId
    }, link ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($e0c339aca18e23bd$var$LinkAppearance, {
        href: link,
        onClick: handleClick,
        onKeyPress: handleKeyPress,
        className: (0, $2R2iS.default)([
            $e0c339aca18e23bd$var$styles.linkStyle
        ])
    }, titlePart) : titlePart, rightSide ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        xcss: $e0c339aca18e23bd$var$styles.noLinkAppearanceStyle
    }, rightSide) : null));
};
const $e0c339aca18e23bd$export$c73a53738ef9e3f = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        xcss: $e0c339aca18e23bd$var$styles.iconTitleWrapperStyle,
        ...props
    });
};

});
parcelRegister("eHESC", function(module, exports) {
$parcel$export(module.exports, "Shimmer", () => $8d620d0c2e3185b2$export$809644b82cfe94b1);
/* Icon.tsx generated by @compiled/babel-plugin v3.0.2 */ /* Icon.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $38Pvw = parcelRequire("38Pvw");
const $8d620d0c2e3185b2$export$f04a61298a47a40f = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_2rkolb4i _4t3i7vkz _1bsb7vkz _2hwx1b66 _uiztglyw _kqswstnw _154i1ssb _1ltv1ssb _t9ec1ooe",
            __cmplp.className
        ])
    });
});
const $8d620d0c2e3185b2$export$809644b82cfe94b1 = ({ testId: testId })=>{
    const skeletonCustomStyles = {
        position: 'absolute',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        top: '50%',
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
        left: '50%',
        transform: 'translate(-50%, -50%)',
        marginRight: "var(--ds-space-050, 4px)"
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $38Pvw.SpanSkeleton), {
        width: 16,
        height: 16,
        borderRadius: "var(--ds-radius-xsmall, 2px)",
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: skeletonCustomStyles
    });
};

});
parcelRegister("38Pvw", function(module, exports) {
$parcel$export(module.exports, "SpanSkeleton", () => $6cca38baf0d97315$export$85d5658002cae6ce);
/* span-skeleton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $6cca38baf0d97315$var$placeholderShimmer = null;
const $6cca38baf0d97315$var$appearanceValues = {
    darkGray: {
        animation: "var(--ds-background-accent-gray-subtle, #8C8F97)"
    },
    gray: {
        animation: "var(--ds-skeleton, #0515240F)"
    },
    blue: {
        animation: "var(--ds-background-information-hovered, #CFE1FD)"
    }
};
const $6cca38baf0d97315$var$spanSkeletonStyles = null;
const $6cca38baf0d97315$var$spanSkeletonBackgroundStyleMap = {
    gray: "_bfhkysee",
    blue: "_bfhk1s93",
    darkGray: "_bfhk7qp0"
};
const $6cca38baf0d97315$export$85d5658002cae6ce = ({ width: width, appearance: appearance = 'gray', height: height = 14, borderRadius: borderRadius = 0, isShimmering: isShimmering = true, testId: testId, style: style = {} })=>{
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        "data-testid": testId,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            height: (typeof height === 'number' ? `${height}px` : height) || 'auto',
            width: (typeof width === 'number' ? `${width}px` : width) || 'auto',
            borderRadius: (typeof borderRadius === 'number' ? `${borderRadius}px` : borderRadius) || 0,
            backgroundImage: `linear-gradient(
    to right,
    transparent 0%,
    ${$6cca38baf0d97315$var$appearanceValues[appearance].animation} 20%,
    transparent 40%,
    transparent 100%
  )`,
            backgroundSize: isShimmering ? `40px ${height}` : '0px'
        },
        className: (0, $2R2iS.default)([
            "_uiztglyw _12vemgnk _j7hq1uu9 _5sag9cwz _1pglp3kn _tip812c5 _1o51q7pw",
            $6cca38baf0d97315$var$spanSkeletonBackgroundStyleMap[appearance]
        ])
    });
};

});



parcelRegister("hseE8", function(module, exports) {
$parcel$export(module.exports, "renderLozenge", () => $29a43a19abfc7b90$export$69cf9880ad713b0e);

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $23U23 = parcelRequire("23U23");
const $29a43a19abfc7b90$var$LOZENGE_TEST_ID = 'inline-card-resolved-view-lozenge';
function $29a43a19abfc7b90$export$69cf9880ad713b0e(lozenge) {
    var _lozenge$style3, _lozenge$style4;
    if (!lozenge || !(lozenge !== null && lozenge !== void 0 && lozenge.text)) return null;
    if ((0, $dRkX9.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const stateMetricMatch = lozenge.text.match(/^(.+?)\s+-\s+(\d+(?:\.\d+)?)$/);
        if (stateMetricMatch) {
            var _lozenge$style, _lozenge$style2;
            const [, label, metric] = stateMetricMatch;
            const appearance = lozenge.appearance || 'neutral';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $23U23.default), {
                testId: $29a43a19abfc7b90$var$LOZENGE_TEST_ID,
                appearance: appearance,
                style: {
                    backgroundColor: lozenge === null || lozenge === void 0 || (_lozenge$style = lozenge.style) === null || _lozenge$style === void 0 ? void 0 : _lozenge$style.backgroundColor,
                    color: lozenge === null || lozenge === void 0 || (_lozenge$style2 = lozenge.style) === null || _lozenge$style2 === void 0 ? void 0 : _lozenge$style2.color
                },
                trailingMetric: metric
            }, label);
        }
    }
    const appearance = lozenge.appearance || 'default';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $23U23.default), {
        testId: $29a43a19abfc7b90$var$LOZENGE_TEST_ID,
        appearance: appearance,
        style: {
            backgroundColor: lozenge === null || lozenge === void 0 || (_lozenge$style3 = lozenge.style) === null || _lozenge$style3 === void 0 ? void 0 : _lozenge$style3.backgroundColor,
            color: lozenge === null || lozenge === void 0 || (_lozenge$style4 = lozenge.style) === null || _lozenge$style4 === void 0 ? void 0 : _lozenge$style4.color
        },
        isBold: lozenge.isBold !== false
    }, lozenge.text);
}

});
parcelRegister("23U23", function(module, exports) {
$parcel$export(module.exports, "default", () => $aa0da119fb18284d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $9wELi = parcelRequire("9wELi");

var $dRkX9 = parcelRequire("dRkX9");
const $aa0da119fb18284d$var$wrapperStylesOld = null;
const $aa0da119fb18284d$var$wrapperStylesNew = null;
const $aa0da119fb18284d$var$wrapperStylesNewLozenge = null;
const $aa0da119fb18284d$var$InlineLozenge = (props)=>{
    if ((0, $dRkX9.fg)('jfp-magma-platform-lozenge-jump-fix')) return /*#__PURE__*/ $fc4bM.createElement("span", {
        "data-inline-card-lozenge": true,
        className: (0, $2R2iS.default)([
            "_1e0c1o8l _154i1n1a _kqswh2mm _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq",
            (0, $dRkX9.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_2hwxt94y"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $9wELi.default), props));
    return /*#__PURE__*/ $fc4bM.createElement("span", {
        "data-inline-card-lozenge": true,
        className: (0, $2R2iS.default)([
            "_1e0c1o8l _s7n4t94y _19pkidpf _2hwx1b66 _otyridpf _18u0v77o _p12f1osq",
            (0, $dRkX9.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') && "_2hwxt94y"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $9wELi.default), props));
};
var $aa0da119fb18284d$export$2e2bcd8739ae039 = $aa0da119fb18284d$var$InlineLozenge;

});




parcelRegister("80nLx", function(module, exports) {
$parcel$export(module.exports, "EmbedCardErroredView", () => $e2a145363dc98042$export$6819d845957344e);
/* ErroredView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $5dzEI = parcelRequire("5dzEI");

var $gDsF8 = parcelRequire("gDsF8");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $ewFKq = parcelRequire("ewFKq");

var $jv3RQ = parcelRequire("jv3RQ");
const $e2a145363dc98042$var$styles = {
    boxStyles: "_19bv1b66 _u5f31b66"
};
const $e2a145363dc98042$export$6819d845957344e = ({ onRetry: onRetry, isSelected: isSelected = false, testId: testId = 'embed-card-errored-view', inheritDimensions: inheritDimensions })=>/*#__PURE__*/ $fc4bM.createElement((0, $jv3RQ.Frame), {
        inheritDimensions: inheritDimensions,
        compact: true,
        isSelected: isSelected,
        testId: testId
    }, /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error-icon"
    }), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $e2a145363dc98042$var$styles.boxStyles
    }, /*#__PURE__*/ $fc4bM.createElement((0, $i3riz.Inline), null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).could_not_load_link))), /*#__PURE__*/ $fc4bM.createElement((0, $5dzEI.default), {
        testId: "err-view-retry",
        spacing: "compact",
        onClick: onRetry
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).try_again)));

});
parcelRegister("jv3RQ", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $987b43a46c3e78ac$export$b89a827e9254211a);
/* ErrorFrame.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports -- exports share Compiled style value(s) [compactFrameAlignStyles, compactFrameHoverStyles, compactFrameInheritDimensionsFalseStyles, compactFrameInheritDimensionsTrueStyles, compactFrameNotSelectedStyles, compactFrameStyles, expandedFrameFluidHeightFalseStyles, expandedFrameFluidHeightTrueStyles, expandedFrameHoverStyles, expandedFrameNotSelectedStyles, expandedFrameSelectedStyles, expandedFrameStyles, sharedBaseFrameStyles, sharedFrameStyles] which cannot be exported across files (UI Styling Standard: no-exported-css) */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
const $987b43a46c3e78ac$export$b89a827e9254211a = (props = {
    isSelected: false,
    isHoverable: false,
    isFluidHeight: false
})=>props.compact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($987b43a46c3e78ac$export$f862a410248f4f00, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($987b43a46c3e78ac$export$7b360cd785b6c366, props);
const $987b43a46c3e78ac$var$sharedBaseFrameStyles = null;
const $987b43a46c3e78ac$var$sharedFrameStyles = null;
const $987b43a46c3e78ac$var$expandedFrameHoverStyles = null;
const $987b43a46c3e78ac$var$expandedFrameFluidHeightTrueStyles = null;
const $987b43a46c3e78ac$var$expandedFrameFluidHeightFalseStyles = null;
const $987b43a46c3e78ac$var$expandedFrameSelectedStyles = null;
const $987b43a46c3e78ac$var$expandedFrameNotSelectedStyles = null;
const $987b43a46c3e78ac$var$expandedFrameStyles = null;
const $987b43a46c3e78ac$export$7b360cd785b6c366 = ({ children: children, isSelected: isSelected, isHoverable: isHoverable, testId: testId, className: className, isFluidHeight: isFluidHeight })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr31dpa _d0altlke",
            isFluidHeight ? "_1tkeidpf" : "_1tke68cl",
            isSelected ? "_2rkofajl _1h6dq98m _1dqonqa1 _189e1dm9" : "_2rkolb4i _1h6d1j28 _1dqonqa1 _189e1dm9",
            "_1reo15vq _18m915vq _1bah1yb4 _16qst7xp",
            className
        ]),
        "data-trello-do-not-use-override": testId
    }, children);
};
const $987b43a46c3e78ac$var$compactFrameHoverStyles = null;
const $987b43a46c3e78ac$var$compactFrameInheritDimensionsTrueStyles = null;
const $987b43a46c3e78ac$var$compactFrameInheritDimensionsFalseStyles = null;
const $987b43a46c3e78ac$var$compactFrameAlignStyles = null;
const $987b43a46c3e78ac$var$compactFrameStyles = null;
const $987b43a46c3e78ac$var$compactFrameNotSelectedStyles = null;
const $987b43a46c3e78ac$export$f862a410248f4f00 = ({ children: children, isHoverable: isHoverable, isSelected: isSelected, testId: testId, className: className, inheritDimensions: inheritDimensions })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            "_1bsb1osq _1e0c1txw",
            "_p12fukw8 _bfhkhp5a",
            isHoverable && "_irr3plhp",
            isSelected && "_2rkofajl _1h6dq98m _1dqonqa1 _189e1dm9",
            !isSelected && "_2rkolb4i",
            "_1bah1h6o _4cvr1h6o _bfhki8nm",
            inheritDimensions ? "_4t3i1osq" : "_4t3i1ylp",
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq",
            className
        ])
    }, children);
};

});


parcelRegister("6KZ0w", function(module, exports) {
$parcel$export(module.exports, "default", () => $29cbb159593a9655$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $5dzEI = parcelRequire("5dzEI");

var $ewFKq = parcelRequire("ewFKq");

var $h7cVs = parcelRequire("h7cVs");

var $kTxuC = parcelRequire("kTxuC");

var $6bRGy = parcelRequire("6bRGy");
const $29cbb159593a9655$var$ForbiddenView = ({ context: context, onAuthorize: onAuthorize, accessContext: accessContext, testId: testId = 'embed-card-forbidden-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, providerIcon: providerIcon, providerIconLabel: providerIconLabel, text: text = '' } = context ?? {};
    const { accessType: accessType, hostname: hostname, titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey, callToActionMessageKey: callToActionMessageKey, action: action } = accessContext ?? {};
    const values = (0, $fc4bM.useMemo)(()=>{
        const product = (context === null || context === void 0 ? void 0 : context.text) ?? '';
        return {
            context: product,
            product: product,
            hostname: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("b", null, hostname)
        };
    }, [
        hostname,
        context === null || context === void 0 ? void 0 : context.text
    ]);
    /**
   * if there is a request access context, but no action to perform, do not show any button.
   * By default, a "Try another account" button shows, but with request access context, we don't
   * want to encourage users to try another account, if their request is already pending, etc.
   */ const button = (0, $fc4bM.useMemo)(()=>{
        const onEmbedCardClick = (action === null || action === void 0 ? void 0 : action.promise) ?? onAuthorize;
        if (!onEmbedCardClick) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
            testId: `button-${(action === null || action === void 0 ? void 0 : action.id) || 'connect-other-account'}`,
            appearance: "primary",
            onClick: onEmbedCardClick,
            isDisabled: accessType === 'PENDING_REQUEST_EXISTS'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...(0, $h7cVs.toMessage)((0, $ewFKq.messages).try_another_account, callToActionMessageKey),
            values: values
        }));
    }, [
        accessType,
        action === null || action === void 0 ? void 0 : action.id,
        action === null || action === void 0 ? void 0 : action.promise,
        callToActionMessageKey,
        onAuthorize,
        values
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTxuC.default), {
        ...unresolvedViewProps,
        icon: icon,
        providerIcon: providerIcon,
        providerIconLabel: providerIconLabel,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6bRGy.ForbiddenSVG), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...(0, $h7cVs.toMessage)((0, $ewFKq.messages).invalid_permissions, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...(0, $h7cVs.toMessage)((0, $ewFKq.messages).invalid_permissions_description, descriptiveMessageKey),
            values: values
        }),
        button: button
    });
};
var $29cbb159593a9655$export$2e2bcd8739ae039 = $29cbb159593a9655$var$ForbiddenView;

});
parcelRegister("kTxuC", function(module, exports) {
$parcel$export(module.exports, "default", () => $4584f0fbf8b0c708$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $1hJdJ = parcelRequire("1hJdJ");

var $inMs5 = parcelRequire("inMs5");

var $dRkX9 = parcelRequire("dRkX9");

var $k8Adr = parcelRequire("k8Adr");

var $Yx6nk = parcelRequire("Yx6nk");

var $2jRBQ = parcelRequire("2jRBQ");
const $4584f0fbf8b0c708$var$containerStyles = null;
const $4584f0fbf8b0c708$var$contentStyles = null;
const $4584f0fbf8b0c708$var$imageStyles = null;
const $4584f0fbf8b0c708$var$UnresolvedView = ({ button: button, description: description, frameStyle: frameStyle, icon: iconUrlOrElement, image: imageUrlOrElement, inheritDimensions: inheritDimensions, isSelected: isSelected, onClick: onClick, providerIcon: providerIcon, providerIconLabel: providerIconLabel, testId: testId, text: text, title: title, url: url })=>{
    // Unresolved embeds have no entity title. The frame shows the provider name, so
    // pair it with the provider/generator icon rather than the entity-type icon.
    const shouldUseProviderIcon = providerIcon != null && (0, $dRkX9.fg)('platform_lp_use_generator_icon_for_provider');
    const frameIconUrlOrElement = shouldUseProviderIcon ? providerIcon : iconUrlOrElement;
    const frameIconLabel = shouldUseProviderIcon ? providerIconLabel : undefined;
    const icon = (0, $fc4bM.useMemo)(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(frameIconUrlOrElement)) return frameIconUrlOrElement;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2jRBQ.ImageIcon), {
            src: typeof frameIconUrlOrElement === 'string' ? frameIconUrlOrElement : undefined,
            alt: frameIconLabel,
            default: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($inMs5))), {
                label: "icon",
                testId: "embed-card-fallback-icon",
                color: "currentColor"
            })
        });
    }, [
        frameIconLabel,
        frameIconUrlOrElement
    ]);
    const image = (0, $fc4bM.useMemo)(()=>{
        if (!imageUrlOrElement) return null;
        const imageTestId = `${testId}-unresolved-image`;
        if (typeof imageUrlOrElement === 'string') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("img", {
            "data-testid": imageTestId,
            src: imageUrlOrElement,
            alt: "",
            className: (0, $2R2iS.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            "data-testid": imageTestId,
            className: (0, $2R2iS.default)([
                "_4t3i68cl _1bsbmgvx _5ral1f51 _rsufaqso"
            ])
        }, imageUrlOrElement);
    }, [
        imageUrlOrElement,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $Yx6nk.ExpandedFrame), {
        // Scroll bar must be shown for unresolved views to display the connect account button
        allowScrollBar: true,
        setOverflow: true,
        // EDM-9259: Fix embed frame showing on unresolved views when frameStyle is set to hide.
        // Set fallback to 'show' here to maintain the current behaviour when platform.editor.show-embed-card-frame-renderer is OFF.
        // Remove 'show' on platform.editor.show-embed-card-frame-renderer cleanup as frameStyle will be set to 'show' both in renderer and editor.
        // We want all views to be consistent and respect frameStyle instead of
        // having resolved view default to showOnHover and unresolved view default to show.
        // Default frameStyle is set inside <ExpandedFrame />
        frameStyle: frameStyle ?? 'show',
        href: url,
        icon: icon,
        inheritDimensions: inheritDimensions,
        isSelected: isSelected,
        onClick: onClick,
        testId: testId,
        text: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": `${testId}-unresolved-container`,
        className: (0, $2R2iS.default)([
            "_1e0c11p5 _4t3i1kw7"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulpv47k _1e0c1txw _2lx21bp4 _1bah1h6o _y3gn1h6o _4cvr1h6o _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _p12f1kdj"
        ])
    }, image, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1hJdJ.default), {
        size: "large",
        testId: `${testId}-unresolved-title`
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $k8Adr.Text), {
        align: "center",
        testId: `${testId}-unresolved-description`
    }, description), button)));
};
var $4584f0fbf8b0c708$export$2e2bcd8739ae039 = $4584f0fbf8b0c708$var$UnresolvedView;

});
parcelRegister("Yx6nk", function(module, exports) {
$parcel$export(module.exports, "ExpandedFrame", () => $1c29e836c25695c1$export$7b360cd785b6c366);
/* ExpandedFrame.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $bcN2K = parcelRequire("bcN2K");

var $bcTS3 = parcelRequire("bcTS3");

var $f1474 = parcelRequire("f1474");

var $l0pqb = parcelRequire("l0pqb");

var $bqaw7 = parcelRequire("bqaw7");
const $1c29e836c25695c1$var$styles = {
    linkWrapper: "_zulpu2gc _kqswh2mm _1e0c1txw _2lx21bp4 _4t3ik5xz _ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _uiztglyw _qc5o94zs _14mjpb1k _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1hfk1j28 _1bqqidpf _u94kidpf _1ifiidpf",
    linkWrapperInheritDimensions: "_4t3i1osq",
    linkWrapperSelected: "_8x3u1yw3",
    linkWrapperBorderAndBackground: "_1tqzia51 _1hfkhp5a _1ifikb7n",
    linkWrapperInteractiveNotHidden: "_hcgvia51 _4tpuhp5a _x148kb7n",
    header: "_11c81qyo _zulp1b66 _1e0c1txw _4cvr1h6o _1bah1yb4 _4t3igktf _1pbykb7n",
    leftSection: "_zulp1b66 _1e0c1txw _4cvr1h6o _1ul9idpf",
    tooltipWrapper: "_1reo15vq _18m915vq",
    headerAnchor: "_11c81qyo _1reo15vq _18m915vq _1e0c1ule _1bto1l2s _o5721q9c _9oik1r31 _1bnxglyw _jf4cnqa1",
    headerIcon: "_11c81qyo _1bsb7vkz _4t3i7vkz",
    contentStyle: "_19itdlqj _2rkoy00x _1reo15vq _18m915vq _v56414au _bfhkhp5a _16jlkb7n _4t3i1osq _1pbykb7n",
    contentInteractiveActiveBorder: "_1jhm1tt7",
    contentOverflowAuto: "_1reo1wug _18m91wug"
};
const $1c29e836c25695c1$var$navigationStyles = {
    headerAnchor: "_80omtlke _aetrb3bt _18postnw _15l2idpf _32rxidpf _1x88idpf _19doidpf _1bqq1mrw"
};
const $1c29e836c25695c1$export$7b360cd785b6c366 = ({ isPlaceholder: isPlaceholder = false, children: children, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, icon: icon, text: text, isSelected: isSelected, frameStyle: frameStyle = 'showOnHover', href: href, minWidth: minWidth, maxWidth: maxWidth, testId: testId = 'expanded-frame', inheritDimensions: inheritDimensions, allowScrollBar: allowScrollBar = false, setOverflow: setOverflow = true, CompetitorPrompt: CompetitorPrompt, onContentMouseEnter: onContentMouseEnter, onContentMouseLeave: onContentMouseLeave })=>{
    const headerRef = (0, $fc4bM.useRef)(null);
    const headerAnchorRef = (0, $fc4bM.useRef)(null);
    const isInteractive = ()=>!isPlaceholder && (Boolean(href) || Boolean(onClick));
    const isEmbedOpenInNewTabEnabled = (0, $bcN2K.isExperimentEnabled)('platform_editor_embed_open_in_new_tab');
    const isModifierNavigationClick = (event)=>isEmbedOpenInNewTabEnabled && frameStyle !== 'hide' && !isPlaceholder && Boolean(href) && (event.button === 0 && (event.metaKey || event.ctrlKey) || event.button === 1);
    const isUnmodifiedPrimaryDoubleClick = (event)=>isEmbedOpenInNewTabEnabled && frameStyle !== 'hide' && !isPlaceholder && Boolean(href) && event.type === 'dblclick' && event.button === 0 && event.detail === 2 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
    const handleClick = (event)=>{
        if (isModifierNavigationClick(event)) {
            // CardWithUrl must see the uncancelled event so it can respect consumer preventDefault.
            event.stopPropagation();
            onClick === null || onClick === void 0 || onClick(event);
            return;
        }
        (0, $l0pqb.handleClickCommon)(event, onClick);
    };
    const isHeaderAnchorTarget = (target)=>{
        var _headerAnchorRef$curr;
        return target instanceof Node && Boolean((_headerAnchorRef$curr = headerAnchorRef.current) === null || _headerAnchorRef$curr === void 0 ? void 0 : _headerAnchorRef$curr.contains(target));
    };
    const isChromeTarget = (event)=>{
        var _headerRef$current, _headerRef$current2;
        const { target: target } = event;
        if (!(target instanceof Element)) return false;
        const isInHeader = ((_headerRef$current = headerRef.current) === null || _headerRef$current === void 0 ? void 0 : _headerRef$current.contains(target)) ?? false;
        const isFrameChrome = target === event.currentTarget;
        if (!isInHeader && !isFrameChrome) return false;
        const interactiveAncestor = target.closest('a, button, input, select, textarea, [role="button"], [role="link"], [contenteditable="true"], [tabindex]');
        const isHeaderControl = interactiveAncestor && ((_headerRef$current2 = headerRef.current) === null || _headerRef$current2 === void 0 ? void 0 : _headerRef$current2.contains(interactiveAncestor));
        return !isHeaderControl || interactiveAncestor === headerAnchorRef.current;
    };
    const handleChromeMouseDownCapture = (event)=>{
        if (isModifierNavigationClick(event) && isChromeTarget(event)) {
            if (event.button === 1 && !isHeaderAnchorTarget(event.target)) // Non-link middle presses otherwise trigger autoscroll or clipboard paste.
            event.preventDefault();
            event.stopPropagation();
        }
    };
    const handleChromeNavigationEvent = (event)=>{
        if (isModifierNavigationClick(event) && !isHeaderAnchorTarget(event.target) && isChromeTarget(event)) handleClick(event);
    };
    const handleChromeDoubleClick = (event)=>{
        if (isUnmodifiedPrimaryDoubleClick(event) && isChromeTarget(event)) {
            event.stopPropagation();
            onClick === null || onClick === void 0 || onClick(event);
        }
    };
    const handleMouseDown = (0, $f1474.useMouseDownEvent)();
    const CompetitorPromptComponent = CompetitorPrompt && href ? /*#__PURE__*/ $fc4bM.createElement(CompetitorPrompt, {
        sourceUrl: href,
        linkType: "embed"
    }) : null;
    const renderHeader = ()=>{
        return frameStyle !== 'hide' && /*#__PURE__*/ $fc4bM.createElement("div", {
            ref: headerRef,
            className: (0, $2R2iS.default)([
                $1c29e836c25695c1$var$styles.header,
                "embed-header"
            ])
        }, /*#__PURE__*/ $fc4bM.createElement("div", {
            className: (0, $2R2iS.default)([
                $1c29e836c25695c1$var$styles.leftSection
            ])
        }, /*#__PURE__*/ $fc4bM.createElement("div", {
            className: (0, $2R2iS.default)([
                $1c29e836c25695c1$var$styles.headerIcon
            ])
        }, icon), /*#__PURE__*/ $fc4bM.createElement("div", {
            className: (0, $2R2iS.default)([
                $1c29e836c25695c1$var$styles.tooltipWrapper
            ])
        }, !isPlaceholder && /*#__PURE__*/ $fc4bM.createElement((0, $bcTS3.default), {
            content: text,
            hideTooltipOnMouseDown: true
        }, /*#__PURE__*/ $fc4bM.createElement("a", {
            ref: headerAnchorRef,
            href: href,
            onClick: handleClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            onMouseDown: handleMouseDown,
            className: (0, $2R2iS.default)([
                $1c29e836c25695c1$var$styles.headerAnchor,
                isEmbedOpenInNewTabEnabled && Boolean(href) && $1c29e836c25695c1$var$navigationStyles.headerAnchor
            ])
        }, text)))), CompetitorPromptComponent);
    };
    const interactive = isInteractive();
    const showBackgroundAlways = frameStyle === 'show' || isSelected && frameStyle !== 'hide';
    const showBackgroundOnHover = interactive && frameStyle !== 'hide';
    const renderContent = ()=>{
        return /*#__PURE__*/ $fc4bM.createElement("div", {
            "data-testid": "embed-content-wrapper",
            // This fixes an issue with input fields in cross domain iframes (ie. databases and jira fields from different domains)
            // See: HOT-107830
            contentEditable: false,
            onMouseEnter: onContentMouseEnter,
            onMouseLeave: onContentMouseLeave,
            onFocus: onContentMouseEnter,
            onBlur: onContentMouseLeave,
            className: (0, $2R2iS.default)([
                $1c29e836c25695c1$var$styles.contentStyle,
                setOverflow && allowScrollBar && $1c29e836c25695c1$var$styles.contentOverflowAuto,
                interactive && !showBackgroundAlways && !showBackgroundOnHover && $1c29e836c25695c1$var$styles.contentInteractiveActiveBorder
            ])
        }, children);
    };
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        role: "none",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            $1c29e836c25695c1$var$styles.linkWrapper,
            inheritDimensions && $1c29e836c25695c1$var$styles.linkWrapperInheritDimensions,
            isSelected && frameStyle !== 'hide' && $1c29e836c25695c1$var$styles.linkWrapperSelected,
            showBackgroundAlways && $1c29e836c25695c1$var$styles.linkWrapperBorderAndBackground,
            showBackgroundOnHover && !showBackgroundAlways && $1c29e836c25695c1$var$styles.linkWrapperInteractiveNotHidden,
            (0, $bqaw7.className)
        ]),
        style: {
            minWidth: minWidth ? `${minWidth}px` : '',
            maxWidth: maxWidth ? `${maxWidth}px` : ''
        },
        "data-testid": testId,
        "data-trello-do-not-use-override": testId,
        onMouseDownCapture: handleChromeMouseDownCapture,
        onClick: handleChromeNavigationEvent,
        onAuxClick: handleChromeNavigationEvent,
        onDoubleClick: handleChromeDoubleClick,
        // Due to limitations of testing library, we can't assert ::after
        "data-is-selected": isSelected,
        ...(isPlaceholder || !href) && {
            'data-wrapper-type': 'default',
            'data-is-interactive': isInteractive()
        }
    }, renderHeader(), renderContent());
};

});
parcelRegister("bqaw7", function(module, exports) {
$parcel$export(module.exports, "className", () => $5a764c5ab0d0653c$export$2913c0c0b5623090);
$parcel$export(module.exports, "Image", () => $5a764c5ab0d0653c$export$3e431a229df88919);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ /* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-dynamic-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");
const $5a764c5ab0d0653c$export$2913c0c0b5623090 = 'media-card-frame';
const $5a764c5ab0d0653c$var$getSizeWithUnit = (value = '100%')=>{
    const unit = typeof value === 'number' ? 'px' : '';
    return `${value}${unit}`;
};
const $5a764c5ab0d0653c$export$3e431a229df88919 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_rcxkve": (0, $8xbhL.default)($5a764c5ab0d0653c$var$getSizeWithUnit(__cmplp.size))
        },
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_2rkofajl _1reo15vq _18m915vq _1bsb17ym _4t3i17ym",
            __cmplp.className
        ])
    });
});
const $5a764c5ab0d0653c$export$1cd1efc78cb52ca5 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $8xbhL.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_2rkofajl _1bsbckbl _4t3ickbl _1aaxusic _19pk1b66 _2hwxidpf _otyrutpp _18u0utpp _bfhkizff _1lrw1dfr _1itk2pcs",
            __cmplp.className
        ])
    });
});

});


parcelRegister("2jRBQ", function(module, exports) {
$parcel$export(module.exports, "ImageIcon", () => $1aa55737de9023cc$export$4a122bafaa48b23d);
/* ImageIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $lig3b = parcelRequire("lig3b");

var $bqaw7 = parcelRequire("bqaw7");
const $1aa55737de9023cc$var$styles = {
    roundedImage: "_2rko1rr0"
};
const $1aa55737de9023cc$export$4a122bafaa48b23d = ({ alt: alt = '', src: src, size: size = 16, title: title, default: defaultIcon, appearance: appearance = 'square', hideLoadingSkeleton: hideLoadingSkeleton })=>{
    const [hasImageErrored, setHasImageErrored] = (0, $fc4bM.useState)(false);
    // If url changes, reset state
    (0, $fc4bM.useEffect)(()=>{
        setHasImageErrored(false);
    }, [
        src
    ]);
    const handleError = (0, $fc4bM.useCallback)(()=>{
        setHasImageErrored(true);
    }, []);
    // TODO: do we need this?
    if (!src) return defaultIcon || null;
    if (hasImageErrored) return defaultIcon;
    const LoadedImageComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bqaw7.Image), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            appearance === 'round' && $1aa55737de9023cc$var$styles.roundedImage,
            "smart-link-icon"
        ]),
        src: src,
        alt: alt,
        size: size,
        title: title,
        ...hideLoadingSkeleton ? {
            onError: handleError
        } : undefined
    });
    if (hideLoadingSkeleton) return LoadedImageComponent;
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lig3b))), {
        src: src,
        loading: defaultIcon,
        loaded: LoadedImageComponent,
        errored: defaultIcon
    });
};

});


parcelRegister("6bRGy", function(module, exports) {
$parcel$export(module.exports, "ForbiddenSVG", () => $6ddd1049fb81d649$export$f51768a4e7ff128);

var $fc4bM = parcelRequire("fc4bM");
const $6ddd1049fb81d649$export$f51768a4e7ff128 = ()=>{
    const gradientId = (0, $fc4bM.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("svg", {
        viewBox: "0 0 168.8372 221.4874",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "forbidden-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: gradientId,
        gradientUnits: "userSpaceOnUse",
        x1: "49.4199",
        x2: "122.662",
        y1: "59.7673",
        y2: "59.7673"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0",
        stopColor: "#0065ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: ".2188",
        stopColor: "#0b6cff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: ".5999",
        stopColor: "#2780ff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#4c9aff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "m122.662 119.5347h-73.242v-82.9141a36.6211 36.6211 0 0 1 73.2422 0zm-61.2422-12h49.2422v-70.9141a24.6211 24.6211 0 0 0 -49.2422 0z",
        fill: `url(#${gradientId})`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "m160.3239 111.17a65.4958 65.4958 0 0 1 -5.657-46.1172l.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-130.6932a5.0533 5.0533 0 0 0 -4.9038 6.273l.0015.0057a66.1488 66.1488 0 0 1 -5.7847 46.3674 75.4908 75.4908 0 0 0 65.21 110.0468c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0027c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0032c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0332.0008.0652-.0009.0977 0h.0023c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0026c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0016c.0333.0008.0652-.0009.0977 0h.0031c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0016c.0333.0008.0651-.0009.0975 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0025c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0651-.0009.0975 0h.0016c.0333.0008.0652-.0009.0977 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0025c.0333.0008.0652-.0009.0977 0h.0023c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0017c.0332.0008.0652-.0009.0977 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0643-.0009.0968 0h.0024c.0325.0008.0645-.0009.0969 0h.0024c.0325.0008.0642-.0009.0967 0h.0024c.0325.0008.0645-.0009.0969 0h.0017c.0332.0008.0651-.0009.0975 0h.0024c.0325.0008.0643-.0009.0968 0h.0024a75.491 75.491 0 0 0 68.8626-110.2939z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "m154.6669 65.0531.0022-.0088a5.0533 5.0533 0 0 0 -4.9039-6.273h-112.8264a5.0533 5.0533 0 0 0 -4.9039 6.273l.0014.0057a66.1491 66.1491 0 0 1 -5.7845 46.3674 75.4854 75.4854 0 1 0 134.072-.2471 65.4957 65.4957 0 0 1 -5.6569-46.1172z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "m93.3523 213.6q-.8454 0-1.6973-.0205a67.6029 67.6029 0 0 1 -58.3963-98.5383 74.3762 74.3762 0 0 0 7.2113-48.3823h105.7618a73.488 73.488 0 0 0 7.0986 48.16 67.6006 67.6006 0 0 1 -59.9755 98.7811z",
        fill: "#ff7452"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "m90.0071 176.8851a16.3079 16.3079 0 0 1 -16.1149-18.8193l2.23-14.3217a24.1482 24.1482 0 0 1 16.087-41.053c.3821-.0176.7658-.0265 1.1435-.0265a24.1491 24.1491 0 0 1 17.229 41.0809l2.2312 14.32a16.31 16.31 0 0 1 -16.1149 18.8193z",
        fill: "#ff5630"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "m108.481 126.8237a15.0613 15.0613 0 0 1 -4.83 11.0676 7.2219 7.2219 0 0 0 -2.1218 6.4121l2.3594 15.1531a7.2783 7.2783 0 0 1 -7.1916 8.3981h-6.69a7.2783 7.2783 0 0 1 -7.1916-8.3981l2.3872-15.3318a7.2321 7.2321 0 0 0 -2.2684-6.345 15.0639 15.0639 0 0 1 -4.6905-11.7523 15.1293 15.1293 0 0 1 30.2376.7963z",
        fill: "#de350b"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "m82.8151 159.4565a7.2565 7.2565 0 1 0 14.3328 0l-2.3594-15.1531a7.2215 7.2215 0 0 1 2.1217-6.4121 15.1041 15.1041 0 0 0 -6.9452-25.804 15.2678 15.2678 0 0 0 -11.7216 13.94 15.0634 15.0634 0 0 0 4.6906 11.7527 7.232 7.232 0 0 1 2.2683 6.3449z",
        fill: "#344563"
    }));
};

});


parcelRegister("gU6bM", function(module, exports) {
$parcel$export(module.exports, "default", () => $dd086aefae7439cd$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $ewFKq = parcelRequire("ewFKq");

var $h7cVs = parcelRequire("h7cVs");

var $kTxuC = parcelRequire("kTxuC");

var $8mKWP = parcelRequire("8mKWP");
const $dd086aefae7439cd$var$NotFoundView = ({ context: context, accessContext: accessContext, testId: testId = 'embed-card-not-found-view', ...unresolvedViewProps })=>{
    const { icon: icon, image: image, providerIcon: providerIcon, providerIconLabel: providerIconLabel, text: text = '' } = context ?? {};
    const { titleMessageKey: titleMessageKey, descriptiveMessageKey: descriptiveMessageKey } = accessContext ?? {};
    const values = (0, $fc4bM.useMemo)(()=>({
            product: text
        }), [
        text
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTxuC.default), {
        ...unresolvedViewProps,
        icon: icon,
        providerIcon: providerIcon,
        providerIconLabel: providerIconLabel,
        image: image ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8mKWP.NotFoundSVG), null),
        testId: testId,
        text: text,
        title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...(0, $h7cVs.toMessage)((0, $ewFKq.messages).not_found_title, titleMessageKey),
            values: values
        }),
        description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...(0, $h7cVs.toMessage)((0, $ewFKq.messages).not_found_description, descriptiveMessageKey),
            values: values
        })
    });
};
var $dd086aefae7439cd$export$2e2bcd8739ae039 = $dd086aefae7439cd$var$NotFoundView;

});
parcelRegister("8mKWP", function(module, exports) {
$parcel$export(module.exports, "NotFoundSVG", () => $835cc71ba1879201$export$80542c1714a314c8);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");
const $835cc71ba1879201$export$80542c1714a314c8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        viewBox: "0 0 200.55 269.99",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "not-found-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "linear-gradient",
        x1: "1316.98",
        y1: "230.66",
        x2: "1396.36",
        y2: "230.66",
        gradientTransform: "matrix(-1, 0, 0, 1, 1517.54, 0)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0",
        stopColor: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#6c798f"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "linear-gradient-2",
        x1: "170.3",
        y1: "897.49",
        x2: "365.15",
        y2: "897.49",
        gradientTransform: "translate(-125.06 -762.9) rotate(4.81)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0",
        stopColor: "#fff"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.69",
        stopColor: "#fff",
        stopOpacity: "0.1"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("title", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        defaultMessage: "Search error",
        id: "smart-card.not-found-svg.title"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("g", {
        id: "Layer_2",
        "data-name": "Layer 2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("g", {
        id: "Objects"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "#cfd4db",
        d: "M126.84,210.1l-9.51-9.39,13-13.23,9.52,9.39a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        id: "_Path_",
        "data-name": "<Path>",
        fill: "url(#linear-gradient)",
        d: "M126.84,210.1l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.82,4.78h0a18.06,18.06,0,0,1,8.82,4.79l38.59,38.09a14.87,14.87,0,0,1,.13,21h0a14.87,14.87,0,0,1-21,.14l-38.59-38.09a18,18,0,0,1-4.9-8.75h0A18,18,0,0,0,126.84,210.1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "#091e42",
        opacity: 0.1,
        d: "M131.63,218.46a18,18,0,0,0-4.79-8.36l-2.9-2.86a9.31,9.31,0,0,1-.09-13.15h0A9.3,9.3,0,0,1,137,194l2.9,2.86a18,18,0,0,0,8.41,4.68,79.1,79.1,0,0,1-7.72,9.12A77.4,77.4,0,0,1,131.63,218.46Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "#344563",
        d: "M155.47,145.8A77.74,77.74,0,0,0,22.41,91.7,77.24,77.24,0,0,0,0,146.82H0a77.22,77.22,0,0,0,23.13,54.81h0A77.74,77.74,0,0,0,155.47,145.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        id: "_Clipping_Path_",
        "data-name": "<Clipping Path>",
        fill: "#deebff",
        d: "M35.62,104.74a59.17,59.17,0,1,1-17.06,42A58.81,58.81,0,0,1,35.62,104.74Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        id: "_Path_2",
        "data-name": "<Path>",
        fill: "#b2d4ff",
        d: "M39.54,101.12A59.19,59.19,0,1,0,82.69,87.36,58.82,58.82,0,0,0,39.54,101.12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "#cce0ff",
        d: "M78.09,94.6a59.17,59.17,0,0,0-52.5,23.71,59.2,59.2,0,0,0,99.68,63.28,59.2,59.2,0,0,0-47.18-87Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "url(#linear-gradient-2)",
        d: "M72.77,205.3A59.25,59.25,0,0,0,133.92,165a59.2,59.2,0,0,1-6.42.62c-19.4.74-33.31-8.64-40-13.32-20.19-14-20.75-28.19-33.7-41.34A56,56,0,0,0,40,100.76l-.44.36A59.18,59.18,0,0,0,72.77,205.3Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("polygon", {
        id: "_Path_3",
        "data-name": "<Path>",
        fill: "#5e6c84",
        points: "105.15 132.36 94.03 121.33 78.7 136.79 63.24 121.45 52.22 132.57 67.68 147.9 52.34 163.35 63.45 174.38 78.79 158.92 94.24 174.26 105.27 163.15 89.81 147.81 105.15 132.36"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "#ffc400",
        d: "M82.29,29.4,72.12.45A.68.68,0,0,0,70.81.6L67.53,28.65l-6.48-.75a.67.67,0,0,0-.72.89l10.17,29a.68.68,0,0,0,1.31-.15l3.28-28.05,6.48.76A.68.68,0,0,0,82.29,29.4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "#ffc400",
        d: "M50.28,47.8,37.64,39.17a.29.29,0,0,0-.42.39l7,12.21-2.84,1.62a.29.29,0,0,0,0,.5L54,62.52a.3.3,0,0,0,.43-.39l-7-12.21,2.84-1.62A.29.29,0,0,0,50.28,47.8Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#344563",
        d: "M104.31,36.05c-.7,2.07-9.75-1-10.44,1.11s8.35,5.11,7.66,7.18-9.75-1-10.44,1.12,8.35,5.11,7.66,7.18-9.75-1-10.44,1.12S96.66,58.87,96,61"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M125.53,59.72c-1.59,1.49-7.85-5.2-9.45-3.71s4.66,8.19,3.06,9.69-7.86-5.21-9.46-3.72c-.74.7.21,2.51,1.28,4.4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        fill: "none",
        strokeLinecap: "round",
        strokeMiterlimit: 10,
        strokeWidth: "2px",
        stroke: "#5e6c84",
        d: "M20.83,59.86c2.17.27,1.06,9.37,3.23,9.63s3.28-8.83,5.46-8.57,1.05,9.37,3.22,9.63c1,.13,1.79-1.76,2.56-3.8"
    }))));

});


parcelRegister("10uKt", function(module, exports) {
$parcel$export(module.exports, "EmbedCardResolvedView", () => $45ddb24a33281165$export$30f3c6c32b384a8b);
/* ResolvedView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $fCOgx = parcelRequire("fCOgx");

var $inMs5 = parcelRequire("inMs5");

var $fnEFU = parcelRequire("fnEFU");

var $dGxDH = parcelRequire("dGxDH");

var $dRkX9 = parcelRequire("dRkX9");

var $anluN = parcelRequire("anluN");

var $j9rqA = parcelRequire("j9rqA");

var $95H2w = parcelRequire("95H2w");

var $96gGh = parcelRequire("96gGh");

var $2g9NH = parcelRequire("2g9NH");

var $gysdQ = parcelRequire("gysdQ");

var $9OgN6 = parcelRequire("9OgN6");

var $4paoX = parcelRequire("4paoX");

var $fKjQL = parcelRequire("fKjQL");

var $c83uc = parcelRequire("c83uc");

var $Yx6nk = parcelRequire("Yx6nk");

var $lHQOy = parcelRequire("lHQOy");

var $2jRBQ = parcelRequire("2jRBQ");

var $4UkG3 = parcelRequire("4UkG3");

const $45ddb24a33281165$var$EmbedRovoActionsFooter = (0, (/*@__PURE__*/$parcel$interopDefault($fCOgx)))({
    loader: ()=>(parcelRequire("kpSmA")).then((module)=>module.default),
    loading: ()=>null
});
$45ddb24a33281165$var$EmbedRovoActionsFooter.displayName = 'lazy(EmbedRovoActionsFooter)';

// Inline module-scope lazy() so product SSR tooling can preload it before hydration.
const $45ddb24a33281165$var$LazyEmbedRovoActionsFooter = (0, $fKjQL.withSuspense)(/*#__PURE__*/ (0, $fc4bM.lazy)(()=>(parcelRequire("kpSmA")).catch((0, $fKjQL.renderNothingOnLoadError))), 'lazy(EmbedRovoActionsFooter)');
const $45ddb24a33281165$var$styles = {
    contentWithFooter: "_1e0c1txw _2lx21bp4 _4t3i1osq _1tkeidpf",
    frameWithFooter: "_16jlkb7n _1tkeidpf",
    footer: "_1e0c1txw _1bah1y6m _85i5u2gc _1q51u2gc _y4tiu2gc _bozgu2gc"
};
const $45ddb24a33281165$var$EmbedFrameWithRovoFooter = ({ actionOptions: actionOptions, details: details, frame: frame, link: link, testId: testId })=>{
    const { rovoOptions: rovoOptions, product: product } = (0, $gysdQ.default)();
    const { isEnabled: isEmbedRovoActionsFooterEnabled } = (0, $2g9NH.default)(link, actionOptions, rovoOptions, product);
    const rovoActionData = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>isEmbedRovoActionsFooterEnabled && details ? (0, $95H2w.default)({
            response: details,
            rovoConfig: {
                rovoOptions: rovoOptions,
                product: product
            },
            product: product,
            actionOptions: actionOptions,
            appearance: (0, $j9rqA.CardDisplay).Embed
        }) : undefined, [
        actionOptions,
        details,
        isEmbedRovoActionsFooterEnabled,
        product,
        rovoOptions
    ]);
    const prompts = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        if (!isEmbedRovoActionsFooterEnabled) return [];
        return (0, $c83uc.getRovoPostAuthPromptKeys)({
            extensionKey: (0, $96gGh.getExtensionKey)(details)
        });
    }, [
        details,
        isEmbedRovoActionsFooterEnabled
    ]);
    const footer = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>rovoActionData && prompts.length > 0 ? (0, $dRkX9.fg)('platform_sl_replace_react_loadable') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($45ddb24a33281165$var$LazyEmbedRovoActionsFooter, {
            actionData: rovoActionData,
            prompts: prompts,
            testId: `${testId}-rovo-actions-footer`
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($45ddb24a33281165$var$EmbedRovoActionsFooter, {
            actionData: rovoActionData,
            prompts: prompts,
            testId: `${testId}-rovo-actions-footer`
        }) : undefined, [
        prompts,
        rovoActionData,
        testId
    ]);
    return footer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            $45ddb24a33281165$var$styles.contentWithFooter
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            $45ddb24a33281165$var$styles.frameWithFooter
        ])
    }, frame), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            $45ddb24a33281165$var$styles.footer
        ])
    }, footer)) : frame;
};
const $45ddb24a33281165$var$EmbedFrameWithoutRovoFooter = ({ frame: frame })=>frame;
const $45ddb24a33281165$var$EmbedFrameWithOptionalRovoFooter = (0, $dGxDH.componentWithFG)('platform_sl_3p_auth_rovo_embed_footer_kill_switch', $45ddb24a33281165$var$EmbedFrameWithRovoFooter, $45ddb24a33281165$var$EmbedFrameWithoutRovoFooter);
const $45ddb24a33281165$export$30f3c6c32b384a8b = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(({ actionOptions: actionOptions, link: link, context: context, details: details, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, isSelected: isSelected, frameStyle: frameStyle, preview: preview, title: title, isTrusted: isTrusted, testId: testId = 'embed-card-resolved-view', inheritDimensions: inheritDimensions, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isSupportProductContext: isSupportProductContext, isSupportTheming: isSupportTheming, type: type, CompetitorPrompt: CompetitorPrompt, hideIconLoadingSkeleton: hideIconLoadingSkeleton, extensionKey: extensionKey }, embedIframeRef)=>{
    const iconFromContext = context === null || context === void 0 ? void 0 : context.icon;
    const iconLabel = context === null || context === void 0 ? void 0 : context.iconLabel;
    const src = typeof iconFromContext === 'string' ? iconFromContext : undefined;
    const text = title || (context === null || context === void 0 ? void 0 : context.text);
    const linkGlyph = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($inMs5))), {
            label: "icon",
            testId: "embed-card-fallback-icon",
            color: "currentColor"
        }), []);
    const icon = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useMemo(()=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(iconFromContext)) return iconFromContext;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2jRBQ.ImageIcon), {
            src: src,
            alt: iconLabel,
            default: linkGlyph,
            appearance: (0, $4paoX.isProfileType)(type) ? 'round' : 'square',
            hideLoadingSkeleton: hideIconLoadingSkeleton
        });
    }, [
        iconFromContext,
        src,
        linkGlyph,
        type,
        hideIconLoadingSkeleton,
        iconLabel
    ]);
    (0, $4UkG3.useEmbedResolvePostMessageListener)({
        url: link,
        embedIframeRef: embedIframeRef
    });
    const themeState = (0, $anluN.useThemeObserver)();
    const { product: product } = (0, $fnEFU.useSmartLinkContext)();
    let previewUrl = preview === null || preview === void 0 ? void 0 : preview.src;
    const hostProduct = (0, $dRkX9.fg)('platform_avp_smartlink_embed_product_context') && isSupportProductContext ? product : undefined;
    if (previewUrl && (isSupportTheming || hostProduct)) previewUrl = (0, $9OgN6.getPreviewUrlWithEmbedContext)(previewUrl, {
        hostProduct: hostProduct,
        themeState: isSupportTheming ? themeState : undefined
    });
    const [isMouseOver, setMouseOver] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const frame = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lHQOy.Frame), {
        url: previewUrl,
        isTrusted: isTrusted,
        testId: testId,
        ref: embedIframeRef,
        onIframeDwell: onIframeDwell,
        onIframeFocus: onIframeFocus,
        onIframeMouseEnter: onIframeMouseEnter,
        onIframeMouseLeave: onIframeMouseLeave,
        isMouseOver: isMouseOver,
        title: text,
        extensionKey: extensionKey
    });
    const frameWithFooter = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($45ddb24a33281165$var$EmbedFrameWithOptionalRovoFooter, {
        actionOptions: actionOptions,
        details: details,
        frame: frame,
        link: link,
        testId: testId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $Yx6nk.ExpandedFrame), {
        isSelected: isSelected,
        frameStyle: frameStyle,
        href: link,
        testId: testId,
        icon: icon,
        text: text,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        inheritDimensions: inheritDimensions,
        setOverflow: false,
        CompetitorPrompt: CompetitorPrompt,
        onContentMouseEnter: ()=>{
            setMouseOver(true);
            onIframeMouseEnter === null || onIframeMouseEnter === void 0 || onIframeMouseEnter();
        },
        onContentMouseLeave: ()=>{
            setMouseOver(false);
            onIframeMouseLeave === null || onIframeMouseLeave === void 0 || onIframeMouseLeave();
        }
    }, frameWithFooter);
});

});
parcelRegister("2g9NH", function(module, exports) {
$parcel$export(module.exports, "default", () => $98c1054d77a5b40d$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $f4Od9 = parcelRequire("f4Od9");

var $96gGh = parcelRequire("96gGh");

var $fzYCU = parcelRequire("fzYCU");

var $79Big = parcelRequire("79Big");

var $4FmnF = parcelRequire("4FmnF");
const $98c1054d77a5b40d$var$NOT_ENABLED_RESULT = {
    isEnabled: false
};
const $98c1054d77a5b40d$var$useEmbedRovoActionsFooterExperiment = (url, actionOptions, rovoOptions, product)=>{
    var _actionOptions$rovoCh;
    const isRovoChatEnabled = (0, $f4Od9.getIsRovoChatEnabled)(rovoOptions);
    const cardState = (0, $fzYCU.useSmartCardState)(url ?? '');
    const extensionKey = (0, $96gGh.getExtensionKey)(cardState.details);
    const isRovoChatActionOptedIn = (actionOptions === null || actionOptions === void 0 || (_actionOptions$rovoCh = actionOptions.rovoChatAction) === null || _actionOptions$rovoCh === void 0 ? void 0 : _actionOptions$rovoCh.optIn) ?? false;
    return (0, $fc4bM.useMemo)(()=>{
        if (!isRovoChatEnabled || !url || !isRovoChatActionOptedIn || !extensionKey) return $98c1054d77a5b40d$var$NOT_ENABLED_RESULT;
        if (!(0, $79Big.isEligibleEmbedRovoActionsFooterExtensionKey)(extensionKey)) return $98c1054d77a5b40d$var$NOT_ENABLED_RESULT;
        return {
            isEnabled: (0, $4FmnF.isEmbedRovoActionsFooterExperimentEnabled)(product)
        };
    }, [
        isRovoChatEnabled,
        extensionKey,
        url,
        isRovoChatActionOptedIn,
        product
    ]);
};
var $98c1054d77a5b40d$export$2e2bcd8739ae039 = $98c1054d77a5b40d$var$useEmbedRovoActionsFooterExperiment;

});
parcelRegister("79Big", function(module, exports) {
$parcel$export(module.exports, "isEligibleEmbedRovoActionsFooterExtensionKey", () => $468b3410df021f2e$export$76997e71dbb58c72);
const $468b3410df021f2e$var$EMBED_ROVO_ACTIONS_FOOTER_ELIGIBLE_EXTENSION_KEYS = new Set([
    'google-object-provider',
    'onedrive-object-provider',
    'github-object-provider',
    'gitlab-object-provider'
]);
const $468b3410df021f2e$export$76997e71dbb58c72 = (extensionKey)=>extensionKey !== undefined && $468b3410df021f2e$var$EMBED_ROVO_ACTIONS_FOOTER_ELIGIBLE_EXTENSION_KEYS.has(extensionKey);

});

parcelRegister("4FmnF", function(module, exports) {
$parcel$export(module.exports, "isEmbedRovoActionsFooterExperimentEnabled", () => $129c75204861001f$export$f52bc2858cff4634);

var $dRkX9 = parcelRequire("dRkX9");
const $129c75204861001f$export$f52bc2858cff4634 = (product)=>{
    return product === 'CONFLUENCE' && (0, $dRkX9.fg)('platform_sl_3p_auth_rovo_embed_footer_kill_switch');
};

});


parcelRegister("c83uc", function(module, exports) {
$parcel$export(module.exports, "getRovoPostAuthPromptKeys", () => $a2f149cc90279c63$export$126e73c0e270bd5c);

var $hcvQy = parcelRequire("hcvQy");
const $a2f149cc90279c63$export$126e73c0e270bd5c = ({ extensionKey: extensionKey })=>{
    const defaultPrompts = [
        (0, $hcvQy.RovoChatPromptKey).KEY_HIGHLIGHTS
    ];
    if (extensionKey === 'github-object-provider' || extensionKey === 'gitlab-object-provider') return [
        (0, $hcvQy.RovoChatPromptKey).EXPLAIN_CODE,
        ...defaultPrompts
    ];
    return [
        (0, $hcvQy.RovoChatPromptKey).SUMMARIZE_DOCUMENT,
        ...defaultPrompts
    ];
};

});

parcelRegister("lHQOy", function(module, exports) {
$parcel$export(module.exports, "Frame", () => $eeb3013ab5d691ed$export$b89a827e9254211a);
/* Frame.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $3jqF1 = parcelRequire("3jqF1");

var $2KVKy = parcelRequire("2KVKy");

var $hF8nc = parcelRequire("hF8nc");
function $eeb3013ab5d691ed$var$mergeRefs(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}
const $eeb3013ab5d691ed$var$iframeStyles = null;
const $eeb3013ab5d691ed$export$b89a827e9254211a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(({ url: url, isTrusted: isTrusted = false, testId: testId, onIframeDwell: onIframeDwell, onIframeFocus: onIframeFocus, onIframeMouseEnter: onIframeMouseEnter, onIframeMouseLeave: onIframeMouseLeave, isMouseOver: isMouseOverProp, title: title, extensionKey: extensionKey }, iframeRef)=>{
    const [isIframeLoaded, setIframeLoaded] = (0, $fc4bM.useState)(false);
    const [isMouseOver, setMouseOver] = (0, $fc4bM.useState)(false);
    // Accessing the document here for SSR where document.hasFocus may be absent breaks SSR
    // when we're trying to load things like Loom frames in SSR
    // We _could_ either throw a guard in here (i.e check for the existence of document)
    // _or_
    // we can default to false, and set this state once the frame ref is available in a useEffect (safer IMO)
    // which already seems to be existing behavior in a useEffect below.
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const [isWindowFocused, setWindowFocused] = (0, $fc4bM.useState)(document.hasFocus());
    // Use prop if provided (from wrapper), otherwise use local state (for backward compatibility)
    const effectiveMouseOver = isMouseOverProp !== undefined ? isMouseOverProp : isMouseOver;
    const ref = (0, $fc4bM.useRef)();
    const mergedRef = $eeb3013ab5d691ed$var$mergeRefs([
        iframeRef,
        ref
    ]);
    const [percentVisible, setPercentVisible] = (0, $fc4bM.useState)(0);
    /**
   * These are the 'percent visible' thresholds at which the intersectionObserver will
   * trigger a state change. Eg. when the user scrolls and moves from 74% to 76%, or
   * vice versa. It's in a state object so that its static for the useEffect
   */ const [threshold] = (0, $fc4bM.useState)([
        0.75,
        0.8,
        0.85,
        0.9,
        0.95,
        1
    ]);
    (0, $fc4bM.useEffect)(()=>{
        if (!ref || !ref.current) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                setPercentVisible(entry === null || entry === void 0 ? void 0 : entry.intersectionRatio);
            });
        }, {
            threshold: threshold
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        threshold,
        mergedRef
    ]);
    (0, $fc4bM.useEffect)(()=>{
        // Initialize with current focus state
        // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        setWindowFocused(document.hasFocus());
        const onBlur = ()=>{
            setWindowFocused(false);
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            if (document.activeElement === ref.current) onIframeFocus && onIframeFocus();
        };
        const onFocus = ()=>{
            setWindowFocused(true);
        };
        window.addEventListener('blur', onBlur);
        window.addEventListener('focus', onFocus);
        return ()=>{
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, [
        ref,
        onIframeFocus
    ]);
    if (!url) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hF8nc.IframeDwellTracker), {
        isIframeLoaded: isIframeLoaded,
        isMouseOver: effectiveMouseOver,
        isWindowFocused: isWindowFocused,
        iframePercentVisible: percentVisible,
        onIframeDwell: onIframeDwell
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2KVKy.IFrame), {
        childRef: mergedRef,
        src: url,
        "data-testid": `${testId}-frame`,
        "data-test-iframe-loaded": isIframeLoaded,
        onMouseEnter: ()=>{
            onIframeMouseEnter === null || onIframeMouseEnter === void 0 || onIframeMouseEnter();
            // Use local state if prop not provided, otherwise prop takes precedence
            if (isMouseOverProp === undefined) setMouseOver(true);
        },
        onMouseLeave: ()=>{
            onIframeMouseLeave === null || onIframeMouseLeave === void 0 || onIframeMouseLeave();
            // Use local state if prop not provided, otherwise prop takes precedence
            if (isMouseOverProp === undefined) setMouseOver(false);
        },
        allowFullScreen: true,
        scrolling: "yes",
        allow: "autoplay; encrypted-media; clipboard-write",
        onLoad: ()=>{
            setIframeLoaded(true);
        },
        sandbox: (0, $3jqF1.getIframeSandboxAttribute)(isTrusted),
        title: title,
        extensionKey: extensionKey,
        className: (0, $2R2iS.default)([
            "_19itidpf _1reo15vq _18m915vq _2rkofajl _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _kqswh2mm"
        ])
    }));
});

});
parcelRegister("hF8nc", function(module, exports) {
$parcel$export(module.exports, "IframeDwellTracker", () => $018a2cb021f1bf8c$export$e3cb965901aecabd);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");
/**
 * A kind of cheap logarithmic backoff. Fire analytics after the user has
 * dwelled for 5 seconds, then 10 seconds, and so on.
 */ const $018a2cb021f1bf8c$var$INTERVALS_TO_LOG = [
    5,
    10,
    15,
    20,
    25,
    30,
    45,
    60,
    90,
    120,
    180
];
const $018a2cb021f1bf8c$export$e3cb965901aecabd = ({ isIframeLoaded: isIframeLoaded, isMouseOver: isMouseOver, iframePercentVisible: iframePercentVisible, onIframeDwell: onIframeDwell })=>{
    const [dwell, setDwell] = (0, $fc4bM.useState)({
        time: 0,
        percentVisible: 0
    });
    const dwellTimeoutId = (0, $fc4bM.useRef)();
    // fire analytics when the dwell timer reaches 5 seconds
    (0, $fc4bM.useEffect)(()=>{
        if (dwell.time > 0 && $018a2cb021f1bf8c$var$INTERVALS_TO_LOG.includes(dwell.time)) onIframeDwell && onIframeDwell(dwell.time, dwell.percentVisible);
    }, [
        dwell,
        onIframeDwell
    ]);
    // start and stop tracking dwell time
    (0, $fc4bM.useEffect)(()=>{
        const incrementDwellTime = ()=>{
            // callback is called on dwell state changes, so change percentVisible and time together
            setDwell(({ time: time })=>{
                return {
                    time: time + 1,
                    // snapshot of percent visible, rounded down to nearest 5%
                    percentVisible: Math.floor((iframePercentVisible || 0) * 20) * 5
                };
            });
        };
        // Require: iframe loaded, mouse over, and >75% visible.
        // Note: isWindowFocused is intentionally not required - it's unreliable and
        // prevents tracking. The mouse over check is sufficient to indicate user engagement.
        const shouldTrack = isIframeLoaded && isMouseOver && iframePercentVisible > 0.75;
        if (shouldTrack) {
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = setInterval(incrementDwellTime, 1000);
        } else if (dwellTimeoutId.current) {
            clearInterval(dwellTimeoutId.current);
            dwellTimeoutId.current = undefined;
        }
        return ()=>{
            if (dwellTimeoutId.current) clearInterval(dwellTimeoutId.current);
        };
    }, [
        setDwell,
        isMouseOver,
        isIframeLoaded,
        iframePercentVisible
    ]);
    return null;
};

});


parcelRegister("4UkG3", function(module, exports) {
$parcel$export(module.exports, "useEmbedResolvePostMessageListener", () => $8f9ed81252487e48$export$50ac35a9a8f2ebaa);

var $fc4bM = parcelRequire("fc4bM");

var $fypiH = parcelRequire("fypiH");
const $8f9ed81252487e48$export$50ac35a9a8f2ebaa = ({ url: url, embedIframeRef: embedIframeRef })=>{
    const resolve = (0, $fypiH.default)();
    (0, $fc4bM.useEffect)(()=>{
        const messageCallback = (event)=>{
            var _embedIframeRef$curre;
            if (typeof embedIframeRef === 'function') return;
            const isFromExpectedIframe = embedIframeRef && event.source === ((_embedIframeRef$curre = embedIframeRef.current) === null || _embedIframeRef$curre === void 0 ? void 0 : _embedIframeRef$curre.contentWindow);
            if (event.data === 'force-resolve-smart-link' && isFromExpectedIframe) resolve({
                url: url,
                isReloading: true
            });
        };
        window.addEventListener('message', messageCallback);
        return ()=>{
            window.removeEventListener('message', messageCallback);
        };
    }, [
        resolve,
        url,
        embedIframeRef
    ]);
};

});

parcelRegister("kpSmA", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = $9dnsd("kUBar").then(()=>parcelRequire('6ZMbk'));

});


parcelRegister("1PlSQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $8707667b85caf20c$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $5dzEI = parcelRequire("5dzEI");

var $fVrlX = parcelRequire("fVrlX");

var $ewFKq = parcelRequire("ewFKq");

var $8Rlkg = parcelRequire("8Rlkg");

var $kTxuC = parcelRequire("kTxuC");

var $deV6p = parcelRequire("deV6p");
const $8707667b85caf20c$var$UnauthorizedView = ({ context: context, extensionKey: extensionKey, isProductIntegrationSupported: isProductIntegrationSupported, onAuthorize: onAuthorize, testId: testId = 'embed-card-unauthorized-view', ...unresolvedViewProps })=>{
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const handleOnAuthorizeClick = (0, $fc4bM.useCallback)(()=>{
        if (onAuthorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorize();
        }
    }, [
        onAuthorize,
        fireEvent
    ]);
    const content = (0, $fc4bM.useMemo)(()=>{
        if (onAuthorize) {
            // Our title and button messages always expect the product name to be present
            // while the description support when product name is not present.
            // To be looked at https://product-fabric.atlassian.net/browse/EDM-8173
            const values = {
                context: (context === null || context === void 0 ? void 0 : context.text) ?? ''
            };
            if (values) // title: Connect your {context} account
            // button: Connect to {context}
            return {
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
                    ...(0, $ewFKq.messages).connect_link_account_card_name,
                    values: values
                }),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8Rlkg.default), {
                    providerName: context === null || context === void 0 ? void 0 : context.text,
                    isProductIntegrationSupported: isProductIntegrationSupported,
                    testId: testId
                }),
                button: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5dzEI.default), {
                    testId: "connect-account",
                    appearance: "primary",
                    onClick: handleOnAuthorizeClick
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
                    ...(0, $ewFKq.messages).connect_unauthorised_account_action,
                    values: values
                }))
            };
        }
        const values = context !== null && context !== void 0 && context.text ? {
            context: context === null || context === void 0 ? void 0 : context.text
        } : undefined;
        if (values) // title: We can't display private pages from {context}
        // description: You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
                ...(0, $ewFKq.messages).unauthorised_account_name,
                values: values
            }),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
                ...(0, $ewFKq.messages).unauthorised_account_description,
                values: values
            })
        };
        // title: We can't display private pages
        // description: You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner.
        return {
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).unauthorised_account_name_no_provider),
            description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).unauthorised_account_description_no_provider)
        };
    }, [
        context === null || context === void 0 ? void 0 : context.text,
        handleOnAuthorizeClick,
        isProductIntegrationSupported,
        onAuthorize,
        testId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kTxuC.default), {
        ...unresolvedViewProps,
        ...content,
        icon: context === null || context === void 0 ? void 0 : context.icon,
        providerIcon: context === null || context === void 0 ? void 0 : context.providerIcon,
        providerIconLabel: context === null || context === void 0 ? void 0 : context.providerIconLabel,
        image: (context === null || context === void 0 ? void 0 : context.image) ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $deV6p.UnauthorizedSVG), null),
        testId: testId,
        text: context === null || context === void 0 ? void 0 : context.text
    });
};
var $8707667b85caf20c$export$2e2bcd8739ae039 = $8707667b85caf20c$var$UnauthorizedView;

});
parcelRegister("deV6p", function(module, exports) {
$parcel$export(module.exports, "UnauthorizedSVG", () => $c2fb5df03142096d$export$6526edaac83a8c90);

var $fc4bM = parcelRequire("fc4bM");
const $c2fb5df03142096d$export$6526edaac83a8c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("svg", {
        viewBox: "0 0 565 267",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        height: "100%",
        width: "100%",
        preserveAspectRatio: "xMidYMid meet",
        "data-testid": "unauthorized-svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("g", {
        clipPath: "url(#clip0_1375_267)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        transform: "translate(0.870117 0.509766)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M150.05 257.529H143.87L144.52 254.379H150.7L150.05 257.529Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M181.06 257.531C183.03 257.531 185 257.531 186.97 257.531C186.92 256.481 186.88 255.431 186.83 254.381C185.02 253.691 182.85 253.301 181.08 254.271C181.02 254.301 180.96 254.341 180.9 254.381C180.95 255.431 181.01 256.481 181.06 257.531Z",
        fill: "#DFE1E5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M141.99 98.8398C110.62 98.8398 85.1801 124.27 85.1801 155.65V206.74C85.1801 238.11 59.7501 263.55 28.3701 263.55H0.870117",
        stroke: "url(#paint0_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M420.16 124.399L418.27 121.929L417.53 116.109L417.4 112.789H419.42L421.66 115.439C422.18 116.059 422.62 116.749 422.94 117.499C423.39 118.539 423.63 119.669 423.63 120.809V123.189L420.16 124.399Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M160.63 111.87L159.06 105.6C159.06 105.21 159.37 104.88 159.76 104.86C160.06 105.13 160.4 105.37 160.63 105.26C160.82 105.17 160.76 104.91 160.97 104.78C161.34 104.55 162.03 105.03 162.24 105.18C162.54 105.39 162.74 105.61 162.86 105.76L163.81 106.1C164.14 106.22 164.39 106.5 164.48 106.85L165.67 107.74C166.21 107.82 166.43 110 166.45 110.07L166.04 112.86C166.07 112.97 166.07 113.09 166.05 113.21C165.96 113.65 165.5 113.91 165.07 113.75L161.09 112.32C160.87 112.25 160.7 112.08 160.63 111.87Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M165.73 116.919C166.92 116.499 169.78 120.329 166.77 112.969C166.59 112.519 166.22 110.519 164.39 109.389C162.47 108.209 160.92 109.649 159.28 108.319C158.39 107.599 158.37 106.789 157.23 106.319C156.44 105.989 155.38 105.939 155.19 106.319C154.97 106.749 156.03 107.399 157.51 109.269C158.97 111.119 158.65 111.409 159.96 112.799C160.5 113.369 160.89 113.669 162.06 114.909C162.67 115.559 162.72 115.629 162.97 115.829C163.52 116.269 164.77 117.259 165.73 116.919Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M164.84 175.06C162.1 173.45 162.32 169.37 162.74 163.63C163.81 148.91 166.33 143.51 166.66 135.95C166.88 130.9 166.17 123.59 161.64 114.5C163.73 114.28 165.81 114.06 167.9 113.83C171.82 123.37 173.58 131.57 174.46 137.43C175.59 144.99 175.69 151.82 175.7 154.41C175.73 165.07 174.28 169.57 175.37 173.41C175.42 173.6 175.65 174.22 175.34 174.79C174.3 176.7 167.91 176.86 164.84 175.06Z",
        fill: "#403294"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        opacity: "0.25",
        d: "M2.76012 266.319H206.4C207.44 266.319 208.29 265.469 208.29 264.429C208.29 263.389 207.44 262.539 206.4 262.539H2.76012C1.72012 262.539 0.870117 263.389 0.870117 264.429C0.870117 265.469 1.72012 266.319 2.76012 266.319Z",
        fill: "url(#paint1_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        opacity: "0.25",
        d: "M562.86 266.319H359.22C358.18 266.319 357.33 265.469 357.33 264.429C357.33 263.389 358.18 262.539 359.22 262.539H562.86C563.9 262.539 564.75 263.389 564.75 264.429C564.75 265.469 563.9 266.319 562.86 266.319Z",
        fill: "url(#paint2_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M423.62 98.8398C454.99 98.8398 480.43 124.27 480.43 155.65V206.74C480.43 238.11 505.86 263.55 537.24 263.55H564.75",
        stroke: "url(#paint3_linear_1375_267)",
        strokeWidth: "4.4681",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M133.69 107.8C131.9 107.8 130.45 106.35 130.45 104.56V93.1502C130.45 91.3602 131.9 89.9102 133.69 89.9102C135.48 89.9102 136.93 91.3602 136.93 93.1502V104.57C136.92 106.35 135.48 107.8 133.69 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M140.16 107.8C138.37 107.8 136.92 106.35 136.92 104.56V93.1502C136.92 91.3602 138.37 89.9102 140.16 89.9102C141.95 89.9102 143.4 91.3602 143.4 93.1502V104.57C143.4 106.35 141.95 107.8 140.16 107.8Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M425.01 107.8C423.22 107.8 421.77 106.35 421.77 104.56V93.1502C421.77 91.3602 423.22 89.9102 425.01 89.9102C426.8 89.9102 428.25 91.3602 428.25 93.1502V104.57C428.25 106.35 426.8 107.8 425.01 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M431.48 107.8C429.69 107.8 428.24 106.35 428.24 104.56V93.1502C428.24 91.3602 429.69 89.9102 431.48 89.9102C433.27 89.9102 434.72 91.3602 434.72 93.1502V104.57C434.72 106.35 433.27 107.8 431.48 107.8Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        opacity: "0.38",
        d: "M285 195.54C338.307 195.54 381.52 152.327 381.52 99.02C381.52 45.7135 338.307 2.5 285 2.5C231.694 2.5 188.48 45.7135 188.48 99.02C188.48 152.327 231.694 195.54 285 195.54Z",
        fill: "url(#paint4_radial_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M346.07 140.879H381.57C404.79 140.879 423.62 122.059 423.62 98.8293C423.62 75.6093 404.8 56.7793 381.57 56.7793H346.07V140.879Z",
        fill: "url(#paint5_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M237.09 123.26H276.41V116.82H237.09V123.26Z",
        fill: "url(#paint6_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M237.09 78.2291H276.41V71.7891H237.09V78.2291Z",
        fill: "url(#paint7_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M325.86 146.589H340.11C343.4 146.589 346.07 143.919 346.07 140.629V57.4092C346.07 54.1192 343.4 51.4492 340.11 51.4492H325.86V146.589Z",
        fill: "url(#paint8_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M219.54 140.879H184.04C160.82 140.879 141.99 122.059 141.99 98.8293C141.99 75.6093 160.81 56.7793 184.04 56.7793H219.54V140.879Z",
        fill: "url(#paint9_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M239.76 146.589H225.51C222.22 146.589 219.55 143.919 219.55 140.629V57.4092C219.55 54.1192 222.22 51.4492 225.51 51.4492H239.76V146.589Z",
        fill: "url(#paint10_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M379.21 146.581C378.91 146.001 378.4 145.181 377.56 144.401C376.28 143.221 374.91 142.761 374.18 142.581C374 142.441 373.77 142.281 373.48 142.131C373.23 142.001 372.97 141.901 372.7 141.831L370.63 141.251C370.29 141.161 370.07 140.831 370.11 140.481C370.15 140.091 370.51 139.801 370.9 139.851L379.42 140.801C380.47 140.921 381.46 140.291 381.79 139.291L382.01 138.651C382.14 138.281 382.5 138.041 382.9 138.091C383.31 138.141 383.62 138.471 383.64 138.871L383.72 140.251C383.86 142.671 383.35 145.091 382.26 147.251L379.21 146.581Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M428.29 185.99C429.39 188.07 430.46 190.28 431.47 192.61C435.75 202.44 437.91 211.78 438.95 219.77C440.03 222.59 441.07 225.54 442.05 228.64C444.86 237.5 446.64 245.84 447.75 253.4C446.13 253.87 444.51 254.34 442.88 254.81C441.2 250.25 438.53 243.08 435.09 234.23C430.76 223.08 428.59 217.5 428.5 217.3C422.43 203.22 419.13 199.32 420.72 193.98C421.29 192.14 422.84 188.93 428.29 185.99Z",
        fill: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M412.72 189.539C409.67 199.159 406.62 208.789 403.57 218.409C400.84 230.159 398.1 241.909 395.37 253.659C398.3 254.449 397.22 254.159 400.15 254.939C403.08 247.829 405.94 240.299 408.66 232.359C410.04 228.319 411.33 224.339 412.52 220.439C414.74 216.039 417.2 213.029 419.05 211.089C423.68 206.239 427.59 204.829 430.28 199.479C432.31 195.449 431.64 193.159 431.46 192.609C431.32 192.189 430.95 191.419 430.21 189.889C429.46 188.319 428.81 187.039 428.38 186.189C426.55 186.889 424.48 187.559 422.18 188.119C418.67 188.989 415.46 189.379 412.72 189.539Z",
        fill: "url(#paint11_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M396.28 246.85C396.21 248.32 395.94 250.38 395.01 252.65C394.37 254.22 392.97 257.51 389.49 259.78C387.45 261.11 385.46 261.59 384.18 261.79C384.26 262.22 384.24 262.13 384.32 262.57C386.73 262.62 391.82 262.66 394.24 262.71C394.59 261.89 395.4 261.57 395.92 261.8C396.41 262.03 396.5 262.7 396.5 262.75C397.32 262.68 398.14 262.61 398.96 262.54C399.23 261.52 399.51 260.49 399.8 259.45C401 255.15 402.31 251.02 403.69 247.08C401.21 247.01 398.74 246.93 396.28 246.85Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M440.03 247.221C440.92 249.251 441.84 252.641 441.92 253.771C442.06 255.691 442.18 257.271 441.21 258.681C440.55 259.641 439.65 260.141 438.15 260.971C436.98 261.621 435.94 262.021 435.21 262.261C435.3 262.651 435.28 262.571 435.37 262.961C437.57 262.901 439.76 262.831 441.96 262.771C442.52 262.751 443.09 262.731 443.65 262.711C443.66 262.661 443.77 262.191 444.22 261.991C444.67 261.791 445.08 262.031 445.17 262.081C445.49 262.261 445.62 262.541 445.67 262.651C446.19 262.691 446.78 262.721 447.42 262.691C448.09 262.671 448.7 262.601 449.24 262.521C449.09 261.461 448.94 260.401 448.78 259.341C448.69 258.741 448.53 257.681 448.29 256.131C447.73 252.481 447 247.951 446.83 246.881C444.56 247.001 442.29 247.111 440.03 247.221Z",
        fill: "#344563"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M404.04 166.88C412.13 163.96 417.86 161.43 418.22 161.14C418.55 160.87 418.88 160.59 418.88 160.59C418.98 160.51 419.08 160.42 419.19 160.32C421.82 157.99 427.78 151.82 427.76 142.35C427.73 131.65 420.19 125.19 419.11 124.29C420.82 123.5 422.52 122.71 424.23 121.92C426.36 123.97 432.76 130.64 433.79 141.01C434.72 150.27 430.85 157.43 429.11 160.66C427.36 163.91 425.44 166.35 424.02 167.97C423.92 170.1 424 172.75 424.56 175.73C425.49 180.68 427.37 184.49 428.86 186.96C423.1 188.75 417.33 190.54 411.57 192.33C413.04 189.13 412.78 187.11 412.25 185.86C411.07 183.05 407.94 182.53 406.78 179.13C406.31 177.76 406.36 176.51 406.46 175.69C404.27 175.89 395.01 176.46 386.94 170C375.33 160.7 377 145.5 377.12 144.57C379.19 145.06 381.27 145.55 383.34 146.04C383.04 147.74 383.3 152.66 384.35 155.65C387.27 163.99 396.59 169.11 404.04 166.88Z",
        fill: "url(#paint12_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M406.52 152.01C406.67 152.06 406.9 152.11 407.25 152.17C408.21 152.33 408.84 152.57 409.24 152.86C410.29 153.59 409.6 155.01 410.51 157.07C410.6 157.28 410.88 157.87 411.03 158.72C411.1 159.15 411.12 159.47 411.12 159.54C411.15 160.21 411.58 161.58 413.11 164.55C412.78 164.46 412.46 164.37 412.13 164.28C411.17 163.91 410.2 163.54 409.24 163.17C407.16 161.78 406.7 161.57 406.7 160.58C406.69 159.4 406.68 157.33 406.62 157.25C405.95 156.6 405.08 156.48 405.74 155.68C406.12 155.23 406.41 154.9 406.51 154.81C406.82 154.53 407.04 153.83 406.52 152.01Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M409.17 152.81C408.97 155.53 409.02 159.86 410.76 164.7C410.8 164.82 410.85 164.95 410.9 165.07C412.74 169.95 418.57 172.14 423.04 169.45C423.19 169.36 423.35 169.26 423.5 169.16C423.53 169.14 423.55 169.12 423.58 169.11C426.31 167.24 426.68 163.37 424.47 160.91C422.98 159.26 422 157.68 421.33 156.36C419.26 152.28 419.55 149.41 416.8 147.81C414.71 146.59 412.02 146.79 411.13 146.85C409.41 146.98 408.61 147.42 408.23 147.7C407.34 148.37 406.86 149.14 406.64 149.56C406.11 150.55 405.98 151.47 405.94 152C406.33 152.02 406.78 152.08 407.26 152.18C408.02 152.34 408.67 152.58 409.17 152.81Z",
        fill: "#172B4D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M298 24.3503L293.82 0.940321C293.72 0.390321 292.95 0.360321 292.8 0.890321L286.8 21.9503L281.93 20.5603C281.56 20.4503 281.2 20.7703 281.27 21.1503L285.45 44.5603C285.55 45.1103 286.32 45.1403 286.47 44.6103L292.47 23.5503L297.34 24.9403C297.71 25.0603 298.07 24.7303 298 24.3503Z",
        fill: "url(#paint13_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M271.23 34.4501L262.63 26.2801C262.45 26.1101 262.17 26.3001 262.26 26.5301L266.06 36.7401L263.69 37.6201C263.53 37.6801 263.49 37.8801 263.61 38.0001L272.21 46.1701C272.39 46.3401 272.67 46.1501 272.58 45.9201L268.78 35.7101L271.15 34.8301C271.31 34.7801 271.35 34.5701 271.23 34.4501Z",
        fill: "url(#paint14_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M252.19 156.739L248.63 180.259C248.55 180.809 249.26 181.089 249.58 180.639L262.02 162.619L266.18 165.499C266.5 165.719 266.94 165.529 266.99 165.149L270.55 141.629C270.63 141.079 269.92 140.799 269.6 141.249L257.16 159.269L253 156.389C252.69 156.169 252.25 156.359 252.19 156.739Z",
        fill: "url(#paint15_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M280.79 160.989L286.31 171.489C286.42 171.709 286.75 171.619 286.74 171.379L286.42 160.489L288.95 160.409C289.12 160.399 289.23 160.219 289.15 160.069L283.63 149.569C283.52 149.349 283.19 149.439 283.2 149.679L283.52 160.569L280.99 160.639C280.82 160.659 280.71 160.839 280.79 160.989Z",
        fill: "url(#paint16_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M210.22 142.149L210.26 142.049C210.88 140.389 211.84 138.869 213.09 137.609L213.57 137.119C213.8 136.879 214.17 136.829 214.46 136.989C214.83 137.199 214.96 137.679 214.73 138.039L214.35 138.639C213.96 139.259 214.44 140.049 215.17 139.989L216.22 139.909C216.41 139.889 216.6 139.889 216.79 139.889H220.09V140.009C220.09 140.589 219.94 141.149 219.65 141.649L219.85 142.479L212.52 144.559L210.22 142.149Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M167.89 212.219C170.43 201.299 170.03 198.249 168.95 195.809C167.16 191.769 163.58 189.559 161.36 188.459C160.58 189.839 159.49 191.959 158.49 194.659C156.66 199.589 156.32 203.239 155.63 207.859C155.11 211.319 154.24 216.299 152.75 222.379C150.92 226.479 149.08 231.349 147.55 236.919C145.75 243.459 144.81 249.419 144.33 254.469C146.45 254.469 148.58 254.469 150.71 254.459C152.73 251.619 154.81 248.339 156.78 244.619C160.42 237.759 162.67 231.309 164.11 225.929C164.85 223.589 165.87 220.159 166.97 215.949C167.26 214.829 167.56 213.629 167.89 212.219Z",
        fill: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M176.58 191.57C179.52 198.15 181.75 203.76 183.34 207.95C186.95 217.46 187.57 220.51 187.81 221.82C188.78 227.05 188.69 231 188.5 237.33C188.37 241.83 187.97 247.87 186.83 255C184.86 255.11 182.88 255.22 180.91 255.33C179.04 250.46 177.13 243.9 176.47 235.99C176.11 231.71 176.19 227.83 176.47 224.47C173.58 221.68 170.54 218.48 167.48 214.83C165.05 211.93 162.9 209.11 161 206.41C161 206.41 156.64 199.14 158.38 195.02C158.38 195.01 158.39 194.99 158.4 194.98C158.89 193.79 159.33 192.79 159.55 192.3C160.25 190.75 160.84 189.5 161.25 188.66C163.04 189.3 165.07 189.9 167.32 190.4C170.78 191.17 173.92 191.48 176.58 191.57Z",
        fill: "url(#paint17_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M172.03 148.42C171.56 148.18 171.05 147.95 170.5 147.72C169.91 147.47 169.34 147.26 168.81 147.09C168.59 146.7 167.07 144.07 163.95 143.52C163.46 143.44 161.77 143.16 160.05 144.06C157.21 145.55 156.37 149.16 156.64 151.67C156.74 152.59 156.91 154.28 158.16 155.58C159.93 157.42 162.29 156.85 162.98 158.45C163.55 159.76 162.18 160.72 162.73 161.65C163.73 163.34 169.99 163.03 171.08 160.08C171.23 159.68 171.48 158.71 170.76 157.19C171.68 155.93 172.61 154.67 173.53 153.42C173.3 152.89 172.96 152.24 172.45 151.55C171.97 150.91 171.49 150.41 171.07 150.05C171.23 149.86 171.41 149.63 171.58 149.35C171.79 149 171.93 148.68 172.03 148.42Z",
        fill: "#A27F68"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M163.94 151.95C163.79 150.89 164.25 150.56 163.88 149.91C163.46 149.16 162.68 149.28 162.15 148.38C161.99 148.12 161.68 147.58 161.84 147.09C162.25 145.82 165.44 146.23 165.81 145C165.91 144.65 165.76 144.29 165.61 144.04C165.08 143.65 164.2 143.12 163.02 142.93C160.36 142.5 157.52 144.01 156.11 146.43C154.47 149.25 155.11 152.73 156.74 154.54C157.37 155.24 158.63 156.65 160.4 156.92C160.96 157.01 161.84 157.02 162.34 157.67C162.73 158.17 162.66 158.75 162.98 158.84C163.06 158.86 163.36 158.91 164.01 158.08C164.71 157.19 165.56 156.12 165.39 154.83C165.22 153.5 164.16 153.48 163.94 151.95Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M171.78 160.529C178.49 163.269 181.57 171.049 181.57 176.839C181.57 180.219 180.53 183.109 179.64 185.569C178.42 188.949 177.51 190.789 176 192.699C171.74 198.069 159.59 197.749 157.75 193.939C157.36 193.139 157.51 192.349 157.55 192.109C159.83 178.359 156.81 163.059 163.89 159.849C166.86 158.499 170.07 159.829 171.78 160.529Z",
        fill: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M213.33 144.43C213.47 144.59 213.62 144.74 213.76 144.9C209.95 149.37 203.65 155.67 194.36 160.95C183.21 167.29 172.8 169.3 166.51 170.01C164.79 168.3 162.68 165.68 163.29 163.25C163.79 161.24 166.05 159.77 176.29 157.08C180.37 156.01 185.85 154.7 192.45 153.53C198.37 149.36 204.3 145.18 210.22 141.01C210.23 141.02 210.23 141.02 210.24 141.03L213.33 144.43Z",
        fill: "url(#paint18_linear_1375_267)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M416.51 117.27L420.41 121.18L421.77 118.83L417.41 116.13C417.1 115.94 416.71 116 416.47 116.27C416.23 116.56 416.24 117 416.51 117.27Z",
        fill: "#D4B696"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M185.75 257.109C185.75 257.119 185.76 257.129 185.77 257.139C185.88 257.189 186.19 256.219 186.63 256.019C187.47 255.639 188.86 258.159 191.32 259.779C192.43 260.509 193.53 260.909 194.4 261.129C194.73 261.209 194.96 261.509 194.96 261.849V262.549H180.01C179.98 261.659 180.04 260.509 180.34 259.209C180.53 258.409 180.77 257.699 181.02 257.119H185.75V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M180.08 259.818C181.72 259.818 183.05 261.138 183.09 262.768C182.06 262.768 181.03 262.768 180 262.768V259.818C180.03 259.828 180.06 259.818 180.08 259.818Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M148.77 257.109C148.77 257.119 148.78 257.129 148.79 257.139C148.9 257.189 149.21 256.219 149.65 256.019C150.49 255.639 151.88 258.159 154.34 259.779C155.45 260.509 156.55 260.909 157.42 261.129C157.75 261.209 157.98 261.509 157.98 261.849V262.549H143.03C143 261.659 143.06 260.509 143.36 259.209C143.55 258.409 143.79 257.699 144.04 257.119H148.77V257.109Z",
        fill: "#42526E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("path", {
        d: "M143.11 259.818C144.75 259.818 146.08 261.138 146.12 262.768C145.09 262.768 144.06 262.768 143.03 262.768V259.818C143.05 259.828 143.08 259.818 143.11 259.818Z",
        fill: "#B3BAC5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint0_linear_1375_267",
        x1: "141.994",
        y1: "181.192",
        x2: "0.870117",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#C1C7D0",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint1_linear_1375_267",
        x1: "208.292",
        y1: "264.428",
        x2: "0.870117",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint2_linear_1375_267",
        x1: "357.327",
        y1: "264.428",
        x2: "564.748",
        y2: "264.428",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#091E42"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.8433",
        stopColor: "#091E42",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint3_linear_1375_267",
        x1: "423.624",
        y1: "181.192",
        x2: "564.748",
        y2: "181.192",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.1724",
        stopColor: "#076AFF",
        stopOpacity: "0.8007"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.4145",
        stopColor: "#1976FF",
        stopOpacity: "0.5208"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.6966",
        stopColor: "#378BFF",
        stopOpacity: "0.1947"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.8651",
        stopColor: "#4C9AFF",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("radialGradient", {
        id: "paint4_radial_1375_267",
        cx: "0",
        cy: "0",
        r: "1",
        gradientUnits: "userSpaceOnUse",
        gradientTransform: "translate(285 99.0229) scale(96.5182)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.1584",
        stopColor: "#FFE587",
        stopOpacity: "0.8416"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.3589",
        stopColor: "#FFDA57",
        stopOpacity: "0.6411"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.5498",
        stopColor: "#FFD031",
        stopOpacity: "0.4502"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.7256",
        stopColor: "#FFC916",
        stopOpacity: "0.2744"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.8811",
        stopColor: "#FFC506",
        stopOpacity: "0.1189"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400",
        stopOpacity: "0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint5_linear_1375_267",
        x1: "346.074",
        y1: "98.8386",
        x2: "423.624",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint6_linear_1375_267",
        x1: "237.087",
        y1: "120.044",
        x2: "276.412",
        y2: "120.044",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint7_linear_1375_267",
        x1: "237.087",
        y1: "75.0106",
        x2: "276.412",
        y2: "75.0106",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#DFE1E5"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint8_linear_1375_267",
        x1: "335.969",
        y1: "146.593",
        x2: "335.969",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#B2D4FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint9_linear_1375_267",
        x1: "219.544",
        y1: "98.8386",
        x2: "141.994",
        y2: "98.8386",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#7A869A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#EBECF0"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint10_linear_1375_267",
        x1: "229.65",
        y1: "146.593",
        x2: "229.65",
        y2: "51.4514",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#F4F5F7"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint11_linear_1375_267",
        x1: "402.858",
        y1: "216.64",
        x2: "421.684",
        y2: "223.492",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#4C9AFF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.8134",
        stopColor: "#0065FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.8713",
        stopColor: "#0065FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint12_linear_1375_267",
        x1: "376.968",
        y1: "157.139",
        x2: "433.936",
        y2: "157.139",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#B2D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint13_linear_1375_267",
        x1: "289.638",
        y1: "45.0027",
        x2: "289.638",
        y2: "0.510323",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#FFF0B2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#FFC400"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint14_linear_1375_267",
        x1: "262.238",
        y1: "36.2259",
        x2: "272.592",
        y2: "36.2259",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint15_linear_1375_267",
        x1: "259.6",
        y1: "180.859",
        x2: "259.6",
        y2: "141.017",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint16_linear_1375_267",
        x1: "284.971",
        y1: "171.613",
        x2: "284.971",
        y2: "149.45",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#FFC400"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#FFF0B2"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint17_linear_1375_267",
        x1: "157.982",
        y1: "221.995",
        x2: "188.627",
        y2: "221.995",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "0.3435",
        stopColor: "#6554C0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#998DD9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("linearGradient", {
        id: "paint18_linear_1375_267",
        x1: "163.185",
        y1: "155.517",
        x2: "213.758",
        y2: "155.517",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        stopColor: "#5243AA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("stop", {
        offset: "1",
        stopColor: "#8777D9"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("clipPath", {
        id: "clip0_1375_267"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("rect", {
        width: "563.88",
        height: "265.81",
        fill: "white",
        transform: "translate(0.870117 0.509766)"
    }))));

});



parcelRegister("jQkCW", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $2f111aea8347569a$export$aff6291803939b05);

var $fc4bM = parcelRequire("fc4bM");

var $jEubQ = parcelRequire("jEubQ");

var $kzNPc = parcelRequire("kzNPc");

var $d7r8x = parcelRequire("d7r8x");

var $j9rqA = parcelRequire("j9rqA");

var $hiN0m = parcelRequire("hiN0m");

var $khTy5 = parcelRequire("khTy5");

var $96gGh = parcelRequire("96gGh");

var $dnVHi = parcelRequire("dnVHi");

var $azBNw = parcelRequire("azBNw");

var $6VGqw = parcelRequire("6VGqw");

var $ihokJ = parcelRequire("ihokJ");

var $8pvh1 = parcelRequire("8pvh1");

var $fpOz2 = parcelRequire("fpOz2");

var $8BNRF = parcelRequire("8BNRF");
const $2f111aea8347569a$var$UFOLoadHoldWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: "smart-card-inline-card"
    }), children);
const $2f111aea8347569a$export$aff6291803939b05 = ({ id: id, url: url, cardState: cardState, handleAuthorize: handleAuthorize, handleFrameClick: handleFrameClick, handleFrameAuxClick: handleFrameAuxClick, handleFrameContextMenu: handleFrameContextMenu, isSelected: isSelected, isHovered: isHovered, renderers: renderers, onResolve: onResolve, onError: onError, testId: testId, inlinePreloaderStyle: inlinePreloaderStyle, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeTextHighlightingFromTitle: removeTextHighlightingFromTitle, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline, hideIconLoadingSkeleton: hideIconLoadingSkeleton })=>{
    var _details$meta2;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { status: status, details: details } = cardState;
    const extensionKey = (0, $96gGh.getExtensionKey)(details);
    const testIdWithStatus = testId ? `${testId}-${status}-view` : undefined;
    const resolvedProps = status === (0, $j9rqA.SmartLinkStatus).Resolved ? (0, $khTy5.extractInlineProps)(details, renderers, removeTextHighlightingFromTitle, false) : {};
    (0, $fc4bM.useEffect)(()=>{
        var _details$meta;
        switch(status){
            case (0, $j9rqA.SmartLinkStatus).Resolved:
                onResolve === null || onResolve === void 0 || onResolve({
                    url: url,
                    title: resolvedProps.title,
                    extensionKey: details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key
                });
                break;
            case (0, $j9rqA.SmartLinkStatus).Errored:
            case (0, $j9rqA.SmartLinkStatus).Fallback:
            case (0, $j9rqA.SmartLinkStatus).Forbidden:
            case (0, $j9rqA.SmartLinkStatus).NotFound:
            case (0, $j9rqA.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        url,
        resolvedProps.title,
        details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key
    ]);
    switch(status){
        case 'pending':
        case 'resolving':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($2f111aea8347569a$var$UFOLoadHoldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fpOz2.InlineCardResolvingView), {
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus,
                inlinePreloaderStyle: inlinePreloaderStyle,
                resolvingPlaceholder: resolvingPlaceholder,
                truncateInline: truncateInline
            }));
        case 'resolved':
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8pvh1.InlineCardResolvedView), {
                ...resolvedProps,
                id: id,
                showHoverPreview: showHoverPreview,
                hoverPreviewOptions: hoverPreviewOptions,
                actionOptions: actionOptions,
                link: url,
                isSelected: isSelected,
                isHovered: isHovered,
                onClick: handleFrameClick,
                // Support middle-/right-clicks for "resolved" only — the vast majority of clicks happen here.
                // Other states (e.g. "resolving") could be added later for completeness.
                onAuxClick: handleFrameAuxClick,
                onContextMenu: handleFrameContextMenu,
                testId: testIdWithStatus,
                truncateInline: truncateInline,
                hideIconLoadingSkeleton: hideIconLoadingSkeleton
            });
        case 'unauthorized':
            const provider = (0, $kzNPc.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8BNRF.InlineCardUnauthorizedView), {
                icon: provider && provider.icon,
                context: provider && provider.text,
                url: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                showHoverPreview: showHoverPreview,
                id: id,
                extensionKey: extensionKey,
                truncateInline: truncateInline
            });
        case 'forbidden':
            const providerForbidden = (0, $kzNPc.extractSmartLinkProvider)(details);
            const cardMetadata = (details === null || details === void 0 ? void 0 : details.meta) ?? (0, $dnVHi.getForbiddenJsonLd)().meta;
            const requestAccessContext = (0, $hiN0m.extractRequestAccessContextImproved)({
                jsonLd: cardMetadata,
                url: url,
                product: (providerForbidden === null || providerForbidden === void 0 ? void 0 : providerForbidden.text) ?? '',
                createAnalyticsEvent: createAnalyticsEvent
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $ihokJ.InlineCardForbiddenView), {
                url: url,
                icon: providerForbidden && providerForbidden.icon,
                context: providerForbidden === null || providerForbidden === void 0 ? void 0 : providerForbidden.text,
                isSelected: isSelected,
                onClick: handleFrameClick,
                onAuthorise: handleAuthorize,
                testId: testIdWithStatus,
                requestAccessContext: requestAccessContext,
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'not_found':
            const providerNotFound = (0, $kzNPc.extractSmartLinkProvider)(details);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6VGqw.InlineCardErroredView), {
                url: url,
                icon: providerNotFound && providerNotFound.icon,
                isSelected: isSelected,
                message: "Can't find link",
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-not-found-view',
                showHoverPreview: showHoverPreview,
                truncateInline: truncateInline
            });
        case 'fallback':
        case 'errored':
        default:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $azBNw.CardLinkView), {
                link: url,
                isSelected: isSelected,
                onClick: handleFrameClick,
                testId: testIdWithStatus || 'inline-card-errored-view',
                truncateInline: truncateInline,
                viewType: "errored"
            });
    }
};

});
parcelRegister("6VGqw", function(module, exports) {
$parcel$export(module.exports, "InlineCardErroredView", () => $4a839a7941a16986$export$8ae570c871cdb179);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $gDsF8 = parcelRequire("gDsF8");

var $ewFKq = parcelRequire("ewFKq");

var $jjsJ4 = parcelRequire("jjsJ4");

var $9eSWL = parcelRequire("9eSWL");

var $5RUL3 = parcelRequire("5RUL3");

var $apOJG = parcelRequire("apOJG");
const $4a839a7941a16986$var$fallbackIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error",
        testId: "errored-view-default-icon"
    });
};
const $4a839a7941a16986$export$8ae570c871cdb179 = ({ url: url, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-errored-view', icon: icon, message: message, onRetry: onRetry, truncateInline: truncateInline, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    const hashAction = !!onRetry;
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((event)=>{
        if (onRetry) {
            event.preventDefault();
            event.stopPropagation();
            onRetry();
        }
    }, [
        onRetry
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        return onRetry && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9eSWL.ActionButton), {
            onClick: handleRetry
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).try_again));
    }, [
        handleRetry,
        onRetry
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5RUL3.Frame), {
        link: hashAction ? undefined : url,
        onClick: hashAction ? undefined : onClick,
        isSelected: isSelected,
        ref: frameRef,
        testId: testId,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $apOJG.IconAndTitleLayout), {
        icon: icon || $4a839a7941a16986$var$fallbackIcon(),
        link: hashAction ? url : undefined,
        title: url,
        onClick: hashAction ? onClick : undefined,
        rightSide: message
    }), renderActionButton());
    if (showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jjsJ4.HoverCard), {
        url: url
    }, content);
    return content;
};

});

parcelRegister("ihokJ", function(module, exports) {
$parcel$export(module.exports, "InlineCardForbiddenView", () => $3eb3b842e49a0a36$export$ebd227d2573ed3d8);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $jTWWA = parcelRequire("jTWWA");

var $EawnW = parcelRequire("EawnW");

var $ewFKq = parcelRequire("ewFKq");

var $jjsJ4 = parcelRequire("jjsJ4");

var $9eSWL = parcelRequire("9eSWL");

var $23U23 = parcelRequire("23U23");

var $5RUL3 = parcelRequire("5RUL3");

var $apOJG = parcelRequire("apOJG");
const $3eb3b842e49a0a36$var$styles = {
    actionButtonLozengeStyle: "_2rkolb4i _bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _p12f1osq"
};
const $3eb3b842e49a0a36$var$fallbackForbiddenIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jTWWA))), {
        label: "error",
        color: "var(--ds-icon-danger, #C9372C)",
        testId: "forbidden-view-fallback-icon"
    });
};
const $3eb3b842e49a0a36$export$ebd227d2573ed3d8 = ({ url: url, icon: icon, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-forbidden-view', truncateInline: truncateInline, requestAccessContext: requestAccessContext, onAuthorise: onAuthorise, context: context, showHoverPreview: showHoverPreview })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    const [hasRequestAccessContextMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(!!(requestAccessContext !== null && requestAccessContext !== void 0 && requestAccessContext.callToActionMessageKey));
    const handleRetry = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) onAuthorise();
        else {
            var _requestAccessContext;
            requestAccessContext === null || requestAccessContext === void 0 || (_requestAccessContext = requestAccessContext.action) === null || _requestAccessContext === void 0 || _requestAccessContext.promise();
        }
    }, [
        onAuthorise,
        requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.action
    ]);
    const renderForbiddenAccessMessage = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        if (requestAccessContext !== null && requestAccessContext !== void 0 && requestAccessContext.callToActionMessageKey) {
            const { callToActionMessageKey: callToActionMessageKey } = requestAccessContext;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
                ...(0, $ewFKq.messages)[callToActionMessageKey],
                values: {
                    product: context
                }
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).invalid_permissions, (formattedMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, formattedMessage));
    }, [
        context,
        requestAccessContext
    ]);
    const renderActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>{
        const accessType = requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.accessType;
        if (hasRequestAccessContextMessage) {
            const isDisabled = accessType === 'PENDING_REQUEST_EXISTS';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9eSWL.ActionButton), {
                isDisabled: isDisabled,
                onClick: handleRetry,
                testId: "button-connect-other-account"
            }, renderForbiddenAccessMessage());
        }
        if (onAuthorise) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $EawnW.Pressable), {
            xcss: $3eb3b842e49a0a36$var$styles.actionButtonLozengeStyle,
            onClick: handleRetry,
            style: {
                font: `inherit`
            },
            testId: "button-connect-other-account"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $23U23.default), {
            appearance: "moved",
            isBold: true
        }, renderForbiddenAccessMessage()));
        return null;
    }, [
        handleRetry,
        hasRequestAccessContextMessage,
        onAuthorise,
        renderForbiddenAccessMessage,
        requestAccessContext === null || requestAccessContext === void 0 ? void 0 : requestAccessContext.accessType
    ]);
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5RUL3.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $apOJG.IconAndTitleLayout), {
        icon: icon ? icon : $3eb3b842e49a0a36$var$fallbackForbiddenIcon(),
        link: url,
        title: url,
        onClick: onClick,
        titleColor: "var(--ds-text-subtle, #505258)"
    }), renderActionButton());
    if (showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jjsJ4.HoverCard), {
        url: url
    }, content);
    return content;
};

});

parcelRegister("fpOz2", function(module, exports) {
$parcel$export(module.exports, "InlineCardResolvingView", () => $d7665db0108a5ea3$export$98531adac42f053e);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");

var $hculA = parcelRequire("hculA");

var $5RUL3 = parcelRequire("5RUL3");

var $apOJG = parcelRequire("apOJG");

var $6XX6p = parcelRequire("6XX6p");
const $d7665db0108a5ea3$var$styles = {
    spinnerWrapper: "_11c8wadc _1e0c116y _4cvr1h6o _1bah1h6o _4t3i7vkz _1bsb7vkz"
};
const $d7665db0108a5ea3$export$98531adac42f053e = ({ url: url, onClick: onClick, isSelected: isSelected, inlinePreloaderStyle: inlinePreloaderStyle, testId: testId = 'inline-card-resolving-view', titleTextColor: titleTextColor, resolvingPlaceholder: resolvingPlaceholder, truncateInline: truncateInline })=>{
    const renderSpinner = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
            as: "span",
            xcss: $d7665db0108a5ea3$var$styles.spinnerWrapper
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hculA.default), {
            size: 14,
            interactionName: "smart-card-inline-card-spinner"
        })), []);
    if (inlinePreloaderStyle === 'on-right-without-skeleton') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5RUL3.Frame), {
        withoutBackground: true,
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $apOJG.IconTitleWrapper), null, url, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6XX6p.RightIconPositionWrapper), null, renderSpinner())));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5RUL3.Frame), {
        testId: testId,
        onClick: onClick,
        isSelected: isSelected,
        link: url,
        truncateInline: truncateInline
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $apOJG.IconAndTitleLayout), {
        icon: renderSpinner(),
        title: resolvingPlaceholder ?? url,
        titleTextColor: titleTextColor
    }));
};

});
parcelRegister("6XX6p", function(module, exports) {
$parcel$export(module.exports, "RightIconPositionWrapper", () => $8b3311fbef994aaf$export$91b164375b8037b5);
/* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ /* styled.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-styled */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");
const $8b3311fbef994aaf$export$91b164375b8037b5 = /*#__PURE__*/ (0, $fc4bM.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $fc4bM.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $2R2iS.default)([
            "_18u0v77o _kqswh2mm _1e0c1o8l",
            __cmplp.className
        ])
    });
});

});


parcelRegister("8BNRF", function(module, exports) {
$parcel$export(module.exports, "InlineCardUnauthorizedView", () => $f6691577a7bb6836$export$ece47728c0503997);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $4Cnkn = parcelRequire("4Cnkn");

var $jTWWA = parcelRequire("jTWWA");

var $bcN2K = parcelRequire("bcN2K");

var $dRkX9 = parcelRequire("dRkX9");

var $dBtOK = parcelRequire("dBtOK");

var $EawnW = parcelRequire("EawnW");

var $fVrlX = parcelRequire("fVrlX");

var $ewFKq = parcelRequire("ewFKq");

var $hWPme = parcelRequire("hWPme");

var $jjsJ4 = parcelRequire("jjsJ4");

var $9eSWL = parcelRequire("9eSWL");

var $5RUL3 = parcelRequire("5RUL3");

var $apOJG = parcelRequire("apOJG");
const $f6691577a7bb6836$var$fallbackUnauthorizedIcon = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jTWWA))), {
        color: "var(--ds-icon-danger, #C9372C)",
        label: "error"
    });
};
/**
 * When persisted personalization adoption from {@link getCachedProviderPctMapAndRefresh} is strictly below this value,
 * the pill uses exploratory "previewing" copy instead of a percentage headline.
 */ const $f6691577a7bb6836$var$SOCIAL_PROOF_TEAM_PREVIEW_THRESHOLD = 30;
const $f6691577a7bb6836$var$SOCIAL_PROOF_TRAIT_NAME = 'sl_3p_connected_providers_site_pct';
// useSyncExternalStore provides hydration snapshots without live cache updates.
const $f6691577a7bb6836$var$noopSubscribe = ()=>()=>{};
const $f6691577a7bb6836$var$socialProofPillStyles = {
    strong: "_k48pwu06",
    root: "_2rko12b0 _1e0c1nu9 _4cvr1h6o _vchhusvi _p12f1osq _bfhk1dpa _syazazsu _y3gn18uv _1wybtjj4 _s7n4t94y _ca0qv77o _n3tdv77o _u5f312x7 _19bv12x7 _2hwx1b66 _irr3plhp _1di61gdz",
    label: "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
    wrappingLabel: "_1reoewfl _18m9ewfl _1btozryt _o5721btx _1nmz9jpi",
    button: "_bfhk1j28 _u5f3ze3t _19bvze3t _ca0qze3t _n3tdze3t",
    pressableContents: "_1e0c1bgi",
    inlineGroup: "_1e0c1nu9"
};
const $f6691577a7bb6836$var$ConnectButtonLabel = ({ context: context, isUpdateCtaEnabled: isUpdateCtaEnabled, showSocialProofPill: showSocialProofPill })=>{
    if (isUpdateCtaEnabled) return showSocialProofPill || !(context !== null && context !== void 0 && context.trim()) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).connect_inline_to_update) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...(0, $ewFKq.messages).connect_inline_provider_to_update,
        values: {
            context: context
        }
    });
    return showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).connect_inline_social_proof) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...(0, $ewFKq.messages).connect_link_account_card_name,
        values: {
            context: context
        }
    });
};
/**
 * Renders the social-proof pill and Connect button using persisted percentages only ({@link getCachedProviderPctMapAndRefresh}) — no
 * loading skeleton; either the cached percentage is shown or the legacy long connect label is used.
 * Only mounted when the card has an authorisation action.
 */ const $f6691577a7bb6836$var$UnauthorisedConnectWithSocialProof = ({ context: context, extensionKey: extensionKey, isUpdateCtaEnabled: isUpdateCtaEnabled, testId: testId, onConnectClick: onConnectClick })=>{
    const cachedProviderPctMap = (0, $hWPme.getCachedProviderPctMapAndRefresh)($f6691577a7bb6836$var$SOCIAL_PROOF_TRAIT_NAME);
    const canUseCachedProviderPctMap = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useSyncExternalStore($f6691577a7bb6836$var$noopSubscribe, ()=>true, ()=>!(0, $dRkX9.fg)('platform_sl_inline_social_proof_hydration_fix'));
    const providerPctMap = canUseCachedProviderPctMap ? cachedProviderPctMap : null;
    // Will be false if this is the first render, when we fetch traits and store to local storage,
    // or if there wasn't our trait for it.
    const isProviderPctMapLoaded = providerPctMap !== null;
    // Percent of current user team (same tenant users) who are connected to this extension.
    const connectedPct = extensionKey && isProviderPctMapLoaded ? providerPctMap[extensionKey] : undefined;
    const trimmedProviderDisplayName = (context === null || context === void 0 ? void 0 : context.trim()) ?? '';
    const hasProviderDisplayName = trimmedProviderDisplayName.length > 0;
    const isSocialProofUsageHighEnough = connectedPct !== undefined && connectedPct >= $f6691577a7bb6836$var$SOCIAL_PROOF_TEAM_PREVIEW_THRESHOLD;
    // Show the social proof pill once the trait data is available.
    const showSocialProofPill = isProviderPctMapLoaded;
    const bold = (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
            as: "strong",
            xcss: $f6691577a7bb6836$var$socialProofPillStyles.strong
        }, chunks);
    // As long as pill is shown it will be one of four messages depending on percent and provider presence:
    // - 45% of your team sees Figma previews
    // - 45% of your team sees richer previews
    // - Your team sees richer Figma previews
    // - Your team sees richer previews
    const socialProofPillContent = isSocialProofUsageHighEnough ? hasProviderDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...(0, $ewFKq.messages).social_proof_inline_cta_tag_high_with_context,
        values: {
            connectedPct: connectedPct,
            context: trimmedProviderDisplayName,
            b: bold
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...(0, $ewFKq.messages).social_proof_inline_cta_tag_high_no_context,
        values: {
            connectedPct: connectedPct,
            b: bold
        }
    }) : hasProviderDisplayName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...(0, $ewFKq.messages).social_proof_inline_cta_tag_low_with_context,
        values: {
            context: trimmedProviderDisplayName
        }
    }) : // Unlikely case, but possible from TS standpoint.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).social_proof_inline_cta_tag_low_no_context);
    const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        xcss: $f6691577a7bb6836$var$socialProofPillStyles.root,
        testId: `${testId}-social-proof-tag`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        xcss: (0, $4Cnkn.cx)($f6691577a7bb6836$var$socialProofPillStyles.label, $f6691577a7bb6836$var$socialProofPillStyles.wrappingLabel)
    }, socialProofPillContent)) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $9eSWL.ActionButton), {
        onClick: onConnectClick,
        viewType: "unauthorised",
        testId: "button-connect-account",
        isSlimDesign: showSocialProofPill
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($f6691577a7bb6836$var$ConnectButtonLabel, {
        context: context,
        isUpdateCtaEnabled: isUpdateCtaEnabled,
        showSocialProofPill: showSocialProofPill
    })));
    return showSocialProofPill ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $EawnW.Pressable), {
        onClick: onConnectClick,
        style: {
            font: `inherit`
        },
        xcss: (0, $4Cnkn.cx)($f6691577a7bb6836$var$socialProofPillStyles.button, $f6691577a7bb6836$var$socialProofPillStyles.pressableContents)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        xcss: $f6691577a7bb6836$var$socialProofPillStyles.inlineGroup
    }, buttonContent)) : buttonContent;
};
const $f6691577a7bb6836$export$ece47728c0503997 = ({ url: url, id: id, icon: icon, onAuthorise: onAuthorise, onClick: onClick, isSelected: isSelected, testId: testId = 'inline-card-unauthorized-view', showHoverPreview: showHoverPreview = false, truncateInline: truncateInline, context: context, extensionKey: extensionKey })=>{
    const frameRef = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(null);
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const isUpdateCtaEnabled = Boolean(onAuthorise) && (0, $dRkX9.fg)('platform_sl_3p_preauth_update_cta_fg') && (0, $bcN2K.isExperimentEnabled)('platform_sl_3p_preauth_update_cta_exp');
    const handleConnectAccount = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        if (onAuthorise) {
            fireEvent('track.applicationAccount.authStarted', {});
            onAuthorise();
        }
    }, [
        fireEvent,
        onAuthorise
    ]);
    const inlineCardUnauthenticatedView = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5RUL3.Frame), {
        testId: testId,
        isSelected: isSelected,
        ref: frameRef,
        truncateInline: truncateInline,
        viewType: "unauthorised"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $apOJG.IconAndTitleLayout), {
        icon: icon ? icon : $f6691577a7bb6836$var$fallbackUnauthorizedIcon(),
        title: url,
        link: url,
        onClick: onClick,
        titleColor: "var(--ds-text-subtle, #505258)"
    }), onAuthorise && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($f6691577a7bb6836$var$UnauthorisedConnectWithSocialProof, {
        context: context,
        extensionKey: extensionKey,
        isUpdateCtaEnabled: isUpdateCtaEnabled,
        testId: testId,
        onConnectClick: handleConnectAccount
    }));
    if (onAuthorise && showHoverPreview) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jjsJ4.HoverCard), {
        url: url,
        id: id
    }, inlineCardUnauthenticatedView);
    return inlineCardUnauthenticatedView;
};

});
parcelRegister("hWPme", function(module, exports) {
$parcel$export(module.exports, "getCachedProviderPctMapAndRefresh", () => $d9ce6e492076f450$export$63f5703c889fdfe6);

var $gTn0u = parcelRequire("gTn0u");

var $jpZmV = parcelRequire("jpZmV");

var $48cNn = parcelRequire("48cNn");

var $3hJbp = parcelRequire("3hJbp");
function $d9ce6e492076f450$export$63f5703c889fdfe6(traitName) {
    const cloudId = (0, $jpZmV.getCurrentSiteCloudIdSync)();
    const providerPctMap = (0, $3hJbp.getProviderPctMapSync)(cloudId, traitName);
    (0, $gTn0u.getCurrentSiteCloudId)().then((resolvedCloudId)=>{
        (0, $48cNn.getProviderPctMap)(resolvedCloudId, traitName);
    });
    return providerPctMap;
}

});



parcelRegister("Xfogc", function(module, exports) {
$parcel$export(module.exports, "default", () => $2a9d6c6361091851$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $lwoVF = parcelRequire("lwoVF");

var $1gjag = parcelRequire("1gjag");

var $8yWCk = parcelRequire("8yWCk");
const $2a9d6c6361091851$var$withCardIntersectionObserver = (Component)=>(props)=>{
        // TODO: NAVX-4682: Add feature parity to LazyIntersectionObserverCard for no lazy loading
        const { appearance: appearance, children: children, id: id, onError: onErrorCallback, ui: ui, url: url = '' } = props;
        const { onIntersecting: onIntersecting, onStatusSettled: onStatusSettled } = (0, $1gjag.useSmartLinkSeenEvent)({
            appearance: appearance,
            children: children,
            id: id,
            ui: ui,
            url: url
        });
        const onError = (0, $fc4bM.useCallback)((data)=>{
            if (data !== null && data !== void 0 && data.status) onStatusSettled(data.status);
            onErrorCallback === null || onErrorCallback === void 0 || onErrorCallback(data);
        }, [
            onStatusSettled,
            onErrorCallback
        ]);
        const ref = (0, $lwoVF.default)({
            onIntersecting: onIntersecting
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8yWCk.default), {
            appearance: props.appearance,
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Component, {
            ...props,
            onError: onError
        }));
    };
var $2a9d6c6361091851$export$2e2bcd8739ae039 = $2a9d6c6361091851$var$withCardIntersectionObserver;

});

parcelRegister("c6cgh", function(module, exports) {
$parcel$export(module.exports, "default", () => $4801af09654c6bb5$export$2e2bcd8739ae039);

var $fnEFU = parcelRequire("fnEFU");

var $dRkX9 = parcelRequire("dRkX9");

var $96gGh = parcelRequire("96gGh");

var $b9KAt = parcelRequire("b9KAt");
const $4801af09654c6bb5$var$useExperimentMetaEventAttributes = ({ appearance: appearance, state: state })=>{
    const { connections: { client: { baseUrlOverride: baseUriWithNoTrailingSlash } } } = (0, $fnEFU.useSmartLinkContext)();
    const { details: details, status: status } = state;
    const extensionKey = (0, $96gGh.getExtensionKey)(details);
    const blockSocialProofExperimentMeta = appearance === 'block' && status === 'unauthorized' && (0, $dRkX9.fg)('social-proof-3p-unauth-block-fg') ? (0, $b9KAt.getSocialProofExperimentMeta)({
        extensionKey: extensionKey,
        baseUriWithNoTrailingSlash: baseUriWithNoTrailingSlash
    }) : undefined;
    const experimentMeta = {
        ...blockSocialProofExperimentMeta
    };
    if (Object.keys(experimentMeta).length > 0) return experimentMeta;
};
var $4801af09654c6bb5$export$2e2bcd8739ae039 = $4801af09654c6bb5$var$useExperimentMetaEventAttributes;

});



//# sourceMappingURL=shared.4c860625.js.map
